export const locale = {
  general_menu_settings: 'تنظیمات عمومی منو',
  settings: { 
    business_type_title: 'نوع کاربری منو را انتخاب کنید',
    currency_label: 'واحد پول',
    show_filter: 'نمایش فیلتر محصولات',
    show_categories: 'نمایش دسته‌بندی محصولات',
    
    business_types: {
      cafe: 'کافه',
      restaurant: 'رستوران',
      fastfood: 'فست‌فود',
      icecream: 'آبمیوه و بستنی',
      sweets: 'شیرینی و دسر',
      bakery: 'نانوایی'
    },
    
    custom_labels: {
          ph_menu_cafe: 'منوی کافه',
    ph_menu_restaurant: 'منوی غذا',
    ph_menu_fastfood: 'منوی فست‌فود',
    ph_menu_icecream: 'آبمیوه و بستنی',
    ph_menu_sweets: 'کیک و شیرینی',
    ph_menu_bakery: 'انواع نان و محصولات',
    ph_product_list: 'محصولات', // برای حالت پیش‌فرض / فروشگاهی
    ph_add_order: 'افزودن',
    ph_add_cart: 'خرید',

      title: 'شخصی‌سازی عبارات (اختیاری)',
      subtitle: 'کلمات دلخواه خود را جایگزین مقادیر پیش‌فرض سیستم کنید.',
      products_title: 'عنوان بخش محصولات',
      ph_food_menu: 'منوی غذا',
      ph_product_list: 'لیست محصولات',
      cart_btn: 'متن دکمه خرید',
      ph_add_order: 'افزودن به سفارش',
      ph_add_cart: 'افزودن به سبد خرید'
    },

    currencies: {
      toman: 'تومان',
      rial: 'ریال'
    }
  },
check_account_balance_and_try_again: 'لطفاً موجودی حساب خود را بررسی کرده و دوباره تلاش کنید',
problem_with_qr_renewal_request: 'در درخواست تمدید کد QR مشکلی پیش آمد',

  ERRORS: {
    PhoneIsNotValid: "شماره تلفن وارد شده صحیح نمیباشد: نمونه 09101234567",
    InvalidNumber: "تعداد وارد شده صحیح نمیباشد",
    NoSelectedLineNumber: "خط ارسالی را انتخاب کنید.",
    EmptyText: "لطفا متن را وارد کنید.",
    UnknownError: "خطای نامشخص",
    TryAgain: "لطفا کمی بعد دباره تلاش کنید.",
    NoAccountCharge: "موجودی ناکافی",
    NoAccess: "دسترسی ندارید.",
    PleasebyeAPlane: "لطفا یک پلن خریداری کنید.",
    PleaseChargeYourAccount: "لطفا اکانت خود را شارژ کنید.",
    AccessDenied: "دسترسی ندارید.",
    AccessDeniedDescription: "برای اطلاعات بیشتر با پشتیبانی تماس بگیرید",
    Error: "خطا",
    InvalidText: "متن نامعتبر",
    InvalidTextContainsLink: "تنها خطوط خدماتی میتوانند حاوی لینک باشند.",
    NoPhoneToSend: "هیچ شماره ای برای ارسال وجود ندارد .",
  },
  FORMS: {
    SuccsessFullySended: "متوجه شدم",
    DestinationPhone: "شماره تلفن گیرنده",
    TestDestinationPhone: "شماره تلفن تست",
    SourceNumber: "شماره فرستنده",
    Text: "متن",
    CharCount: "تعداد کاراکترها",
    FarsiCharCount: "تعداد کاراکترهای فارسی",
    EnglishCharCount: "تعداد کاراکتر های انگلیسی",
    Send: "ارسال",
    SendTime: "زمان ارسال",
    SendTest: "ارسال تستی",
    SendToTestNumber: "ارسال به شماره تست",
    SmsCount: "تعداد پیامک",
    SmsLang: "زبان پیامک",
    Add: "اضافه کردن",
    FromFile: "افزودن فایل",
    TestNumber: "شماره تست",
    Test: "تست",
    ServiceRelated: "خدماتی",
    Price: "هزینه ارسال وایت",
    TotalPrice: "جمع کل هزینه",
    NumbersCount: "تعداد کل شماره ها",
    BlacklistPrice: "هزینه ارسال بلک",
    BlacklistNumbersCount: "تعداد بلک لیست",
    WhitelistNumbersCount: "تعداد وایت لیست",
    IrancellNumbersBlacklistCount: "تعداد شماره های بلک لیست ایرانسل",
    HamrahavalNumbersBlacklistCount: "تعداد شماره های بلک لیست همراه اول",
    IrancellNumbersWhitelistCount: "تعداد شماره های وایت لیست ایرانسل",
    HamrahavalNumbersWhitelistCount: "تعداد شماره های وایت لیست همراه اول",
    NumbersCountToSend: "تعداد شماره های صحیح",
    Search: "جستجو",
    Title: "عنوان",
    RequestTime: "زمان درخواست",
    RequestInformation: "اطلاعات درخواست",
    CreateNewPhoneBook: "ساخت دفترچه تلفن جدید",
    AddPhone: "افزودن شماره ها",
    Remove: "حذف",
  },
  unexpected_error: "یک خطای غیرمنتظره رخ داد. لطفاً دوباره تلاش کنید.",
  luck_wheel_name: "نام کیوآر چرخ گردون",
  off: "تخفیف",
  update_video: "افزودن گالری ویدئو",
  edit: "ویرایش",
  to_top: "از بالا",
  to_bottom: "از پایین",
  to_left: "از راست به چپ",
  to_right: "از چپ به راست",
  to_top_right: "از پایین به راست",
  to_top_left: "از پایین به چپ",
  to_bottom_right: "از بالا به راست",
  to_bottom_left: "از بالا به چپ",
  select_color_gradient: "انتخاب رنگ گرادینت",
  select_color_solid: "انتخاب رنگ ساده",
  gradient_direction: "جهت گرادینت",
  gradient_background: "پس‌زمینه گرادینت",
  qr_downloaded_successfully: "کیوآر با موفقیت دانلود شد.",
  logo: "لوگو",
  qr_design_size: "طرح و سایز کیوآر",
  qr_eye_design: "طرح چشم کیوآر",
  qr_markout: "حاشیه خروجی",
  frame: "فریم",
  ready_card_samples: "نمونه کارت ویزیت های آماده",
  ready_card_sample: "نمونه کارت ویزیت آماده",
  remove_default_info: "حذف اطلاعات پیش‌فرض",
  select_ready_card: "انتخاب کارت ویزیت آماده",
  connection_code: "کد اتصال",
  enter_visit_card_info: "وارد کردن اطلاعات کارت ویزیت",
  "enter_visit_card_pro_info": "نام کارت ویزیت پرو را وارد کنید",
  info: "اطلاعات",
  select_template_design: "انتخاب طرح قالب",
  qr_address: "آدرس کیوآر",
  visit_card_name: "نام کارت ویزیت شما",
  visit_card_name_pro: "نام کارت ویزیت پرو شما",
  download_qr: "دانلود کیوآر",
  fast_design: "دیزاین سریع",
  professional_design: "دیزاین حرفه ای",
  ai_design: "دیزاین هوش مصنوعی",
  update_qr: "بروزرسانی کیوآر",
  fast_design_message:
    "شما به دیزاین کد سریع انتقال پیدا کردید. دیزاین قبلی را در این بخش انجام دادید.",
  professional_design_message:
    "شما به دیزاین کد حرفه‌ای انتقال پیدا کردید. دیزاین قبلی را در این بخش انجام دادید.",
  scan_me: "اسکن کن",
  visit_card_edited_successfully: "کیوآر شما با موفقیت ویرایش شد.",
  customer_club_membership: "عضویت در باشگاه مشتریان",
  qrland: "کیوآر لند",
  dynamic: "داینامیک",
  about_us_text:
    "ویژگی های کیوار کد داینامیک:\n✔️ویرایش نامحدود\n✔️اسکن اسان\n✔️امکان محدودیت اسکن\n✔️امکان افزودن رمز\n✔️مشاهده و بررسی آمار بازدیدکنندگان\n✔️تغییر رنگ‌ظاهرکیوار\n✔️حفظ اطلاعات و امنیت\n✔️امکان افزودن تصویر و لوگو به کیوارکد\n✔️امکان افزودن کیوار تخصصی باتوجه به نیازکسب و کار\n✔️انتقال اسکن کننده به لینک ها و سایت\n✔️ارائه همزمان کیوار و لینک کوتاه\n✔️قابل استفاده در کلیه شبکه های اجتماعی(آفلاین و آنلاین)\n✔️قابل دانلود با پسوند دلخواه\n✔️قابل چاپ به روی هر نوع سطح و یا ابعادی",
  video_gallery: "گالری ویدئو",
  address_text:
    "تهران، خیابان شریعتی ، بعد از پل سید خندان، بن بست خندان ، پلاک 6 ",
  visit_card: "کارت ویزیت",
  qrland_system: "سامانه کیوآر لند",
  qrland_first_system: "اولین سامانه ساخت کیوآر کد داینامیک",
  address: "آدرس",
  enter_site_link: "لینک سایت مورد نظر را وارد نمایید",
  instagram: "اینستاگرام",

  enter_instagram_username: "نام کاربری خود را وارد نمایید",
  whatsapp: "واتساپ",
  invalid_qr_address: "آدرس وارد شده صحیح نمی‌باشد!",
  visit_card_created_successfully: "کیوآر شما با موفقیت ساخته شد.",
  qr_creation_failed: "ساخت کیوآر با خطا روبرو شد!",
  manage_password: "مدیریت رمز عبور",
  hour_limit: "محدودیت زمان",
  scan_click_limit: "محدودیت تعداد اسکن/کلیک",
  redirect_scanner: "انتقال اسکن کننده",
  edit_settings_error: "خطایی در ویرایش تنظیمات رخ داده است!",
  next: "بعدی",
  add: "افزودن",
  header_color_settings: "تنظیمات رنگ و متن سربرگ",
  select_image: "انتخاب عکس",
  enter_qr_address: "آدرس کیوآر خود را وارد نمایید",
  qr_idea_title: "ایده ساخت کیو آر",
  qr_idea: "ایده کیوآر",
  qr_idea_subject: "موضوع ساخت کیو آر",
  confirm_qr_idea: "تایید ایده کیو آر من",
  scannable: "قابل اسکن است",
  ai_sample: "نمونه ای از ساخت هوش مصنوعی...",
  scan_warning:
    "ممکن است در کلیه دستگاه‌ها اسکن نشود. در صورت عدم اسکن مجدد تلاش کنید.",
  ai_description:
    "شرح کیوآر مورد نظر خودرا وارد نمایید، تا هوش مصنوعی آن را برای شما خلق کند.",
  attach: "الصاق",
  qr_creation: "ساخت کیوآر",
  free: "رایگان",
  select_language_for_request: "انتخاب زبان برای نوشتن متن درخواست",
  request_text: "متن درخواست",
  request_text_placeholder: "کیوآر لینک مورد نظر خودرا شرح دهید...",
  strengthen_text: "تقویت متن موجود",
  prompt_idea: "ایده پرامپت",
  try_again: "تلاش مجدد",
  create_qr: "ساخت کیوآر",
  smart_qr_code: "کیوآر کد هوشمند",
  regenerate_image: "ساخت مجدد تصویر",
  updating_qr: "در حال به‌روزرسانی QR...",
  copied: "کپی شد",
  copy: "کپی",
  print_qr: "پرینت کیوآر",
  print_visit_card: "چاپ کارت ویزیت",
  send_link: "ارسال لینک",
  customer_list: "لیست مشتریان",
  order_list: "لیست سفارشات",
  reserved_appointments: "نوبت‌های رزرو شده",
  feedback: "بازخورد",
  request_form: "فرم درخواست",
  transfer_ownership: "انتقال مالکیت",
  select_nfc_card: "انتخاب کارت NFC",
  created_at: "ایجاد شده",
  last_edit: "آخرین ویرایش",
  qr_card: "کارت کیوآر",
  viewed: "دیده شده",
  see_more: "مشاهده بیشتر",
  download: "دانلود",
  activate: "فعال کردن",
  design: "دیزاین",
  qr_settings: "تنظیمات کیوآر",
  deactivate: "متوقف کردن",
  qr_color_size: "رنگ و سایز کیوآر",
  dots_design_color: "طرح و رنگ نقطه‌ها",
  eye_design_color: "طرح و رنگ چشم",
  border_design_color: "طرح و رنگ حاشیه",
  logo_settings: "تنظیمات لوگو",
  download_qr_comment: "دانلود کیوآر",
  connection_established: "اتصال برقرار شد.",
  show_qr: "نمایش کیوآر",
  preview: "پیش نمایش",
  user_info: "اطلاعات کاربری",
  sms_club_membership: "عضویت در باشگاه مشتریان",
  smart_settings: "تنظیمات هوشمند",
  add_audio_file: "افزودن فایل صوتی",
  back: "بازگشت",
  after_click_location: "پس از کلیک بر روی لوکیشن مسیریاب خودرا انتخاب کنید.",
  phone_number: "شماره تلفن",
  auto_display: "نمایش خودکار",
  customer_club: "باشگاه مشتریان",
  auto_download: "دانلود خودکار",
  save: "ذخیره",
  about_us: "درباره ما",
  view_more: "مشاهده بیشتر",
  view_less: "مشاهده کمتر",
  audio_file: "فایل صوتی",
  add_video: "افزودن ویدئو",
  add_image: "افزودن تصویر",
  select_color: "انتخاب رنگ",
  header_color: "متن سربرگ",
  add_social_networks: "افزودن شبکه های اجتماعی",
  format: "فرمت",
  output_size: "سایز خروجی",
  file_type: "نوع فایل",
  default: "پیشفرض",
  qr_download_error: "بارگیری کیوآر با مشکل مواجه شد. مجدد تلاش کنید",
  header_color_text_settings: "تنظیمات رنگ و متن سربرگ",
  upload_catalog_images: "آپلود تصاویر کاتالوگ / بروشور",
  delete: "حذف",
  personal_domain: "دامنه شخصی",
  no_domain_found: "دامنه ای یافت نشد!",
  enter_domain_address: "لطفا آدرس دامنه خود را وارد نمایید",
  dns_setup_note:
    "در نظر داشته باشید ابتدا میبایست DNS های سرور را تنظیم نمایید!",
  attention: "توجه: ",
  dns_setup_instruction: "برای ثبت دامنه شخصی ابتدا DNS های",
  and: "و",
  setup_on_domain: "بر روی دامنه خود تنظیم نمایید.",
  dns_change_time: "(زمان تغییر DNS حداکثر تا 24 ساعت)",
  add_domain: "افزودن دامنه",
  add_personal_domain: "افزودن دامنه شخصی",
  min_characters: "حداقل تعداد کارکتر ورودی",
  domain_format:
    "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
  invalid_domain: "دامنه وارد شده صحیح نمی باشد!",
  domain_added_successfully: "دامنه شما با موفقیت افزوده شد",
  invalid_dns_settings: "تنظیمات DNS صحیح نمی باشد!",
  deleted_successfully: "با موفقیت حذف شد",
  location: "لوکیشن",
  save_contact: "ذخیره مخاطب",
  search: "جستجو",
  data_fetch_error: "خطا در دریافت داده‌ها!",
  error: "خطا",
  view_qr: "مشاهده QR",
  qr_design: "دیزاین کیوآر",
  register: "ثبت",
  terminal_ads: "ترمینال تبلیغات",
  manage_40_advertising_methods: "مدیریت همزمان ۴۰ روش تبلیغاتی!",
  ms_khansari: "خانم خوانساری",
  support: "پشتیبانی",
  comprehensive_advertising_system:
    "تنها سامانه جامع بررسی و مدیریت تبلیغات آنلاین",
  terminal_ads_description:
    "سامانه ترمینال تبلیغات مفتخر است تا از رهگذر ارتباط مداوم و تاثیرگذار با مشتریان و مخاطبان خود از نیازهای آنها آگاه گردیده و بهترین راهکارها را در اختیارشان قرار دهد. سامانه ترمینال تبلیغات بزرگترین و مهمترین سرمایه خود را مشتریان و کاربران وفادار می داند و در درجه دوم تیم متخصص و کارآمد که با ایده های جدید و فناوری های نوین شرکت را یاری می کنند.",
  please_enter_qr_address_correctly: "لطفا آدرس کیوآر را به درستی وارد نمایید!",
  server_error: "خطای سرور!",
  please_enter_your_address: " لطفا آدرس آدرس خودرا وارد کنید ",
  please_enter_instagram_address: " لطفا آدرس اینستاگرام خودرا وارد کنید ",
  please_enter_whatsapp_address: " لطفا آدرس واتساپ خودرا وارد کنید ",
  enter_information: "ورود اطلاعات",
  dynamic_qr: " کیوآر داینامیک باشد",
  coming_soon: "بزودی",
  qr_name: "نام کیوآر",
  for_default_address_leave_empty: "!برای استفاده از آدرس پیشفرض، خالی بگذارید",
  default_address: "آدرس پیشفرض",
  sms: "پیامک",
  enter_number_without_zero: "شماره موردنظر خودرا بدون 0 وارد کنید.",
  number: "شماره ",
  country_code: "پیش شماره کشور:",
  sms_text: "متن پیامک",
  complete_sms_fields_correctly: "فیلد های پیامک را به درستی تکمیل نمایید!",
  qr_code_created_successfully: "کد کیوآر شما با موفقیت ساخته شد.",
  chat: "چت",
  call: "تماس",
  please_enter_username: "لطفا نام کاربری خود را وارد کنید.",
  username: "نام کاربری ",
  sample_menu: "نمونه منو",
  online_menu_name: "نام منو آنلاین شما",
  online_menu_name_short: "نام منو آنلاین",
  enter_menu_information: "وارد کردن اطلاعات منو",
  select_sample_menu: "انتخاب نمونه منو",
  select_ready_menu: "انتخاب منو آماده",
  online_sales: "فروش آنلاین",
  sales_settings: "تنظیمات فروش",
  photo_gallery: "گالری عکس",
  fast_food1: "فست فود1",
  fast_food2: "فست فود2",
  products: "محصولات",
  pizzas: "پیتزاها",
  pizza_rust_beef: "پیتزا رست بیف",
  italian_pizza_with_beef: "🤩پیتزا ایتالیایی با گوشت گوساله",
  italian_pizza_dough_30cm: "خمیر پیتزا ایتالیایی ۳۰ سانتی متری",
  "100g_shredded_beef": "۱۰۰ گرم گوشت گوساله ریش ریش شده",
  mushroom_bell_pepper: " قارچ، فلفل دلمه ای",
  black_olives: "زیتون سیاه",
  pizza_chicken_mushroom: "پیتزا مرغ و قارچ",
  classic_40cm: "🍕کلاسیک 40 سانتی متری",
  fresh_tomato_sauce:
    "سس گوجه فرنگی تازه پیتزارا،\n پنیر (مطهر)، \nفیله مرغ، \nقارچ،\n آویشن کوهی",
  pizza_meat_mushroom: "پیتزا گوشت وقارچ",
  meat_pizza_with_mushroom: "🥰 پیتزا گوشت چرخ کرده با قارچ",
  pizza_vegetables: "پیتزا سبزیجات",
  american_vegetable_pizza: "🍕 پیتزا سبزیجات آمریکایی",
  american_pizza_dough:
    "خمیر پیتزا آمریکایی،\n ذرت،\n قارچ،\n زیتون،\n گوجه،\n پیاز،\n فلفل، \nپنیر پیتزا",
  special_pizza: "پیتزا مخصوص",
  american_special_pizza: "پیتزا مخصوص آمریکایی",
  pizza_bolognese: "پیتزا بولنیز",
  one_person_23cm: "(یک نفره)خمیر پیتزا 23 سانت متری 🤌",
  pepperoni_pizza: "پیتزاپپرونی ",
  one_person_23cm_dough: "(یک نفره) خمیر پیتزا23 سانتی متری ",
  bacon_pizza: "پیتزا بیکن ",
  one_person_23cm_explosion: "(یک نفره)خمیر پیتزای 23 سانتی 💥",
  mixed_pizza: "پیتزا مخلوط ",
  one_person_23cm_mixed: "(یک نفره) خمیرپیتزا 23 سانتی 🤭",
  american_steak_pizza: "پیتزا استیک آمریکایی",
  one_person_23cm_steak: "(یک نفره) 23 سانتی متری 💥",
  burgers: "همبرگر ها",
  cheese_burger: "چیز برگر",
  with_french_fries: "🤩همراه با سیب زمینی سرخ شده",
  "2_beef_burgers_150g": "۲ عدد برگر گوشت گوساله ۱۵۰ گرمی",
  special_sauce_gouda_cheese: "سس مخصوص، پنیر گودا",
  pickles_lettuce_tomato: "خیارشور، کاهو، گوجه",
  special_sauce: "سس مخصوص",
  burger: "همبرگر",
  pure_meat_with_special_sauce: "😍گوشت خالص همراه سس مخصوص",
  chicken_burger: "چیکن برگر",
  grilled_chicken_burger_with_cheese: "گریل چیکن برگر با پنیر",
  spicy_burger: "اسپایس برگر",
  beef_with_spicy_sauce: "گوشت گوساله همرا سس اسپایسی",
  double_burger: "دوبل برگر",
  "150g_beef": "گوشت گوساله 150 گرمی",
  royal_burger: "رویال برگر",
  "150g_beef_emoji": "150 گرم گوشت گوساله 🍔",
  mushroom_burger: "قارچ برگر",
  "150g_beef_mushroom": "گوشت گوساله 150 گرمی ",
  mushroom_burger_grilled: "ماشروم برگر",
  "100_percent_grilled_beef": "گوشت گوساله گریل شده 100%🤩",
  fried_burger: "برگر سوخاری ",
  "100_percent_grilled_fried": "گوشت گوساله گریل شده سوخاری 100%👌",
  fried: "سوخاری ",
  fried_chicken: "مرغ سوخاری",
  "3_piece_fried_chicken": "😍مرغ سوخاری سه تیکه ",
  "3_fried_chicken_pieces": "۳ عدد مرغ سوخاری",
  "120_150g_french_fries": "۱۲۰ تا ۱۵۰ گرم سیب زمینی سرخ کرده",
  enter_product_information: "وارد کردن اطلاعات محصول",
  product_name: "نام محصول شما",
  product_name_short: "نام محصول",
  complete_features_from_image: "تکمیل ویژگی‌ها از روی تصویر محصول",
  skip_step: "رد کردن مرحله",
  product_and_information: "اطلاعات و محصول",
  product_introduction: "معرفی محصول",
  shiva_waves: "شیوا امواج",
  think_best: "به بهترین ها فکر کنید...",
  iran_zanjan_abhar: "ایران ،زنجان،ابهر،شهرک صنعتی شریف ، جنب پست برق 63/20",
  video_gallery_description: "از ویدئوهای مجموع ما دیدن فرمایید.",
  gallery: "گالری",
  welcome: "خوش آمدگویی",
  invalid_address: "آدرس وارد شده صحیح نمی‌باشد!",
  product_created_successfully: "محصول شما با موفقیت ساخته شد.",
  qr_visit_card_edited_successfully: "کیوآر شما باموفقیت ویرایش شد.",
  change_header_color: "تغییر رنگ هدر",
  change_body_color: "تغییر رنگ بدنه",
  change_button_colors: "تغییر رنگ دکمه ها",
  change_text_colors: "تغییر رنگ متن ها",
  gradient_colors: "رنگ‌های گرادینتی",
  color_direction: "جهت رنگ",
  first_color: "رنگ اول",
  second_color: "رنگ دوم",
  color: "رنگ",
  text_color: "رنگ متن",
  from_top: "از بالا",
  from_bottom: "از پایین",
  from_left_to_right: "از چپ به راست",
  from_right_to_left: "از راست به چپ",
  from_top_to_left: "از بالا به چپ",
  from_top_to_right: "از بالا به راست",
  from_bottom_to_left: "از پایین به چپ",
  from_bottom_to_right: "از پایین به راست",
  sharing: "اشتراک گذاری",
  business_shop: "بیزینس / فروشگاه",
  corporate_organizational: "شرکتی / سازمانی",
  customer_contact: "ارتباط با مشتری",
  information: "اطلاع رسانی",
  miscellaneous: "متفرقه",
  link: "لینک",
  margin: "حاشیه",
  width: "عرض",
  height: "ارتفاع",
  background_color: "رنگ پس زمینه",
  gradient_color: "رنگ گرادینت",
  linear: "خطی",
  radial: "دایره ای",
  color_rotation: "چرخش رنگ",
  background_color_label: "رنگ پس زمینه",
  dots_color: "رنگ نقطه ها",
  dots_color_label: "رنگ نقطه ها",
  eye_colors: "رنگ چشم‌ها",
  separate_colors_for_each_eye: "رنگ‌های جداگانه برای هر چشم",
  current_mode: "حالت فعلی:",
  separate_colors: "رنگ‌های جداگانه",
  same_color: "رنگ یکسان",
  all_eyes_color: "رنگ همه چشم‌ها",
  top_right_eye: "چشم بالا راست",
  top_left_eye: "چشم بالا چپ",
  bottom_left_eye: "چشم پایین چپ",
  upload_logo: "آپلود لوگو",
  hide_background_dots: "پنهان کردن نقطه های پشت لوگو",
  logo_size: "سایزلوگو",
  logo_margin: "حاشیه لوگو",
  qr_accuracy: "دقت کیوآر",
  mode: "حالت",
  error_correction_level: "سطح اصلاح خطا",
  numeric: "عددی",
  alphanumeric: "الفبایی",
  byte: "بایت",
  apply_changes: "اعمال تغییرات",
  please_click_apply_changes:
    'لطفا پس از انتخاب تغییرات مورد نظر خود، دکمه "اعمال تغییرات" را کلیک کنید.',
  created_qr_codes: "کیوآر های ساخته شده",
  square_ratio: "1:1 (مربع)",
  image_upload_error: "خطای آپلود تصویر!",
  visit_card_name_label: "نام کارت ویزیت",
  sms_membership_message: "پیامک عضویت در باشگاه مشتریان",
  admin_menu: "منوی ادمین",
  user_menu: "منوی کاربر معمولی",
  guide_tooltip: "راهنمای",
  close: "بستن",
  browser_video_support_error:
    "مرورگر شما از هیچ‌یک از فرمت‌های ویدئو پشتیبانی نمی‌کند.",
  video_loading_error: "خطا در بارگذاری ویدئو (ممکن است دسترسی محدود باشد).",
  click_more_for_videos: "برای مشاهده ویدئو بیشتر بر روی بیشتر کلیک کنید.",
  more_info: "اطلاعات بیشتر",
  more: "بیشتر",
  add_user_guide: "افزودن راهنمای کاربران",
  edit_user_guide: "ویرایش راهنمای کاربران",
  display_info: "نمایش اطلاعات",
  element: "المان",
  disable_attach: "غیرفعال کردن attach برای قرارگیری نسبت به صفحه",
  view: "مشاهده",
  guide: "راهنما",
  details: "جزییات",
  guide_images: "عکس‌های راهنما",
  guide_videos: "ویدئوهای راهنما",
  faq: "سوالات متداول",
  data_preload_error: "خطا در پیش‌لود داده‌ها:",
  guide_not_found: "راهنما یافت نشد. لطفاً ابتدا یک راهنما ایجاد کنید.",
  delete_guide_question: "حذف آموزش؟",
  delete_guide_error: "خطا در حذف آموزش!",
  unknown_file_type: "نوع فایل ناشناخته است:",
  content_type_error: "خطا در دریافت نوع محتوا:",
  video: "ویدئو",
  image: "تصویر",
  guide_data_error: "خطا در دریافت داده‌های راهنما:",
  add_iranian_stores: "افزودن استور های ایرانی",
  add_foreign_stores: "افزودن استور های خارجی",
  bazaar: "بازار",
  myket: "مایکت",
  app_store: "اپ استور",
  google_play: "گوگل پلی",
  samsung_store: "سامسونگ استور",
  xiaomi_store: "شیامی استور",
  vivo_store: "ویوو استور",
  amazon_store: "آمازون استور",
  bazaar_app: "اپلیکیشن بازار",
  bazaar_link_placeholder: "لینک برنامه موجود در بازار را وارد کنید",
  bazaar_link_hint:
    "لینک معتبر بازار (مثلاً https://cafebazaar.ir/app/com.abankefarda) وارد کنید",
  myket_app: "اپلیکیشن مایکت",
  myket_link_placeholder: "لینک برنامه موجود در مایکت را وارد کنید",
  myket_link_hint:
    "لینک معتبر مایکت (مثلاً myket://details?id=com.example) وارد کنید",
  app_store_app: "اپلیکیشن اپ استور",
  app_store_link_placeholder: "لینک برنامه موجود در اپ استور را وارد کنید",
  app_store_link_hint:
    "لینک معتبر اپ‌استور (مثلاً https://apps.apple.com/us/app/appname/id123456789) وارد کنید",
  google_play_app: "اپلیکیشن گوگل پلی",
  google_play_link_placeholder: "لینک برنامه موجود در گوگل پلی را وارد کنید",
  google_play_link_hint:
    "لینک معتبر گوگل‌پلی (مثلاً https://play.google.com/store/apps/details?id=com.example) وارد کنید",
  samsung_store_app: "اپلیکیشن سامسونگ استور",
  samsung_store_link_placeholder:
    "لینک برنامه موجود در سامسونگ استور را وارد کنید",
  samsung_store_link_hint:
    "لینک معتبر سامسونگ استور (مثلاً https://galaxy.store/appname) وارد کنید",
  xiaomi_store_app: "اپلیکیشن شیامی استور",
  xiaomi_store_link_placeholder:
    "لینک برنامه موجود در شیامی استور را وارد کنید",
  xiaomi_store_link_hint: "لینک معتبر شیامی استور وارد کنید",
  vivo_app_store: "ویوو اپ استور",
  vivo_app_store_app: "اپلیکیشن ویوو اپ استور",
  vivo_app_store_link_placeholder:
    "لینک برنامه موجود در ویوو اپ استور را وارد کنید",
  vivo_app_store_link_hint: "لینک معتبر ویوو اپ استور وارد کنید",
  amazon_store_app: "اپلیکیشن آمازون استور",
  amazon_store_link_placeholder:
    "لینک برنامه موجود در آمازون استور را وارد کنید",
  amazon_store_link_hint: "لینک معتبر آمازون استور وارد کنید",
  iranian_store: "استور ایرانی",
  foreign_store: "استور خارجی",
  personal_store: "استور شخصی",
  image_logo: "تصویر/لوگو",
  image_gallery: "گالری تصاویر",
  header_image: "تصویر هدر",
  template_background_image: "تصویر پس قالب",
  background_image: "تصویر پس‌زمینه",
  background_image_alt: "تصویر پس زمینه",
  logo_upload: "بارگذاری لوگو",
  welcome_image: "عکس خوش آمدگویی",
  welcome_image_logo_upload: "بارگذاری عکس/لوگو خوش آمدگویی",
  loading_animation: "انیمیشن لودینگ",
  max_background_size:
    "حداکثر حجم هر تصویر پس زمینه نظر می‌تواند 2 مگابایت باشد.",
  max_logo_size: "حداکثر حجم هر لوگو مورد نظر می‌تواند 2 مگابایت باشد.",
  scale_from_center: "بزرگ شدن از مرکز",
  slide_from_left: "ورود از چپ",
  slide_from_top: "ورود از بالا",
  fade: "محو شدن",
  select_music_card: "انتخاب کارت موسیقی",
  show_audio: "نمایش صوت",
  hide_audio: "عدم نمایش صوت",
  add_voice: "افزودن صدا",
  max_files_limit: "شما مجاز به انتخاب بیشتر از {count} فایل نیستید !",
  files_not_allowed: "فایل نیستید !",
  voice_gallery: "گالری صوتی",
  edit_voice: "ویرایش صدا",
  list: "لیست",
  file_name: "نام فایل",
  title: "عنوان",
  description: "توضیحات",
  selectdate: "انتخاب تاریخ",
  background: "بگراند",
  text: "متن",
  delete_audio_confirm: "آیا از پاک کردن فایل صوتی از گالری خود اطمینان دارید؟",
  add_voice_gallery: "افزودن گالری صوتی",
  gallery_number: "گالری",
  delete_confirm: "آیا از حذف",
  confirm: "اطمینان دارید ؟",
  voice_gallery_title_hint: "لطفا عنوان گالری صوتی خود را وارد کنید.",
  voice_gallery_title: "عنوان",
  voice_gallery_subtitle_hint: "لطفا زیر عنوان گالری صوتی خود را وارد کنید.",
  voice_gallery_subtitle: "زیر عنوان گالری صوتی",
  voice_gallery_subtitle_alt: "زیر عنوان",
  website_address_hint: "لطفا آدرس وبسایت خود را وارد کنید.",
  website_address: "آدرس وبسایت",
  about_voice_gallery: "درباره گالری",
  about_voice_gallery_alt: "درباره گالری",
  button_name_hint: "لطفا نام دکمه خود را وارد کنید.",
  button_name: "نام دکمه",
  domain_format_hint:
    "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود.",
  about_us_alt: "درباره ما",
  add_default_form: "افزودن فرم پیش فرض",
  delete_all: "حذف همه",
  validation_active: "اعتبارسنجی:فعال",
  validation_inactive: "اعتبارسنجی:غیرفعال",
  validation: "اعتبار سنجی",
  clear_form: "پاک کردن فرم",
  status: "وضعیت",
  active: "فعال",
  inactive: "غیرفعال",
  optional: "اختیاری",
  required: "اجباری",
  question_title: "عنوان",
  question_title_hint: "عنوان سوال مربوط را وارد کنید",
  options_hint: "گزینه های مد نظر خود را تایپ کرده سپس با زدن اینتر اضافه کنید",
  options: "گزینه‌ها",
  add_suggested_form: "افزودن فرم درخواست پیشنهادی",
  save_changes: "ثبت تغییرات",
  add_request_field: "افزودن فیلد درخواستی",
  select_form_type: "انتخاب نوع فرم درخواستی",
  select_form_type_placeholder: "انتخاب نوع فرم درخواستی",
  dropdown: "کشویی",
  text_field: "متن",
  number_field: "عدد",
  textarea_field: "متن باز",
  date_field: "تاریخ",
  field_name_required: "نام فیلد نمیتواند خالی باشد",
  field_name: "نام فیلد",
  add_field_name: "افزودن نام فیلد",
  field_label: "متن لیبل",
  add_field_label: "افزودن لیبل فیلد",
  advanced_settings: "تنظیمات پیشرفته",
  select_input_pattern: "انتخاب الگو برای ورودی",
  select_input_pattern_placeholder: "انتخاب الگو برای ورودی",
  max_characters: "حداکثر تعداد کارکتر ورودی",
  min_input_error: "حداقل ورودی باید 0 باشد",
  name_field: "نام",
  field_type: "نوع فیلد",
  persian_limit: "محدودیت زبان فارسی",
  family_name: "نام خانوادگی",
  mobile_number: "شماره موبایل",
  number_limit: "محدودیت تایپ عدد",
  national_code: "کد ملی",
  meli_code: "کد ملی",
  email: "ایمیل",
  email_limit: "محدودیت ایمیل",
  dropdown_field: "کشویی",
  english_limit: "محدودیت زبان انگلیسی",
  mix_per_eng_limit: "محدودیت زبان فارسی و انگلیسی",
  site_limit: "محدودیت وبسایت",
  form_added_successfully: "فرم جدید با موفقیت اضافه شد",
  form_updated_successfully: "فرم با موفقیت بروزرسانی شد",
  delete_item_confirm: "آیا از حذف ایتم خود اطمینان دارید؟",
  default_form_added_successfully: "فرم پیش فرض با موفقیت اضافه شد",
  resources_upload_error: "بارگزاری منابع به مشکل برخورد کرده است",
  update_value_if_duplicate: "آپدیت مقدار اگر تکراری بود",
  first_tab: "تب اول",
  display_count: "تعداد نمایش",
  buy_renew_qr_instruction:
    "برای خرید/تمدید کیوآرکد دکمه مدت زمان انقضا را کلیک کنید.",
  days_until_expiry: "روز تا انقضا",
  expired: "منقضی شده",
  no_qr_to_display: "هیچ کیوآری برای نمایش وجود ندارد!",
  second_tab: "تب دوم",
  total_qr_codes: "تعداد کل کیو آر کدها",
  select_all: "انتخاب همه",
  selected_qr_codes_count: "تعداد  کیو آر کد‌های انتخاب شده",
  qr_codes_count: "تعداد کیو آر کد ها",
  group_renewal_instruction:
    "برای تمدید گروهی، کیوآر کدهای مورد نظر خود را انتخاب نمایید.",
  no_qr_found_with_filters: "هیچ کیوآری با این فیلترها یافت نشد!",
  qr_codes_count_label: "تعداد کیوآر کدها:",
  renew_qr: "تمدید کیوآر",
  days: "روزه",
  buy_now: "خرید می‌کنم!",
  buy_now_label: "خرید می‌کنم",
  add_discount_code: "افزودن کد تخفیف",
  use_discount_code: "استفاده از کد تخفیف",
  discount_code: "کد تخفیف",
  submit: "ثبت",
  my_qr_list: "لیست کیوآرهای من",
  group_renewal: "تمدید گروهی",
  row: "ردیف",
  type: "نوع",
  clicks: "بازدید",
  created_at_diff: "زمان ساخت",
  updated_at_diff: "زمان ویرایش",
  table_view: "نمایش جدولی",
  normal_view: "نمایش معمولی",
  no_qr_or_id_selected: "هیچ کیوآر یا شناسه‌ای انتخاب نشده است!",
  qr_updated_successfully: "کیوآر با موفقیت به‌روزرسانی شد.",
  qr_update_error: "خطا در به‌روزرسانی کیوآر!",
  no_qr_selected: "هیچ QR انتخاب نشده است!",
  no_qr_code_selected: "هیچ QR کدی انتخاب نشده است!",
  success: "موفقیت",
  qrs_upgraded_successfully: "کیوآرهای شما با موفقیت ارتقا پیدا کرد.",
  qr_renewal_error: "مشکلی برای درخواست تمدید کیوآر پیش آمده است!",
  changed_successfully: "با موفقیت تغییر یافت.",
  error_occurred: "خطایی رخ داده است!",
  no_tariff_exists: "هیچ تعرفه‌ای وجود ندارد!",
  qr_upgraded_successfully: "کیوآر شما با موفقیت ارتقا پیدا کرد.",
  check_account_balance:
    "لطفا موجودی حساب خود را بررسی بفرمایید و بعدا، دوباره تلاش فرمایید.",
  group_renewal_price_error: "خطا در دریافت قیمت تمدید گروهی!",
  qr_count_error: "خطا در دریافت تعداد QR کدها!",
  no_qr_for_renewal: "هیچ QR کدی برای تمدید وجود ندارد!",
  table_pagination: "Pagination بالای جدول",
  virtual_scroll_display: "نمایش داده‌ها با Virtual Scroll",
  popups_shared_components: "پاپ‌آپ‌ها و کامپوننت‌های مشترک",
  edit_qr_address: "ویرایش آدرس کیوآر",
  please_enter_correct_address: "لطفا آدرس صحیح وارد نمایید",
  successfully_edited: "با موفقیت ویرایش شد.",
  error_editing_qr_address: "خطا در ویرایش آدرس کیوآر!",
  go_to_page: "برو به صفحه",
  page_from_to: "صفحه {current} از {last}",
  display: "نمایش",
  to: "تا",
  from: "از",
  show: "نمایش",
  page_status: "صفحه {current} از {total}",
  until: "الی",
  successfully_completed: "با موفقیت انجام شد",
  problem_occurred: "مشکلی پیش آمده است",
  download_failed: "دانلود ناموفق",
  audio_file_default: "فایل صوتی",
  memory_release: "آزادسازی حافظه",
  seek_music_comment: "فرضاً این موزیک یا هر چیزی رو seek می‌کنه",
  all: "همه",
  create_podcast: "ضبط صدا",
  add_link: "افزودن لینک",
  upload_file: "آپلود فایل",
  file_list: "لیست فایل ها",
  count: "تعداد",
  select_category: "انتخاب دسته‌بندی",
  after_typing_enter: "پس از تایپ، دکمه اینتر را کلیک کنید.",
  no_image_available: "تصویری موجود نیست",
  no_image_found: "تصویری پیدا نشد!",
  for_adding_file_use_upload_center:
    "برای افزودن فایل از فیلد بازگذاری تصاویر یا آپلود سنتر استفاده نمایید",
  ai_story_creation_description:
    "کافیست داستان مورد نظر خود را وارد کنید تا هوش مصنوعی آن را برای شما خلق کند",
  create_new_podcast: "ضبط صدا جدید",
  show_audio_file: "نمایش فایل صوتی",
  cancel: "لغو",
  no_audio_in_category: "در این دسته فایل صوتی وجود ندارد",
  health_apple: "سیب سلامت",
  standard: "استاندارد",
  arshia_badge: "نشان ارشیا",
  home_appliances_association: "انجمن لوازم خانگی",
  energy_label: "لیبل انرژی",
  select_gold_purity_first: "برای دریافت قیمت ابتدا عیار طلا را مشخص کنید",
  gold_price_service: "سرویس دریافت قیمت طلا",
  rahvard: "رهاورد",
  to_change_gold_service_go_to_assets:
    "برای تعویض سرویس دریافت قیمت به قسمت دارایی ها مراجعه کنید",
  gold: "طلا",
  purity: "عیار",
  rial: "ریال",
  final_product_price: "قیمت نهایی محصول",
  show_images_right_side: "نمایش تصاویر سمت راست",
  show_as_slider: "نمایش به صورت اسلایدر باشد.",
  show_as_grid: "نمایش به صورت گرید باشد.",
  show_as_second_mode: "نمایش به صورت حالت دوم باشد.",
  gallery_name: "نام گالری",
  change_gallery_name: "تغییر نام گالری",
  add_photo: "افزودن تصویر",
  select_photo: "انتخاب عکس",
  show_image: "نمایش تصویر",
  selected_photo: "عکس انتخابی",
  to_use_ready_images_search_category_or_product:
    "برای استفاده از تصاویر آماده، نام دسته یا محصول مورد نظر خود را از فیلدهای بالا جستجو کنید.",
  max_file_size_2mb: "حداکثر حجم هر فایل مورد نظر می‌تواند 2 مگابایت باشد.",
  drag_and_drop_to_upload_or: "برای آپلود بکشید و رها کنید یا",
  here: "اینجا",
  click: "کلیک کنید",
  to_use_external_image_link_fill_fields:
    "برای استفاده از تصویر با لینک خارجی، لطفا فیلدهای زیر را پر نمایید",
  image_url_hint: "آدرس (لینک) تصویر مورد نظر.",
  image_url: "آدرس تصویر",
  add_new_gallery: "افزودن گالری جدید",
  create_image: "خلق تصویر",
  ready_images: "تصاویر آماده",
  edit_image: "ویرایش تصویر",
  enter_valid_link: "لینک صحیح وارد نمایید.",
  max_background_image_size_2mb:
    "حداکثر حجم هر تصویر پس زمینه نظر می‌تواند 2 مگابایت باشد.",
  uploaded_successfully: "با موفقیت آپلود شد.",
  banner: "بنر",
  question: "سوال",
  selected_question: "سوال انتخابی",
  answer: "پاسخ",
  add_question: "افزودن سوال",
  selected_blog: "بلاگ انتخابی",
  icon: "ایکون",
  select_icon: "انتخاب ایکن",
  add_blog: "افزودن بلاگ",
  post: "پست",
  selected_services: "خدمات انتخابی",
  add_new_post: "افزودن پست جدید",
  add_new_services: "افزودن خدمات جدید",
  add_new_service: "افزودن خدمت جدید",
  domain_must_be_https_or_http:
    "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود.",
  id: "شناسه",
  images: "تصاویر",
  tags: "برچسب‌ها",
  print_type: "نوع چاپ",
  user: "کاربر",
  user_shipping_info: "اطلاعات پستی کاربر",
  qr_short_link: "لینک کوتاه کیوآر",
  delivery_method: "روش تحویل",
  delivery_at_company: "تحویل در شرکت",
  delivery_by_post: "ارسال با پست",
  post_cost_and_tax_warning:
    "در زمان ثبت، هزینه پست و 10 درصد مالیات (روی مبلغ سفارش) از کیف پول شما کسر خواهد شد.",
  shipping_info: "اطلاعات ارسال",
  continue_shopping: "ادامه خرید",
  complete_shopping: "تکمیل خرید",
  select_free_nfc_card: "خرید تجهیزات آماده",
  order_custom_nfc_card: "سفارش کارت nfc اختصاصی",
  buy_qr_equipment: "سفارش تجهیزات اختصاصی",
  vertical: "عمودی",
  horizontal: "افقی",
  card_type: "نوع کارت",
  tag: "برچسب",
  select: "انتخاب",
  order_card: "سفارش کارت",
  available: "موجود",
  unavailable: "ناموجود",
  for_initial_loading: "برای بارگذاری اولیه",
  already_have_free_nfc_message:
    "شما قبلا NFC رایگان برای این کیوآر دریافت کرده‌اید. در صورت تمایل به تغییر کارت NFC، از کارت ویزیت اختصاصی خریداری فرمایید.",
  nfc_in_delivery_process_message:
    "شما قبلا NFC رایگان برای این کیوآر ثبت کردید و NFC شما در پروسه تحویل قرار دارد. در صورت تمایل به تغییر کارت NFC، از کارت ویزیت اختصاصی خریداری فرمایید.",
  free_nfc_card_warning_message:
    "همراه گرامی: کارت های nfc رایگان به دلیل اینکه قبلا چاپ شده اند، کیوآر کد فعلی شما تغییر خواهد کرد.\nچنانچه کیوآر کد خود را قبلا استفاده نموده اید، پیشنهاد میکنیم از چاپ سفارشی کارت nfc طرح دلخواه خود را انتخاب و ثبت نمایید.\n",
  select_card: "انتخاب کارت",
  free_card_selection_conditions: "شرایط انتخاب کارت رایگان",
  confirm_and_select: "تایید و انتخاب",
  registered_successfully: "با موفقیت ثبت شد.",
  error_registering_nfc_order: "خطا در ثبت درخواست سفارش کارت NFC!",
  nfc_physical_card_orders: "سفارشات کارت فیزیکی nfc",
  buy_equipment: "خرید تجهیزات",
  select_quantity: "انتخاب تعداد",
  ready_samples: "نمونه‌های آماده",
  upload_custom_design: "آپلود طرح دلخواه",
  select_ready_card_image: "انتخاب تصویر کارت آماده",
  select_card_front_image: "انتخاب تصویر روی کارت",
  select_card_back_image: "انتخاب تصویر پشت کارت",
  nfc_card_image: "تصویر کارت NFC",
  add_quantity: "افزودن تعداد",
  total_price: "قیمت کل",
  price_with_discount: "قیمت با تخفیف",
  shipping_cost: "هزینه ارسال",
  your_profit_from_purchase: "سود شما از خرید",
  discount: "تخفیف",
  ten_percent_tax_will_be_added: "۱۰٪ مالیات به مبلغ نهایی افزوده خواهد شد.",
  payable_amount: "مبلغ قابل پرداخت",
  continue: "ادامه",
  Confirm_code: "تایید کد",
  form_success_message: "فرم شما با موفقیت دریافت شد",
  refill_form_message: "پرکردن مجدد فرم",
  Enter_the_sent_code: "کد ارسالی را وارد کنید",
  SUBMIT_FORM: "ثبت فرم",
  enter_phone_number: "شماره موبایل خود را وارد کنید",
  order_registered_successfully: "سفارش شما با موفقیت ثبت شد.",
  smart_creation: "ساخت هوشمند",
  automatic_creation: "ساخت اتوماتیک",
  business_name: "نام کسب و کار",
  example_household_goods: "مثال: لوازم خانگی",
  organization_name: "نام مجموعه",
  example_tech_company: "مثال: شرکت فناوری پیشرو",
  minimum_two_characters_required: "حداقل دو کاراکتر باید وارد شود!",
  maximum_100_characters_allowed: "حداکثر ۱۰۰ کاراکتر مجاز است",
  latin_name_qr_address: "نام لاتین (آدرس کیوآرکد)",
  example_advanced_tech: "مثال: advanced-tech",
  only_english_numbers_dash_allowed:
    "فقط حروف انگلیسی، اعداد و خط تیره مجاز است",
  maximum_50_characters_allowed: "حداکثر ۵۰ کاراکتر مجاز است",
  latin_name_goes_after_domain: "نام لاتین در ادامه دامنه قرار می‌گیرد",
  select_logo_and_store_product_image: "انتخاب لوگو و تصویر فروشگاه/محصول",
  select_logo: "انتخاب لوگو",
  file_size_must_be_less_than_2mb: "حجم فایل باید کمتر از ۲ مگابایت باشد",
  for_buying_renewing_qr_click_expiry_button:
    "برای خرید/تمدید کیوآرکد دکمه مدت زمان انقضا را کلیک کنید.",
  for_group_renewal_select_desired_qr_codes:
    "برای تمدید گروهی، کیوآر کدهای مورد نظر خود را انتخاب نمایید.",
  no_qr_found_with_these_filters: "هیچ کیوآری با این فیلترها یافت نشد!",
  i_buy: "خرید",
  visits: "بازدید",
  creation_time: "زمان ساخت",
  edit_time: "زمان ویرایش",
  enter_business_card_name_correctly: "نام کارت ویزیت را به درستی وارد نمایید!",
  are_you_sure_delete_qr: "آیا از حذف کیوآر مطمئن هستید؟",
  qr_deleted_successfully: "کیوآر با موفقیت حذف شد.",
  are_you_sure_deactivate_qr: "آیا از متوقف کردن کیوآر مطمئن هستید؟",
  are_you_sure_activate_qr: "آیا از فعال کردن کیوآر مطمئن هستید؟",
  deactivated: "متوقف",
  qr_successfully: "کیوآر با موفقیت",
  successfully: "شد",
  user_transferred_successfully: "کاربر با موفقیت انتقال یافت",
  problem_occurred_in_transfer: "مشکلی در انتقال رخ داده است!",
  error_in_user_transfer: "خطا در انتقال کاربر!",
  qr_business_card_edited_successfully: "کیوآر شما باموفقیت ویرایش شد.",
  group_qr_renewal: "تمدید گروهی کیوآر",
  select_desired_duration: "مدت زمان مورد نظر خودرا انتخاب نمایید",
  total_count: "تعداد کل",
  final_amount: "مبلغ نهایی",
  ten_percent_vat_will_be_added:
    "۱۰٪ درصد مالیات ارزش افزوده به مبلغ فوق اضافه خواهد شد.",
  pay_and_upgrade: "پرداخت و ارتقا",
  no_tariff_for_this_period: "برای این بازه زمانی، تعرفه‌ای وجود ندارد!",
  selected: "انتخاب شده",
  total_amount: "مبلغ کل",
  final_amount_with_discount: "مبلغ نهایی با تخفیف",
  add_qr: "افزودن کیوآر",
  actions: "عملیات",
  filter_type: "فیلتر نوع",
  start_from: "شروع از",
  search_in_id: "جستجو در شناسه",
  filter_user: "فیلتر کاربر",
  clear_filters: "حذف فیلترها",
  send_sms: "ارسال پیامک",
  selected_pattern: "پترن انتخاب شده",
  send: "ارسال",
  bulk_download: "دانلود گروهی",
  one_month_renewal: "تمدید یک ماهه",
  three_month_renewal: "تمدید سه‌ماهه",
  six_month_renewal: "تمدید شش ماهه",
  one_year_renewal: "تمدید یک ساله",
  no_item_selected: "هیچ آیتمی انتخاب نشده است!",
  error_loading_card_info: "خطا در بارگذاری اطلاعات کارت!",
  send_registered_successfully: "ارسال با موفقیت ثبت شد",
  error_getting_prices: "خطا در دریافت قیمت‌ها!",
  payment_error: "خطا در پرداخت!",
  business_card: "کارت ویزیت",
  product_label: "لیبل محصول",
  restaurant_menu: "منوی رستوران",
  event_ticket: "بلیط رویداد",
  brochure: "بروشور",
  flyer: "فلایر",
  poster: "پوستر",
  catalog: "کاتالوگ",
  newsletter: "خبرنامه",
  organization_name_hint: "لطفا نام مجموعه خود را وارد کنید.",
  organization_name_label: "نام مجموعه",
  sub_organization_hint: "لطفا زیرنام مجموعه خود را وارد کنید.",
  sub_organization_label: "توضیحات زیر نام مجموعه",
  user_name_hint: "لطفا نام خود را وارد کنید.",
  user_name_label: "نام و نام خانوادگی",
  work_field_hint: "لطفا سمت شغلی خود را وارد کنید.",
  work_field_label: "سمت",
  mobile_number_hint: "لطفا شماره خود را وارد کنید.",
  mobile_number_label: "شماره موبایل",
  phone_number_hint: "لطفا شماره تلفن خود را وارد کنید.",
  phone_number_label: "شماره تلفن",
  email_hint: "لطفا ایمیل خود را وارد کنید.",
  email_label: "ایمیل",
  fax_hint: "لطفا فکس شرکت خود را وارد کنید.",
  fax_label: "فکس شرکت",
  website_hint: "لطفا وبسایت شرکت خود را وارد کنید.",
  website_label: "وبسایت شرکت",
  postal_code_hint: "لطفا کدپستی خود را وارد کنید.",
  postal_code_label: "کدپستی",
  copyright_hint: "لطفا متن کپی رایت در فوتر خود را وارد کنید.",
  copyright_label: "متن کپی رایت",
  address_hint: "لطفا آدرس خود را وارد کنید.",
  address_label: "آدرس",
  add_more_info: "اطلاعات بیشتر مورد نظر خود را اضافه نمایید:",
  edit_location: "ویرایش",
  add_location: "افزودن",
  delete_location: "حذف لوکیشن",
  about_us_label: "درباره ما",
  search_address: "جستجوی آدرس:",
  northern_coordinates: "مختصات شمالی",
  eastern_coordinates: "مختصات عرضی",
  select_address_on_map: "انتخاب آدرس روی نقشه",
  location_not_found: "محل موردنظر یافت نشد.",
  text_label: "متن",
  number_label: "شماره",
  website_address_label: "آدرس وبسایت",
  location_label: "لوکیشن",
  mobile_viewer_title: "نمایشگر موبایل",
  visit_theme_two_title: "تم کارت ویزیت دو",
  visit_theme_flipped_title: "تم کارت ویزیت برگشتی",
  flip_card: "برگردان کارت",
  flip_card_description: "برای مشاهده اطلاعات بیشتر کارت را برگردانید",
  share_contacts: "اشتراک گذاری مخاطبین",
  close_share: "بستن اشتراک گذاری",
  card_front: "روی کارت",
  card_back: "پشت کارت",
  flip_to_back: "برگردان به پشت",
  flip_to_front: "برگردان به روی",
  swipe_to_flip: "برای برگرداندن کارت بکشید",
  swipe_left: "بکشید به چپ",
  swipe_right: "بکشید به راست",
  expand_card: "باز کردن کارت",
  contract_card: "بستن کارت",
  view_details: "مشاهده جزئیات",
  hide_details: "مخفی کردن جزئیات",
  social_media_share: "اشتراک گذاری شبکه های اجتماعی",
  contact_actions: "عملیات مخاطب",
  card_actions: "عملیات کارت",
  floating_menu: "منوی شناور",
  close_menu: "بستن منو",
  open_menu: "باز کردن منو",
  choice_gallery: "گالری انتخابی",
  choice_video: "انتخاب ویدئو",
  url_video: "آدرس ویدیو",
  selected_video: "ویدیو انتخابی",
  add_video: "افزودن ویدئو",
  edit_video: "ویرایش ویدئو",
  linl_video: "لینک انتقال",
  upload_video: "افزودن فیلم",
  rule_link:
    "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
  fax_hint: "لطفا فکس شرکت خود را وارد کنید.",
  fax_label: "فکس شرکت",
  website_hint: "لطفا وبسایت شرکت خود را وارد کنید.",
  website_label: "وبسایت شرکت",
  postal_code_hint: "لطفا کدپستی خود را وارد کنید.",
  postal_code_label: "کدپستی",
  add_more_info: "اطلاعات بیشتر مورد نظر خود را اضافه نمایید:",
  edit_location: "ویرایش",
  add_location: "افزودن",
  about_us_label: "درباره ما",
  search_address: "جستجوی آدرس:",
  northern_coordinates: "مختصات شمالی",
  eastern_coordinates: "مختصات عرضی",
  select_address_on_map: "انتخاب آدرس روی نقشه",
  location_not_found: "محل موردنظر یافت نشد.",
  location_label: "لوکیشن",
  rule_link:
    "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود.",
  address_hint: "لطفا آدرس خود را وارد کنید.",
  address_label: "آدرس",
  copyright_hint: "لطفا متن کپی رایت در فوتر خود را وارد کنید.",
  copyright_label: "متن کپی رایت",
  organization_name_hint: "لطفا نام مجموعه خود را وارد کنید.",
  organization_name_label: "نام مجموعه",
  sub_organization_hint: "لطفا زیرنام مجموعه خود را وارد کنید.",
  sub_organization_label: "توضیحات زیر نام مجموعه",
  mobile_number_hint: "لطفا شماره خود را وارد کنید.",
  mobile_number_label: "شماره موبایل",
  number_label: "شماره",
  text_label: "متن",
  company_phone_hint: "لطفا شماره تلفن خود را وارد کنید.",
  company_phone_label: "شماره تلفن",
  email_hint: "لطفا ایمیل خود را وارد کنید.",
  email_label: "ایمیل",
  fax_hint: "لطفا فکس شرکت خود را وارد کنید.",
  fax_label: "فکس شرکت",
  postal_code_hint: "لطفا کدپستی خود را وارد کنید.",
  postal_code_label: "کدپستی",
  website_hint: "لطفا آدرس وبسایت خود را وارد کنید.",
  website_label: "آدرس وبسایت",
  copyright_hint: "لطفا متن کپی رایت در فوتر خود را وارد کنید.",
  copyright_label: "متن کپی رایت",
  add_more_info: "اطلاعات بیشتر مورد نظر خود را اضافه نمایید:",
  address_hint: "لطفا آدرس خود را وارد کنید.",
  address_label: "آدرس",
  edit_location: "ویرایش",
  add_location: "افزودن",
  delete_location: "حذف لوکیشن",
  location_label: "لوکیشن",
  about_company_label: "درباره شرکت",
  select_address_on_map: "انتخاب آدرس روی نقشه",
  search_address: "جستجوی آدرس:",
  rule_link:
    "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود.",
  link_label: "آدرس لینک",
  label_label: "عنوان",
  field_value_label: "مقدار فیلد",
  add_new_field: "افزودن فیلد جدید",
  tehran_address:
    "تهران، خیابان شریعتی، بعد از پل سید خندان، بن بست خندان، پلاک 6",
  welcome_message_hint:
    "با فعال بودن این گزینه، هنگام عضویت مشتریان به باشگاه مشتریان شما، یک پیام خوش‌آمد گویی برای ایشان ارسال خواهد شد.",
  change_pattern_campaign: "تغییر پترن/کمپین",
  selected_message: "پیام انتخاب شده:",
  required_inputs: "ورودی‌های اجباری:",
  selected_campaign_or_pattern: "کمپین/پترن انتخاب شده:",
  campaign: "کمپین",
  pattern: "پترن",
  id: "شناسه",
  auto_csv_download_label: "ذخیره اتوماتیک",
  auto_csv_download_hint:
    "پس از باز شدن کارت ویزیت، اطلاعات شما به صورت اتوماتیک در موبایل مشتری دانلود می‌شود.",
  show_cclub_onload_label: "پیشنهاد عضویت",
  show_cclub_onload_hint:
    "یک پنجره جدید برای عضویت در باشگاه مشتریان به شخص، نمایش داده می‌شود.",
  forced_submission_hint:
    "با نمایش فرم عضویت، کاربر حتما شماره خودرا در باشگاه مشتریان شما ثبت کند.",
  forced_submission_forced: "عضویت اجباری",
  forced_submission_optional: "عضویت اختیاری",
  has_manifest_icons_label: "شخصی سازی وب اپلیکیشن",
  has_assistant_label: "هوش مصنوعی",
  has_assistant_hint:
    "با انتخاب دستیار هوش مصنوعی از قابلیت چت هوشمند استفاده کنید",
  select_assistant: "انتخاب دستیار",
  search_assistant: "جستجوی دستیار...",
  add_new_assistant: "افزودن دستیار جدید",
  hasAssistantsName_hint:
    "با انتخاب این گزینه زمان چت از کاربر نام دریافت خواهد کرد.",
  hasAssistantsName_label: "نام",
  hasAssistantsFamily_hint:
    "با انتخاب این گزینه زمان چت از کاربر نام خانوادگی دریافت خواهد کرد.",
  hasAssistantsFamily_label: "نام خانوادگی",
  hasAssistantsMobile_hint:
    "با انتخاب این گزینه زمان چت از کاربر شماره همراه دریافت خواهد کرد.",
  hasAssistantsMobile_label: "شماره همراه",
  expires_today: "امروز منقضی می‌شود",
  one_day_remaining: "یک روز باقی مانده",
  days_remaining: "روز باقی مانده",
  weeks_remaining: "هفته باقی مانده",
  months_remaining: "ماه باقی مانده",
  remaining: "مانده",
  no_expiry_date: "بدون تاریخ انقضا",
  assistant_ai: "دستیار هوش مصنوعی",
  has_manifest_icons_hint:
    "لوگو و عکس وارد شده شما، در زمان نصب وب اپ بر روی موبایل یا کامپیوتر به کاربر نمایش داده میشود.",
  logo_144px: "لوگو ۱۴۴px",
  logo_48px: "لوگو ۴۸px",
  photo_wide: "عکس Wide",
  photo: "عکس",
  iranian_social_networks: "شبکه‌های اجتماعی ایرانی",
  foreign_social_networks: "شبکه‌های اجتماعی خارجی",
  advertising_sites: "سایت‌های اختصاصی",
  other_links: "لینک‌های دیگر",
  custom_text: "متن دلخواه",
  custom_text_placeholder: "متن دلخواه خودرا وارد کنید.",
  aparat: "آپارات",
  aparat_hint: "نام کانال آپارات خود را وارد نمایید",
  eitaa: "ایتا",
  eitaa_hint: "نام کاربری خود را وارد نمایید",
  soroush: "سروش",
  soroush_hint: "نام کاربری خود را وارد نمایید",
  bale: "بله",
  bale_hint: "نام کاربری خود را وارد نمایید",
  rubika: "روبیکا",
  rubika_hint: "لینک کانال/گروه خود را وارد نمایید",
  gap: "گپ",
  gap_hint: "نام کاربری خود را وارد نمایید",
  linkedin: "صفحه شخصی لینکدین",
  linkedin_hint: "نام کاربری خود را وارد نمایید",
  linkedin_company: "صفحه شرکتی لینکدین",
  linkedin_company_hint: "نام صفحه شرکتی خود را وارد کنید",
  pinterest: "پینترست",
  pinterest_hint: "نام کاربری خود را وارد نمایید",
  dribbble: "دریبل",
  dribbble_hint: "نام کاربری خود را وارد نمایید",
  facebook: "فیسبوک",
  facebook_hint: "نام کاربری خود را وارد نمایید",
  github: "گیت هاب",
  github_hint: "نام کاربری خود را وارد نمایید",
  threads: "تردز",
  threads_hint: "نام کاربری خود را وارد نمایید",
  tiktok: "تیک تاک",
  tiktok_hint: "نام کاربری خود را وارد نمایید",
  twitter: "توئیتر",
  twitter_hint: "نام کاربری خود را وارد نمایید",
  skype: "اسکایپ",
  skype_hint: "نام کاربری خود را وارد نمایید",
  youtube: "یوتیوب",
  youtube_hint: "نام کاربری خود را بدون @ وارد نمایید",
  wechat: "وی چت",
  wechat_hint: "نام کاربری خود را وارد نمایید",
  viber: "وایبر",
  viber_hint: "نام کاربری خود را وارد نمایید",
  divar: "دیوار",
  divar_hint: "لینک آگهی/پنل/فروشگاه خود را وارد نمایید",
  sheypoor: "شیپور",
  sheypoor_hint: "لینک آگهی/پنل/فروشگاه خود را وارد نمایید",
  social_network: "شبکه اجتماعی",
  photo_logo_tab: "تصویر/لوگو",
  gallery_image_tab: "گالری عکس",
  template_image: "تصویر قالب",
  background_image: "تصویر پس‌زمینه",
  upload_logo: "بارگذاری لوگو",
  welcome_image_upload: "بارگذاری عکس/لوگو خوش‌آمدگویی",
  welcome_photo: "عکس خوش‌آمدگویی",
  loading_animation: "انیمیشن لودینگ",
  preview_welcome_page: "مشاهده پیش‌نمایش صفحه خوش‌آمدگویی",
  default_template_image: "تصویر پس قالب",
  default_background_image: "تصویر پس‌زمینه",
  default_logo: "لوگو",
  default_welcome: "خوش‌آمدگویی",
  default_gallery: "گالری",
  animation_scale: "بزرگ شدن از مرکز",
  animation_slide_x: "ورود از چپ",
  animation_slide_y: "ورود از بالا",
  animation_fade: "محو شدن",
  image_size_error: "حداکثر حجم هر تصویر پس‌زمینه می‌تواند ۲ مگابایت باشد.",
  logo_size_error: "حداکثر حجم هر لوگو می‌تواند ۲ مگابایت باشد.",
  categories: {
    bankcard: 'کیوکارت',
    bale: "بله",
    robika: "روبیکا",
    eitaa: "ایتا",
    text: "متن",
    multi_card: "مولتی کارت",
    product_introduction_pro: "معرفی محصول پرو",
    gift:"قاب خاطره ها",
    electronic_business_card_pro:"کارت ویزیت الکترونیکی پرو",
    link_pro:"کلیک یار سئو",
    generated_images: "تصاویر خلق شده",
    electronic_business_card: "کارت ویزیت الکترونیکی",
    social_media: "شبکه های اجتماعی",
    photo_gallery: "گالری تصاویر",
    video_gallery: "گالری ویدئو",
    link: "لینک",
    audio_gallery: "گالری صوتی",
    audio_gallery_pro: "گالری صوتی (پرو)",
    feedback: "فیدبک (بازخورد)",
    consultation_form: "فرم درخواست",
    application: "ارائه اپلیکیشن",
    pdf_gallery: "گالری PDF",
    schedule_table: "جدول برنامه ریزی",
    personal_company_website: "سایت شخصی/شرکتی",
    online_store: "فروشگاه آنلاین",
    online_menu: "منو آنلاین",
    appointment_booking: "نوبت دهی",
    commercial_admin_website: "سایت مجتمع تجاری/اداری",
    online_insurance_sales: "فروش آنلاین بیمه",
    discount_code: "کد تخفیف",
    product_introduction: "معرفی محصول",
    product_label: "لیبل محصول",
    gold_label: "لیبل طلا",
    franchise: "فرانچایز (بیزینس پیج)",
    marketplace: "مارکت PLACE (بیزینس پیج)",
    recruitment_form: "فرم استخدام",
    organizational_form: "فرم سازمانی",
    employee_card: "کارت پرسنلی",
    book_magazine: "کتاب/مجله",
    catalog_brochure: "کاتالوگ/بروشور",
    catalog: "کاتالوگ",
    faq: "سوالات متداول",
    feedback_survey: "فیدبک / نظرسنجی",
    consultation_request: "درخواست مشاوره",
    customer_club: "باشگاه مشتریان",
    invitation_card: "کارت دعوت",
    countdown: "شمارنده معکوس",
    tombstone: "سنگ قبر",
    luck_wheel: "گردونه شانس",
  },
  support_day60: "60 روز ضمانت بازگشت وجه",
  ROUTE: {
    TITLES: {
    attendance:"حضور و غیاب",
    editattendance:"ویرایش کیوآ حضور و غیاب",
    QR_NAME_EDIT_TEXT:"ویرایش کیوآر متن",
    SERVER_DOWN: "در حال به روزرسانی",
    CREATE_MEMORIES_MODEL: "ساخت مدل قاب خاطره",
    CREATE_CARD_VISIT_PRO_MODEL: "ساخت مدل کارت ویزیت پرو",
    CREATE_PRODUCT_PRO_MODEL: "ساخت مدل معرفی محصول پرو",
    CREATE_PRODUCT_LABEL_MODEL: "ساخت مدل لیبل محصول",
    CREATE_PHOTO_GALLERY_MODEL: "ساخت مدل گالری تصویر",
    CREATE_PDF_GALLERY_MODEL: "ساخت مدل گالری پی دی اف",
    CREATE_SOCIAL_MEDIA_MODEL: "ساخت مدل شبکه اجتماعی",
    EDIT_CARD_VISIT_PRO_MODEL: "ویرایش مدل کارت ویزیت پرو",
    EDIT_PRODUCT_PRO_MODEL: "ویرایش مدل معرفی محصول پرو",
    EDIT_PRODUCT_LABEL_MODEL: "ویرایش مدل لیبل محصول",
    EDIT_PHOTO_GALLERY_MODEL: "ویرایش مدل گالری تصویر",
    EDIT_PDF_GALLERY_MODEL: "ویرایش مدل گالری پی دی اف",
    EDIT_SOCIAL_MEDIA_MODEL: "ویرایش مدل شبکه اجتماعی",
    BOOK: "دفترچه / کتاب",
    NFC_LIST: "لیست NFC ها",
    API_KEY_MANAGER: "ساخت کلید API",
    PRE_PURCHASE: "پیش خرید",
    PRE_PURCHASE_MODEL: "نمونه آماده",
      QR_NAME_EDIT_GIFT:"ویرایش کیوار کد قاب خاطره ها",
      QR_GIFT:"کیوار کد قاب خاطره ها",
      QR_CARD_VISIT_PRO:" کارت ویزیت پرو",
      QR_NAME_EDIT_PRO:"ویرایش کارت ویزیت پرو",
      QR_LINK_PRO:"کیوار کلیک یار سئو",
      DIGI: "مونیتورینگ قیمت‌گذار دیجی‌کالا",
      QR_PDF: "گالری پی دی اف",
      QR_NAME_EDIT_PDF: "ویرایش گالری پی دی اف",
      QR_MULTICART: "کیوار مولتی کارت",
      QR_MULTICART_EDIT: "ویرایش مولتی کارت کیوار",
      QR_NAME_PRODUCTPRO: "ویرایش معرفی محصول پرو",
      QR_PRODUCTPRO: "معرفی محصول پرو",
      QR_NAME_EDIT_CATALOG: "ویرایش کاتالوگ",
      QR_LUCK_WHEEL_Edit: "ویرایش گردونه شانس",
      QR_LUCK_WHEEL: "ساخت کیو آر گردونه شانس",
      DASHBOARD: "داشبورد",
      ADMIN_QR_DOMAINS: "مانیتورینگ دامنه‌ها",
      ADMIN_TOGETHER_TOKEN: "مانیتورینگ توکن‌ها",
      ADMIN_QR_SMS: "ارسال پیامک",
      MENU_PROFILE_INFO: "اطلاعات کاربر",
      MENU_PROFILE_SETTING: "تنظیمات پروفایل",
      MENU_PROFILE_ORDERS: "سفارش‌ها",
      MENU_PROFILE_ADDRESSES: "آدرس‌ها",
      QR_MONITORING: "مانیتورینگ کیوآر",
      QR_LIST: "لیست کیوآرهای من",
      QR_NAME_LIST: "مدیریت مشارکت",
      QR_GENERATE_MULTIPLE: "ساخت گروهی کیوآر کد",
      QR_CARD_VISIT: "ساخت کارت ویزیت",
      HELP_INFO: "تست دکمه",
      QR_MENU: "منو فروشگاهی",
      QR_APPOINTMENT: "نوبت‌دهی",
      QR_INSURANCE: "ساخت بیمه آنلاین",
      QR_BPAGE: "ساخت صفحه کاری",
      QR_CPAGE: "ساخت سایت مجتمع تجاری/اداری",
      QR_BSHOP: "فروشگاه آنلاین",
      QR_NAME_EDIT_BSHOP: "ویرایش فروشگاه آنلاین",
      QR_LINK_EDIT: "ویرایش لینک",
      QR_NAME_DESIGN: "ویرایش دیزاین",
      QR_NAME_SETTING: "ویرایش تنظیمات",
      QR_NAME_EDIT: "ویرایش کارت ویزیت",
      QR_NAME_EDIT_BPAGE: "ویرایش صفحه کاری",
      QR_EDIT_CPAGE: "ویرایش سایت مجتمع تجاری/اداری",
      QR_NAME_INSURANCE: "ویرایش بیمه آنلاین",
      QR_NAME_EDIT_MENU: "ویرایش منو",
      QR_NAME_EDIT_APPLICATION: "ارائه اپلیکیشن",
      QR_NAME_EDIT_APPOINTMENT: "ویرایش نوبت‌دهی",
      QR_NAME_EDIT_PHOTO: "ویرایش گالری عکس",
      QR_NAME_EDIT_VIDEO: "ویرایش گالری ویدئو",
      QR_NAME_EDIT_VOICE: "ویرایش گالری صوتی",
      QR_NAME_EDIT_FEEDBACK: "ویرایش گالری بازخورد",
      QR_NAME_CONSULTATION_QR_EDIT: "ویرایش فرم درخواست",
      QR_NAME_EDIT_VOICE_PRO: "ویرایش گالری صوتی (پرو)",
      QR_NAME_EDIT_SOCIAL: "ویرایش شبکه‌های اجتماعی",
      QR_NAME_STATISTICS: "آمار کد کیوآر",
      QR_CATE: "انتخاب دسته",
      QR_SHARE: "اشتراک‌گذاری",
      QR_BUSINESS_SHOP: "بیزینس/فروشگاه",
      QR_CO_ORGAN: "شرکتی/سازمانی",
      QR_CONTACT: "ارتباط با مشتری",
      QR_NOTICES: "اطلاع‌رسانی",
      QR_OTHERS: "متفرقه",
      QR_STATICS: "کیوآر استاتیک",
      QR_DYNAMICS: "کیوآر داینامیک",
      QR_D_BUSINESS: "کیوآر داینامیک بیزینسی",
      QR_D_ORGANS: "کیوآر داینامیک سازمانی",
      QR_D_GOVERNMENT: "کیوآر داینامیک دولتی",
      QR_VIDEO: "گالری ویدئو",
      QR_APPLICATION: "ارائه اپلیکیشن",
      QR_VOICE: "گالری صوتی",
      QR_VOICE_PRO: "گالری صوتی (پرو)",
      QR_CONSULTATION_QR: "فرم درخواست",
      QR_FEEDBACK: "گالری بازخورد",
      QR_PHOTO: "گالری عکس",
      QR_CATALOG: "کاتالوگ / بروشور",
      QR_LOCATION: "ساخت کیوآر مکان",
      QR_SOCIAL_MEDIA: "ساخت کیوآر شبکه اجتماعی",
      QR_LINK: "ساخت لینک",
      QR_TEXT: "ساخت متن",
      QR_MAIL: "ساخت ایمیل",
      QR_CALL: "تماس",
      QR_SMS: "پیامک",
      QR_WHATSAPP: "واتساپ",
      QR_SITE: "وبسایت",
      QR_INSTAGRAM: "اینستاگرام",
      QR_SKYPE: "اسکایپ",
      QR_WIFI: "وایفای",
      QR_BUSINESS: "صفحه کاری",
      QR_DISCOUNT: "صفحه تخفیف",
      QR_PRODUCT_SHOP: "معرفی محصول",
      QR_PRODUCT_LABEL: "لیبل محصول",
      QR_GOLD_LABEL: "لیبل طلا",
      QR_PRODUCT_TEMPLATE: "محصولات",
      ADMIN_CATEGORY: "دسته‌بندی‌ها",
      QR_NFC_ORDERS: "کارت NFC منتظر تأیید",
      QR_NAME_PRODUCT: "ویرایش معرفی محصول",
      QR_NAME_LABELPRODUCT: "ویرایش لیبل محصول",
      QR_NAME_GOLDPRODUCT: "ویرایش لیبل طلا",
      QR_COINS: "رمزارزها",
      QR_SHOP: "مدیریت فروشگاه",
      QR_TWITTER: "توییتر",
      UPLOAD_CENTER: "آپلود‌سنتر",
      PRICING: "تعرفه‌های کیوآر",
      QR_CREATE_MODELS: "ساخت مدل کارت ویزیت",
      QR_CREATE_BUSINESS_MODELS: "ساخت مدل صفحه کاری",
      QR_CREATE_PRODUCT_MODEL: "ساخت مدل کارت محصول",
      QR_CREATE_MENU_MODELS: "ساخت مدل منو فروشگاهی",
      QR_CREATE_SHOP_MODEL: "ساخت مدل فروشگاه آنلاین",
      MODELS_LIST: "انواع مدل‌های کیوآر",
      MODELS_LIST_EDIT: "ویرایش مدل",
      MODELS_LIST_MENU_EDIT: "ویرایش مدل منو",
      MODELS_LIST_BMODEL_EDIT: "ویرایش مدل فروشگاه آنلاین",
      NFC: "کارت‌های NFC",
      SUBMIT_FORM: "ثبت بلاگر",
      REQUEST_LIST: "لیست بلاگرها",
      PURE_DATA: "لیست کارت ویزیت‌های ساخته نشده",
      AUTO_CREATE: "ساخت اتوماتیک کیوآر",
      QR_CREATE: "ساخت کیوآر",
      HISTORY_REMINDER: "مونیتورینگ یادآوری",
      BOOK: "مونیتورینگ یادآوری"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "روش‌های پرداخت",
      ORDER_NOTIFICATIONS: "اطلاع‌رسانی سفارشات",
      DISCOUNT_CODE: "کد تخفیف",
      CART: "سبد خرید",
      TABLE_MANAGEMENT: "مدیریت میز",
    },
    ERRORS: {
      INVALID_INPUT: "مقادیر را به درستی وارد نمایید!",
      CART_SETTINGS_FAILED: "تنظیمات سبد خرید با خطا مواجه شد!",
    },
  },
  popup: {
    prepared_stores_title: "نمونه فروشگاه‌های آنلاین آماده",
  },
  buttons: {
    reset_defaults: "بازنشانی داده های پیش فرض",
    download_qr: "دانلود کیوآر",
    cleardefaults: "حذف اطلاعات پیش‌فرض",
    select_prepared_store: "انتخاب فروشگاه آنلاین آماده",
  },
  stepper: {
    create_qr: "ساخت کیوآر",
    products_info: "محصولات و اطلاعات",
    content_settings: "تنظیمات محتوا",
    sales_settings: "تنظیمات فروش",
  },
    LANGUAGE:{
    Persian:'فارسی',
    English:'انگلیسی',
  },
  fields: {
    online_store_name: "نام فروشگاه آنلاین",
    qr_address: "آدرس کیوآر",
    qr_address_hint: "آدرس کیوآر خود را وارد نمایید",
    online_sale: "فروش آنلاین",
  },
  login_settings: "تنظیمات ورود",
  shop_logo_and_images: "لوگو و تصاویر فروشگاه",
  login_page_info: "اطلاعات صفحه ورود",
  upload_banner: "آپلود بنر",
  create_product: "ایجاد محصول",
  special_sale: "فروش ویژه",
  ended: "پایان یافته",
  blog: "بلاگ",
  services: "خدمات",
  pdf_gallery: "گالری پی دی اف",
  create_section: "ایجاد بخش",
  achievements: "موفقیت های بدست آمده",
  team_members: "اعضای تیم",
  working_hours: "تایم کاری",
  saturday: "شنبه",
  sunday: "یکشنبه",
  monday: "دوشنبه",
  tuesday: "سه‌شنبه",
  wednesday: "چهارشنبه",
  thursday: "پنجشنبه",
  friday: "جمعه",
  we_will_be_different: "متفاوت خواهیم شد...",
  striving_for_excellence:
    "در مسیری درست، همیشه کوشا هستیم تا بهترین خود باشیم >>> برای شما",
  online_store_ready_15_minutes: "فروشگاه آنلاین شما 15 دقیقه ای آمادست!",
  sales_management: "مدیریت فروش",
  dear_customer_online_stores:
    "مشتری عزیز شما می توانید از سایر فروشگاه های آنلاین ما نیز خرید کنید:",
  divar_site: "سایت دیوار",
  digikala_site: "سایت دیجی کالا",
  basalam_site: "سایت باسلام",
  torob_site: "سایت ترب",
  emalls_site: "سایت ایمالز",
  copyright_qrland: "تمامی حقوق این سایت متعلق به کیوآر لند می باشد.",
  tehran_address:
    "تهران، خیابان شریعتی، بعد از پل سید خندان، بن بست خندان، پلاک 6",
  our_achievements: "دستاوردهای مجموعه ما",
  customer_satisfaction: "رضایت مشتریان",
  lowest_returns: "کمترین بازگشتی",
  loyal_customer: "مشتری وفادار",
  shipped_orders: "سفارش ارسال شده",
  visit_our_videos: "از ویدئوهای مجموعه ما دیدن فرمایید.",
  bringing_the_best: "بهترین ها را برای شما به ارمغان آورده ایم...",
  feedback_important: "بازخورد شما برای ما مهم است",
  guide_us_with_feedback:
    "لطفا با پاسخ گویی به سوالات زیر ما را در خدمات بهتر راهنمایی فرمایید.",
  satisfied_with_quality: "آیا از کیفیت کالاها رضایت داشتید؟",
  evaluate_packaging_quality: "کیفیت بسته بندی را چگونه ارزیابی می کنید؟",
  satisfied_with_variety: "آیا از تنوع کالاها راضی بودید؟",
  benefited_from_discounts: "آیا از تخفیفات این فروشگاه هم بهره‌مند شده‌اید؟",
  post_1: "پست 1",
  fast_order_delivery: "ارسال سریع سفارش",
  post_2: "پست 2",
  cash_on_delivery: "امکان پرداخت در محل",
  post_3: "پست 3",
  product_authenticity_guarantee: "ضمانت اصالت کالا",
  comfortable_purchase: "یک خرید راحت",
  how_to_place_order: "چطوری می‌تونم سفارش خودم رو ثبت کنم؟",
  add_to_cart: "کافیست محصولات مورد نظر خود را به سبد خرید اضافه کنید.",
  how_to_register: "چگونه می‌توانم در سایت ثبت‌نام کنم؟",
  click_login_and_enter_code:
    'کافیست بر روی دکمه "ورود" کلیک کنید و پس از وارد کردن شماره همراه، کد پیامک شده را نیز وارد کنید.',
  delivery_time: "پس از اینکه سفارشم رو ثبت کردم چقدر طول می‌کشه به دستم برسه؟",
  fastest_delivery: "در سریع‌ترین زمان ممکن سفارش شما ارسال خواهد شد.",
  shipping_cost: "هزینه ارسال سفارش چقدر هست؟",
  shipping_cost_order: "هزینه ارسال سفارش",
  variable_shipping_cost: "هزینه ارسال سفارش نسبت به آدرس شما متغیر خواهد بود.",
  change_or_cancel_order:
    "آیا می‌تونم بعد از ثبت سفارش، محصولمو تغییر بدم یا کنسل کنم؟",
  no_change_or_cancel: "خیر.\nامکان تغییر یا لغو وجود ندارد.",
  mrs_Safdarian: "خانم صفدریان",
  invalid_address: "آدرس وارد شده صحیح نمی‌باشد!",
  shop_page_created_success: "صفحه فروشگاهی شما با موفقیت ساخته شد.",
  qr_creation_failed: "ساخت کیوآر با خطا روبرو شد!",
  server_error: "خطای سرور!",
  qr_card_updated_success: "کیوآر شما باموفقیت ویرایش شد.",
  qr_save_edit_failed: "خطا در ذخیره/ویرایش کیوآر",
  your_feedback: "بازخورد شما",
  digital_marketing_strategy:
    "با استراتژیست بازاریابی دیجیتال ما، شرکت خود را در مسیر درست قرار دهید",
  wait_for_default_products:
    "لطفا صبور باشید تا محصولات پیشفرض به صورت کامل در سایت شما بارگذاری شود.",
  template_categories_saved: "دسته‌بندی‌های مدل نمونه با موفقیت ذخیره شدند.",
  template_products_saved: "محصولات مدل نمونه با موفقیت ذخیره شدند.",
  template_products_save_failed: "خطا در ذخیره سازی محصولات مدل نمونه!",
  template_categories_save_failed: "خطا در ذخیره سازی دسته‌بندی‌های مدل نمونه!",
  login_page_text: "متن صفحه ورود",
  persian_error: "متن باید فارسی باشد",
  number_error: "داده ورودی نباید غیر عدد یا خالی باشد",
  english_error: "متن نباید غیر انگلیسی یا خالی باشد",
  mixPerEng_error: "متن نباید غیر انگلیسی یا غیر فارسی یا خالی باشد",
  email_error: "فرمت ایمیل وارد شده صحیح نمی باشد",
  mobile_error: "فرمت شماره وارد شده صحیح نمی باشد",
  meliCode_error: "فرمت کد ملی وارد شده صحیح نمی باشد",
  site_error: "فرمت سایت وارد شده صحیح نمی باشد",
  min_length_error: "مقدار ورودی نمی‌تواند از {{min}} کمتر باشد",
  max_length_error: "مقدار ورودی نمی‌تواند بیشتر از {{max}} باشد",
  form_submitted_message: "فرم شما با موفقیت ارسال شد",
  required_fields_error: "مقادیر اجباری وارد نشده است",
  headphone_title: "هدفون",
  buy_button: "خریدن",
  day: "روز",
  hour: "ساعت",
  minute: "دقیقه",
  second: "ثانیه",
  required_field_error: "{{fieldName}} اجباری می‌باشد",
  submit_request_button: "ثبت درخواست",
  request_submitted_success: "درخواست شما با موفقیت ثبت شد",
  feedback_submitted_success: "بازخورد شما با موفقیت ثبت شد",
  description_required_label: "توضیحات (اجباری)",
  description_optional_label: "توضیحات (اختیاری)",
  description_hint:
    "لطفا توضیحات مورد نظر خود را در این فیلد وارد نمایید (حداقل 3 کاراکتر)",
  footer: {
    position: "سمت",
    contactUs: "تماس با ما",
    aboutUs: "درباره ما",
    firstShift: "شیفت اول",
    secondShift: "شیفت دوم",
    startTime: "ساعت شروع",
    endTime: "ساعت پایان",
    features: "امکانات",
    partners: "همکاران",
    affiliates: "برنامه های وابسته",
    panels: "پنل ها",
    supportTicket: "تیکت پشتیبانی",
    inPersonServices: "خدمات حضوری",
    liveChat: "ارتباط زنده",
    faq: "سوالات متداول",
    add_secondshift: "افزودن شیفت دوم",
    firstDate: "تاریخ شروع",
    endDate: "تاریخ پایان",
  },
  qr_management: "QR مدیریت",
  restore_default_questions: "بازگشت سوال‌های پیش‌فرض",
  delete_all: "حذف همه",
  edit_question: "ویرایش سوال",
  move_up: "بالا",
  move_down: "پایین",
  delete: "حذف",
  selected_question: "سوال انتخابی",
  question: "سوال",
  answer_type: "نوع پاسخ",
  excellent: "عالی",
  good: "خوب",
  very_poor: "خیلی ضعیف",
  response_optionality: "اختیاری / اجباری بودن پاسخ",
  required: "اجباری",
  optional: "اختیاری",
  add_new_question: "افزودن سوال جدید",
  satisfied_with_quality: "آیا از کیفیت کالاها رضایت داشتید؟",
  evaluate_packaging_quality: "کیفیت بسته‌بندی را چگونه ارزیابی می‌کنید؟",
  satisfied_with_variety: "آیا از تنوع کالاها راضی بودید؟",
  benefited_from_discounts: "آیا از تخفیفات این فروشگاه بهره‌مند شده‌اید؟",
  suggestions_for_improvement:
    "برای بهبود تجربه خرید از این فروشگاه چه پیشنهادی دارید؟",
  confirm_delete_question: "حذف سوال انتخاب شده؟",
  question_deleted_success: "سوال با موفقیت حذف شد.",
  question_delete_failed: "خطا در حذف سوال!",
  confirm_delete_all_questions:
    "آیا مطمئن هستید که می‌خواهید همه سوالات را حذف کنید؟",
  questions_deleted_success: "سوالات با موفقیت حذف شد.",
  questions_delete_failed: "خطا در حذف سوالات!",
  invalid_input: "مقادیر را به درستی وارد نمایید!",
  operation_failed: "عملیات با خطا مواجه شد!",
  question_number: "سوال {number}؟",
  card_subtitle:
    "کافیست داستان تصویر مورد نظر خود را وارد نمایید، تا هوش مصنوعی آن را برای شما خلق کند.",
  upgrade_label: "الصاق",
  free: " - رایگان",
  language_select: "انتخاب زبان برای نوشتن متن درخواست",
  image_size: "سایز تصویر",
  prompt_label: "متن درخواست",
  prompt_placeholder: "تصویر مورد نظر خود را شرح دهید...",
  generate_image: "ساخت تصویر",
  regenerate_image: "ساخت تصویر جدید",
  save_image: "ذخیره تصویر",
  save_image_subtitle: "فقط تصویر نمایش داده شده در بالا ذخیره خواهد شد.",
  size_items: {
    "16:9": "16:9 (افقی)",
    "9:16": "9:16 (عمودی)",
    "1:1": "1:1 (مربع)",
  },
  lang_items: {
    fa: "Fa | فارسی",
    en: "En | انگلیسی",
    ar: "Ar | عربی",
  },
  rules: {
    empty: "حداقل ۳ کاراکتر باید وارد شود!",
    spell_checker: "متن وارد شده باید به زبان {language} باشد!",
  },
  ERRORS: {
    VpnDetectedTitle: "VPN خود را خاموش کنید",
    VpnDetectedSubtitle:
      "این کار باعث می‌شود سامانه بهتر عمل کند و شما تجربه بهتری داشته باشید.",
  },
  errors: {
    VpnDetectedTitle: "VPN خود را خاموش کنید",
    VpnDetectedSubtitle:
      "این کار باعث می‌شود سامانه بهتر عمل کند و شما تجربه بهتری داشته باشید.",
    invalid_size: "لطفا عرض و ارتفاع را به درستی وارد نمایید!",
    image_generation_error: "خطا در خلق تصویر",
    image_upload_error: "خطای آپلود تصویر!",
    service_unavailable:
      "امکان استفاده از این سرویس نیست - بارگذاری داده از سرور با خطا مواجه شد",
    qr_address_taken: "این آدرس کیوآر قبلاً ثبت شده است",
  },

  add_working_time: "افزودن تایم کاری",
  selected_day: "روز انتخابی",
  range_name: "نام بازه زمانی",
  add: "افزودن",
  first_shift: "شیفت اول",
  second_shift: "شیفت دوم",
  start_time: "زمان شروع",
  end_time: "زمان پایان",
  date_range: "بازه زمانی",
  all_week_days: "همه‌ی روزهای هفته",
  saturday_to_wednesday: "شنبه تا چهارشنبه",
  saturday_to_thursday: "شنبه تا پنجشنبه",
  work_week: "همه‌ی روزهای هفته(به جز روزهای تعطیل)",
  // saturday: "شنبه",
  // sunday: "یکشنبه",
  // monday: "دوشنبه",
  // tuesday: "سه‌شنبه",
  // wednesday: "چهارشنبه",
  // thursday: "پنجشنبه",
  // friday: "جمعه",
  feedbacks: "بازخوردها",
  failed_retrieve_feedback: "دریافت بازخوردها با خطا مواجه شد!",
  province: "استان",
  search_city_placeholder: "نام شهر مورد نظر را جستجو کنید.",
  search_city_label: "جستجوی شهر",
  welcome: "به برنامه ما خوش آمدید",
  description: "این یک برنامه چندزبانه است.",
  soon: "به زودی",
  beta_version: "نسخه آزمایشی",
  defaults_cleared_success: "داده‌های پیش فرض با موفقیت پاک شدند",
  defaults_reset_success: "داده های پیش فرض با موفقیت بازنشانی شدند",

  select_navigator_after_location_click:
    "پس از کلیک بر روی لوکیشن مسیریاب خود را انتخاب کنید",
  no_address_selected: "آدرسی انتخاب نشده است",
  no_location_selected: "موقعیتی انتخاب نشده است",
  region: "منطقه",
  api_unauthorized: "خطای احراز هویت: کلید API نامعتبر است",
  location_not_found: "موقعیت یافت نشد",
  addCategory: "افزودن دسته جدید",
  editCategory: "ویرایش دسته‌بندی",
  deleteCategory: "حذف دسته‌بندی انتخاب شده؟",
  addProduct: "افزودن محصول جدید",
  saveProducts: "انتخاب محصصولات پیشفرض",
  addSubCategory: "افزودن زیردسته",
  product: "محصول",
  categoryName: "نام دسته",
  subCategoryName: "نام زیر دسته",
  confirmDeleteProduct: "آیا از حذف محصول از دسته بندی اطمینان دارید؟",
  successMessages: {
    categorySaved: "دسته‌بندی‌ها با موفیت ذخیره شدند.",
    productSaved: "محصولات با موفیت ذخیره شدند.",
    productDeleted: "محصول با موفقیت حذف شد.",
  },
  errorMessages: {
    saveCategoryFailed: "خطا در ذخیره سازی دسته‌بندی‌ها!",
    saveProductFailed: "خطا در ذخیره سازی محصولات!",
    deleteCategoryFailed: "خطا در حذف دسته‌بندی!",
  },
  add_edit_categories: "ویرایش/افزودن دسته بندی",
  copy_category: "کپی دسته‌بندی",
  product: "محصول {point}",
  copy_product: "کپی محصول",
  add_edit_products: "افزودن/ ویرایش محصولات",
  copy_category: "کپی دسته‌بندی",
  edit_category: "ویرایش دسته‌بندی",
  category_name: "نام دسته‌بندی",
  edit_subcategory: "ویرایش زیرمجموعه",
  subcategory_name: "نام زیرمجموعه",
  add_new_category: "افزودن دسته‌بندی جدید",
  store_management: "مدیریت فروشگاه",
  manage_products: "مدیریت محصولات",
  products_export: "دانلود محصولات",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "آپلود فایل اکسل",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1":
    "فایل اکسل خود را بکشید و اینجا رها کنید یا",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "انتخاب کنید",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "برای آپلود",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE": "لطفاً فقط فایل اکسل (.xlsx) آپلود کنید",
  "GENERAL.SUBMIT": "ارسال",
  "GENERAL.CANCEL": "لغو",
  "GENERAL.SUCCESSFULLY_ADDED": "محصولات با موفقیت آپلود شد",
  SUCCESSFULLY_DOWNLOADED: "محصولات با موفقیت دانلود شد",
  "GENERAL.ERROR": "خطایی رخ داد",
  EditSubCategoty: "ویرایش زیر دسته",
  create: "ُساخت",
  save_changes: "ذخیره تغییرات",
  buy_button_settings: "تنظیمات دکمه خرید",
  image: "تصویر",
  color: "رنگ",
  title: "عنوان",
  price: "قیمت",
  discount: "تخفیف",
  percent: "درصد",
  amount: "مبلغ",
  brand: "برند",
  inventory: "تعداد موجودی",
  inventory_hint: "خالی بودن فیلد، به معنای سفارش نامحدود است",
  order_limit: "حداکثر تعداد در هر سفارش",
  order_limit_hint: "خالی بودن فیلد، به معنای بدون محدودیت.",
  packing_price: "هزینه بسته بندی",
  packing_price_hint:
    "چنانچه مشتری سفارش بیرون بر(ارسال با پیک/مراجعه حضوری) انتخاب کرده باشد, اعمال میگردد.",
  description: "توضیحات",
  options: "آپشن‌ها",
  product_features: "ویژگی‌های محصول",
  field_required: "فیلد الزامی میباشد.",
  min_length: "حداقل طول فیلد ۳ حرف میباشد.",
  product: "محصول",
  default_brand: "اپل",
  product_added_success: "محصول با موفیت اضافه شد",
  product_added_error: "خطا در اضافه کردن محصول",
  whole_categories: "(همه دسته‌بندی‌ها)",
  add_select_category: "افزودن/انتخاب دسته‌بندی",
  select_default_category: "انتخاب دسته پیشفرض",
  deleted_product: "حذف محصول",
  confirm_delete_prooduct: "آیا  حذف محصول از دسته بندی اطمینان دارید‌ ؟",
  please_wait_store_product: "درحال ذخیره سازی محصولات، لطفا صبر کنید...",
  saved_product_success: "محصولات با موفقیت ذخیره شدند.",
  error_in_store: "خطا در ذخیره",
  delete_category: "حذف دسته‌بندی",
  confirm_delete_category: "دسته‌بندی با موفقیت حذف شد.",
  error_delete_category: "خطا در حذف دسته‌بندی!",
  productOptionEditor: {
    tabs: {
      color: "رنگ",
      size: "سایز",
      count: "تعداد",
      weight: "وزن",
      type: "جنس/نوع",
    },
    fields: {
      count: "تعداد",
      max_order: "حداکثر تعداد سفارش",
      price: "قیمت",
      discount: "تخفیف",
      color: "رنگ",
      color_name: "نام رنگ",
      inventory: "تعداد موجودی",
      size: "سایز",
      type: "جنس/نوع",
      weight: "وزن",
    },
    actions: {
      delete: "حذف",
      add_location: "افزودن گزینه",
    },
  },
  extraSubProducts: {
    feature: "ویژگی",
    name_label: "نام",
    name_placeholder: "مثال: سس اضافه/نان اضافه",
    price_label: "قیمت",
    price_hint: "خالی بودن فیلد، به معنای رایگان بودن زیرمحصول است.",
    price_placeholder: "مثال: آب، نوع (مثل نوع مرغ پخته شده: سینه/ران)",
    add_subproduct: "افزودن زیر محصول",
  },
  error_selected_category: "خطا در انتخاب دسته‌بندی!",
  suggestinput: {
    title: "انتخاب ایموجی",
    aboutUs: "درباره ما",
    error: "خطا",
    errorMessage: "لطفا کیف پول خود را شارژ کنید و مجدد امتحان کنید.",
    generateText: "پیشنهاد هوش مصنوعی",
    emoji: "ایموجی",
    errorMessage_400:
      "ایجاد متن درباره ما با مشکل مواجه شد. لطفا مجدد تلاش کنید.",
    errorMessage_403:
      "ساخت متن درباره ما با مشکل مواجه شد، لطفا پکیج خریداری کنید مجدد تلاش کنید",
  },
  togetherai: {
    buy_package: "خرید بسته",
    tax_notice: "به مبلغ بسته خریداری شده ۱۰ درصد مالیات افزوده می‌شود!",
    package: "بسته",
    rial: "﷼",
    buy_button: "خرید می‌کنم!",
    discount_label: "کد تخفیف",
    submit_discount: "ثبت",
    success_message: "کیوآر شما با موفقیت ارتقا پیدا کرد.",
    error_insufficient_funds:
      "لطفا موجودی حساب خود را بررسی بفرمایید و بعدا، مجدد تلاش کنید.",
    error_upgrade: "خطا در تمدید کیوآر!",
    error_title: "خطا",
    success_title: "موفقیت",
  },
  category_not_found: "دسته‌بندی یافت نشد!",
  create_upload_category: "ایجاد دسته‌بندی و آپلود",
  add_subcategory: "افزودن زیر دسته‌بندی",
  error_upload_m_video: "خطا در بارگذاری ویدئو (ممکن است دسترسی محدود باشد).",
  info_show_video: "برای مشاهده ویدئو بیشتر بر روی بیشتر کلیک کنید.",
  error_not_valid_guide_id: "شناسه راهنما نامعتبر است!",
  error_give_guide_info: "خطا در دریافت اطلاعات اموزش!",
  info_success_saved: "با موفقیت ذخیره شد",
  error_add_new_guide: "خطا در افزودن راهنمای جدید",
  popup: {
    details: "جزئیات",
    guide_images: "عکس‌های راهنما",
    guide_videos: "ویدئوهای راهنما",
    faq: "سوالات متداول",
    no_title: "بدون عنوان",
    no_content: "محتوایی برای نمایش وجود ندارد",
    no_questions: "سوالی برای نمایش وجود ندارد",
    video_error: "خطا در بارگذاری ویدئو (ممکن است دسترسی محدود باشد)",
    no_answer: "پاسخ موجود نیست",
    question_no_title: "سوال بدون عنوان",
    default_title: "راهنما",
  },
  productPicker: {
    select_default_product: "انتخاب محصول پیش‌فرض",
    search: "جستجو",
    select_all_products: "انتخاب همه محصولات",
    back: "بازگشت",
    no_products_in_category: "محصولی در این دسته‌بندی وجود ندارد!",
    products_error: "خطا در دریافت محصولات!",
    retry: "تلاش مجدد",
    items_per_page: "تعداد نمایش",
    root_breadcrumb: "/",
  },
  end_date: "تاریخ اتمام",
  filters: {
    userType: {
      legal: "حقوقی",
      individual: "حقیقی",
    },
    serviceType: {
      Payamakland: "پیامک‌لند",
      Coreland: "کُرلند",
      Qrland: "کیوآرلند",
      Robotland: "ربات‌لند",
      billboard: "بیلبورد",
      tablighNegar: "تبلیغ‌نگار",
      unknown: "ناشناخته",
    },
    qrType: {
      attendanceqr:"حضور و غیاب",
      eitaa:'ایتا',
      bale:'بله',
      robika:'روبیکا',
      gift: 'قاب خاطره ها',
      instagram: "اینستاگرام",
      visitCard: "کارت ویزیت",
      Business: "سایت شخصی/ شرکتی",
      Commericial: "سایت مجتمع تجاری/اداری",
      qrlink: "لینک کیوآر",
      labelproduct: "لیبل محصول",
      goldLabel: "لیبل طلا",
      bShop: "فروشگاه",
      SocialMedia: "شبکه‌های اجتماعی",
      VideoGallery: "گالری ویدئو",
      PhotoGallery: "گالری عکس",
      voiceGallery: "گالری صوتی",
      consultationQr: "فرم درخواست",
      application: "اپلیکیشن",
      feedbackGallery: "فیدبک (بازخورد)",
      voiceGalleryPro: "گالری صوتی حرفه‌ای",
      singleProduct: "معرفی محصول",
      menu: "منو",
      appointment: "نوبت دهی",
      insurance: "بیمه",
      text: "متن",
      luck_wheel: "گردونه شانس",
      pdfgallery: "گالری پی دی اف",
      productpro: "معرفی محصول پرو",
      multicard: "مولتی کارت",
      catalog: "کاتالوگ",
      visitCard_pro:"کارت ویزیت پرو",
      clickyarseo:"کیوار کلیک یار سئو",
    },
    expire: {
      day: "روز",
      expired: "منقضی شده",
    },
    numericPersianNumber: {
      thousand: "هزار",
      million: "میلیون",
    },
    dateString: {
      at: "در",
    },
    messages: {
      pleaseLogin: "لطفاً وارد شوید",
      invalidPhone: "شماره تلفن نامعتبر است",
      copied: "کپی شد",
      createError: "خطا در ایجاد کاربر",
      userCreated: "کاربر با موفقیت ایجاد شد",
      fillAllFields: "تمام فیلدها را پر کنید",
      registerUpdated: "وضعیت ثبت نام آنلاین به‌روزرسانی شد",
      registerUpdateError: "خطا در به‌روزرسانی وضعیت ثبت نام آنلاین",
    },
  },
  nextButton: "بعدی",
  previousButton: "قبلی",
  rowsPerPageText: "تعداد در صفحه",
  noDataText: "داده ای برای نمایش وجود ندارد",
  placeholderSearch: "جستجو کنید..",
  set_qr: "QR ثبت شده",
  numbers: "شماره‌ها",
  enter_param_product: "مشخصات محصولات را به درستی وارد نمایید!",
  instagram_hint: "لطفا اینستاگرام خود را وارد کنید",
  whatsapp_hint: "لطفا واتس آپ  خود را وارد کنید",
  telegram: "تلگرام",
  telegram_hint: "لطفا تلگرام خود را وارد کنید",
  userpicker: {
    select_user: "انتخاب کاربر",
    choice_users: "انتخاب کاربران",
    id: "شناسه",
    phone_number: "شماره همراه",
    date_created: "تاریخ ثبت نام",
    info_edit: "ویرایش اطلاعات",
    name_family: "نام و نام خانوادگی",
    position: "پست و مقام",
    phone: "شماره تماس",
    discription: "توضیحات",
  },
  search_product: "جستجو محصول",
  search_name_product: "نام محصول را جستجو کنید",
  search_name_product: "جستجوی نام محصول",
  search_product: "جستجوی محصول",
  currency: "﷼",
  headers: {
    index: "ردیف",
    gallery: "تصویر",
    id: "شناسه",
    name: "نام",
    brand: "برند",
    price: "مبلغ",
    discount_amount: "تخفیف",
  },
  search_categories: "جستجو در دسته‌بندی",
  search_categories: "جستجوی ",
  delete_all: "حذف همه",
  select_category: "انتخاب دسته‌بندی",
  currency1: "IRR", // واحد پول ایران (ریال)
  features: "ویژگی ها",
  product_sp: {
    edit: "ویرایش",
    back: "بازگشت",
    save: "ذخیره",
    add_product_to_special_category:
      "لطفا فیلدهای زیر را برای افزودن محصول به دسته‌بندی ویژه تکمیل نمایید",
    inventory: "موجودی",
    discount: "تخفیف",
    max_per_customer: "تعداد قابل خرید برای هر مشتری",
    max_per_order: "تعداد قابل خرید در هر سبد خرید",
    expires_at: "تاریخ اتمام",
    field_cannot_be_empty: "فیلد نمی‌تواند خالی باشد.",
    please_enter_correctly: "لطفا فیلدها را به درستی وارد نمایید!",
    currency: "IRR", // واحد پول ایران (ریال)
  },
  selectproduct: "انتخاب محصول",
  section: {
    edit_part: "ویرایش بخش",
    title: "عنوان",
    position_text: "جایگاه متن",
    add_video: "افزودن فیلم",
    text: "متن",
    address_video: "آدرس ویدئو",
    position_left: "جایگاه چپ",
    position_right: "جایگاه راست",
    tab_edit_button: "ویرایش دکمه",
    tab_content: "محتوای بخش",
  },
  name_shopping: "نام فروشگاه",
  hint_shopping: "لطفا نام فروشگاه خود را وارد کنید.",
  title_discount: "عنوان تخفیف",
  hint_discount: "عنوان تخفیف خود را وارد کنید.",
  hint_mount_discount: " 20٪ تخفیف برای سفارش بعدی خود دریافت کنید.",
  label_discount: "میزان تخفیف خود رو وارد کنید",
  give_discount: "گرفتن کد تخفیف",
  give_copon: "کوپن بگیرید",
  enter_copon: "وارد کردن کوپن",
  hint_phone: "لطفا شماره تلفن خود را وارد کنید.",
  label_phone: "شماره تلفن",
  hint_condition_discount: "شرایط تخفیف خود را توضیح دهید..",
  label_discription_discount: "توضیحات تخفیف",
  add_info_discount: "اطلاعات بیشتر مورد نظر خود را اضافه نمایید:",
  enter_address_discount: "لطفا ادرس  خود را وارد کنید.",
  address_discount: "آدرس",
  edit_feedback: "ویرایش بازخورد",
  select_type_replay: "انتخاب نوع پاسخ",
  field_discription: "فیلد توضیحات",
  messages_discription:
    "با فعال کردن این گزینه، فیلدی جهت توضیحات برای کاربر نمایش داده خواهد شد",
  number_char: "تعداد کاراکتر باید بین 3 تا 50 عدد باشد!",
  search: "جستجو",
  no_videos_found: "ویدئویی پیدا نشد!",
  upload_video_prompt: "برای افزودن فایل از قسمت آپلود ویدئو استفاده نمایید",
  delete_success: "با موفقیت حذف شد.",
  tabs: {
    qr_view: "مشاهده QR",
    preview: "پیش نمایش",
    ready_video: "ویدئو آماده",
    video_gallery: "گالری ویدئو",
    link: "لینک",
    video_upload: "آپلود ویدئو",
  },
  consultation: {
    name: "نام",
    surname: "نام‌خانوادگی",
    phone: "شماره موبایل",
    nationalId: "کدملی",
    nationalIdAuthenticate: "احراز‌هویت کدملی",
    nationalIdCorrect: "بررسی صحت کدملی",
    mail: "ایمیل",
    address: "آدرس",
    location: "لوکیشن",
    custom: "کشویی",
    customLabel: "عنوان",
    customOptions: "گزینه‌ها",
    optional: "اختیاری",
    require: "اجباری",
    description: "توضیحات",
  },
  add_section: "اضافه کردن بخش",
  add_new_text_section: "شما به سرزمین هوشمند دیجیتالی کیوآر لند دعوت شده اید.",
  btn_title_section: "ثبت نام رایگان",
  shop: {
    step_products_and_info: "محصولات و اطلاعات",
    online_store_name: "نام فروشگاه آنلاین",
    qr_address: "آدرس کیوآر",
    qr_address_hint: "آدرس کیوآر خود را وارد نمایید",
    online_sale: "فروش آنلاین",
    step_content_settings: "تنظیمات محتوا",
    step_sale_settings: "تنظیمات فروش",
    download_qr: "دانلود کیوآر",
    login_settings: "تنظیمات ورود",
    store_logo_images: "لوگو و تصاویر مجموعه",
    login_page_info: "اطلاعات صفحه ورود",
    upload_banner: "آپلود بنر",
    user_info: "اطلاعات کاربری",
    create_product: "ایجاد محصول",
    special_sale: "فروش ویژه",
    add_social_media: "افزودن شبکه های اجتماعی",
    blog: "بلاگ",
    services: "خدمات",
    faq: "سوالات متداول",
    photo_gallery: "گالری عکس",
    video_gallery: "گالری ویدئو",
    pdf_gallery: "گالری پی دی اف",
    feedback: "بازخورد",
    countdown: "شمارنده معکوس",
    request_form: "فرم درخواست",
    create_section: "ایجاد بخش",
    achievements: "موفقیت های بدست آمده",
    team_members: "اعضای تیم",
    working_hours: "تایم کاری",
    error_saving_content: "خطا در ذخیره تنظیمات محتوا!",
    success_edit_store: "صفحه فروشگاهی با موفقیت ویرایش شد.",
    post_1: "پست 1",
    logo: "لوگو",
    background_image: "تصویر پس‌زمینه",
  },
  discount_obj: {
    quantity:"تعداد",
    create_edit_code: "ایجاد/ویرایش کد تخفیف",
    coding_type_label: "ایجاد به صورت",
    coding_type_single: "تکی",
    coding_type_group: "گروهی",
    status_label: "وضعیت",
    status_active: "فعال",
    status_deactivate: "غیرفعال",
    discount_code: "کد تخفیف",
    discount_type: "نوع تخفیف",
    discount_type_percent: "درصد",
    discount_type_fixed: "مبلغ",
    discount_value: "مقدار تخفیف",
    discount_limit: "محدودیت تخفیف",
    no_limit: "بدون محدودیت",
    tab_create_discount: "ایجاد کد تخفیف",
    tab_settings: "تنظیمات",
    success_create: "کد تخفیف شما با موفقیت ساخته شد",
    success_edit: "کد تخفیف شما با موفقیت ویرایش شد",
    error_value_empty: "مقدار تخفیف نمی‌تواند خالی باشد!",
    error_start_time: "زمان شروع طرح را انتخاب نکرده‌اید!",
    error_end_time: "زمان پایان طرح را انتخاب نکرده‌اید!",
    error_same_time: "زمان شروع و پایان طرح نمی‌تواند یکسان باشد",
  },
  personnel: {
    team_members: "اعضای تیم انتخابی",
    add_team_member: "افزودن اعضای تیم",
    default_position: "پست و مقام",
    default_phone: "شماره تماس",
    default_full_name: "نام و نام‌خانوادگی",
    default_description:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است",
  },
  discount_settings: {
    function_type: {
      title: "نوع عملکرد تخفیف",
      all_shopping_cart: "کل مبلغ سبد خرید",
      special_products: "محصولات خاص",
      special_categories: "دسته‌بندی خاص",
    },
    basket_condition: {
      title: "شرایط سبد خرید",
      no_conditions: "بدون محدودیت",
      minimum_shopping: "حداقل مبلغ سبد خرید",
      minimum_product: "حداقل تعداد محصولات در سبد خرید",
      maximum_shopping: "حداکثر مبلغ سبد خرید",
      maximum_product: "حداکثر تعداد محصولات در سبد خرید",
    },
    user_settings: {
      title: "تنظیمات کاربران",
      all_user: "همه کاربران",
      group: "گروهی از کاربران",
      special: "کاربران خاص",
    },
    limitation_use: {
      title: "محدودیت استفاده",
      no_limitations: "بدون محدودیت",
      discount_code: "تعداد استفاده از کد تخفیف",
      user: "تعداد استفاده برای هر کاربر",
    },
    start_time: {
      title: "تاریخ شروع تخفیف",
      no_time_selected: "زمانی برای شروع انتخاب نشده است",
    },
    end_time: {
      title: "تاریخ پایان تخفیف",
      no_time_selected: "زمانی برای پایان انتخاب نشده است",
    },
  },
  counterService: {
    typeLabel: "نوع نمایش",
    number: "عدد",
    percent: "درصد",
    iconLabel: "ایکن",
    counterLabel: "مقدار",
    linkLabel: "لینک",
    nameLabel: "عنوان",
    addButton: "افزودن موفقیت به دست‌آمده",
    successful: {
      added: "آیتم با موفقیت اضافه شد",
      removed: "آیتم با موفقیت حذف شد",
      movedUp: "آیتم با موفقیت به بالا منتقل شد",
      movedDown: "آیتم با موفقیت به پایین منتقل شد",
    },
  },
  qrUsersList: {
    messages: {
      createError: "خطا در ایجاد کاربر",
      userCreated: "کاربر با موفقیت ایجاد شد",
      fillAllFields: "تمام فیلدها را پر کنید",
      registerUpdated: "وضعیت ثبت نام آنلاین به‌روزرسانی شد",
      registerUpdateError: "خطا در به‌روزرسانی وضعیت ثبت نام آنلاین",
    },
    hasAssistantsMobile_hint: "انتخاب موبایل",
    invalidPhone: "شماره موبایل وارد شده معتبر نیست",
    validation: {
      nameRequired: "وارد کردن نام الزامی است",
      nameMinLength: "نام باید حداقل ۲ کاراکتر باشد",
      familyRequired: "وارد کردن نام خانوادگی الزامی است",
      familyMinLength: "نام خانوادگی باید حداقل ۲ کاراکتر باشد",
    },
    addUser: "افزودن کاربر",
    registerOnline: "فعال‌سازی ثبت نام آنلاین",
    customersList: "لیست مشتریان",
    orders: "سفارشات",
    addresses: "آدرس‌ها",
    usersColumns: {
      id: "شناسه",
      name: "نام",
      family: "نام خانوادگی",
      mobile: "شماره همراه",
      subscriptionId: "شماره اشتراک",
      ordersCount: "تعداد سفارش",
      lastLogin: "آخرین ورود",
      status: "وضعیت",
      activeUser: "کاربر فعال",
      none: "کاربر غیر فعال",
      actions: "عملیات",
      buttons: {
        info: "اطلاعات مشتری",
        sendSms: "ارسال پیامک",
        history: "تاریخچه",
        addresses: "آدرس‌ها",
        orders: "سفارشات",
      },
    },
    orderColumns: {
      orderId: "شماره سفارش",
      customerName: "نام مشتری",
      mobile: "شماره همراه",
      paymentMethod: "روش پرداخت",
      shippingMethod: "روش دریافت",
      orderAmount: "مبلغ سفارش",
      orderTime: "زمان سفارش",
      status: "وضعیت",
      currency: "ریال",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "عنوان آدرس",
      name: "نام",
      family: "نام خانوادگی",
      mobile: "شماره تماس",
      address: "آدرس",
      zipCode: "کد پستی",
      number: "پلاک",
      unit: "واحد",
    },
    shippingType: {
      courier: "ارسال با پیک",
      reservation: "رزرو میز",
      place: "دریافت حضوری",
      none: "-",
    },
    paymentType: {
      online: "پرداخت آنلاین",
    },
    perPage: "تعداد در صفحه",
    search: "جستجو",
    sortColumn: "مرتب‌سازی بر اساس",
    sortDirection: "جهت مرتب‌سازی",
    sortDirectionDesc: "نزولی",
    sortDirectionAsc: "صعودی",
    noStatus: "وضعیتی یافت نشد",
    status: {
      all: "همه",
      active: "فعال",
      inactive: "غیرفعال",
    },
    fetchError: "خطا در دریافت اطلاعات کاربران",
  },
  listCardHeader: {
    clear_filters: "حذف فیلترها",
    group_qr_renewal: "تمدید گروهی کیوآر",
    select_desired_duration: "مدت زمان مورد نظر خود را انتخاب نمایید",
    total_count: "تعداد کل",
    final_amount: "مبلغ نهایی",
    ten_percent_vat_will_be_added:
      "ده درصد مالیات بر ارزش افزوده اضافه خواهد شد",
    pay_and_upgrade: "پرداخت و ارتقا",
    no_tariff_for_this_period: "تعرفه‌ای برای این دوره وجود ندارد",
    one_month_renewal: "تمدید یکماهه",
    three_month_renewal: "تمدید سه‌ماهه",
    six_month_renewal: "تمدید شش‌ماهه",
    one_year_renewal: "تمدید یکساله",
    selected: "انتخاب شده",
    view: "مشاهده",
    details: "جزییات",
    total_amount: "مبلغ کل",
    discount: "تخفیف",
    final_amount_with_discount: "مبلغ نهایی با تخفیف",
    add_qr: "افزودن کیوآر",
    select_all: "انتخاب همه",
    actions: "عملیات",
    filter: "فیلتر",
    type_filter: "فیلتر نوع",
    start_from: "شروع از",
    search: "جستجو",
    id_search: "جست جو در شناسه",
    filter_user: "فیلتر کاربر",
    sort: "مرتب‌سازی",
    send_sms: "ارسال پیامک",
    selected_pattern: "پترن انتخاب شده:",
    send: "ارسال",
    newest: "جدید ترین",
    oldest: "قدیمی ترین",
    most_visited: "پربازدیدترن",
    least_visited: "کم بازدیدترین",
    pause: "متوقف کردن",
    bulk_download: "دانلود گروهی",
    activate: "فعال کردن",
    deactivate: "متوقف کردن",
    error_loading_card: "خطا در بارگذاری اطلاعات کارت!",
    error_fetching_prices: "خطا در دریافت قیمت‌ها!",
    error_payment: "خطا در پرداخت!",
    sms_success: "ارسال با موفقیت ثبت شد",
    generic_error: "خطایی رخ داده است!",
  },
  headerTypeFilter: {
    qr_model: "مدل کیوآر",
    all_qr_models: "همه مدل های کیوآر",
  },
  menuOrderFactor: {
    order_invoice: "فاکتور سفارش",
    total: "جمع کل",
    tax: "مالیات",
    shipping_cost: "هزینه ارسال",
    packing_cost: "هزینه بسته‌بندی",
    discount: "تخفیف",
    final_total: "مجموع",
    currency: "ریال",
    titles: {
      default_title: "سفارش پیش‌فرض",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "جست جو در لیست",
    search: "جستجو",
    start_from: "شروع از",
  },
  headerStatusFilter: {
    all_qr_codes: "همه کدهای کیوآر",
    active_qr_codes: "کدهای کیوآر فعال",
    inactive_qr_codes: "کدهای کیوآر غیرفعال",
    expiring_qr_codes: "کدهای کیوآر درحال انقضا",
    expired_qr_codes: "کدهای کیوآر منقضی شده",
  },
  qrOrdersList: {
    title: "لیست سفارشات",
    orderColumns: {
      index: "ردیف",
      id: "شماره سفارش",
      customerName: "نام مشتری",
      mobile: "شماره همراه",
      paymentType: "روش پرداخت",
      shippingType: "روش دریافت",
      price: "مبلغ سفارش",
      createdAt: "زمان سفارش",
      status: "وضعیت",
      actions: "عملیات",
    },
    productsColumns: {
      productId: "شناسه محصول",
      image: "تصویر",
      productName: "نام محصول",
      unitPrice: "قیمت واحد",
      quantity: "تعداد",
      totalPrice: "قیمت",
    },
    actions: {
      products: "لیست سفارش",
      print: "پرینت سفارش",
      share: "اشتراک گذاری سفارش",
      status: "تغییر وضعیت",
    },
    shippingType: {
      courier: "ارسال با پیک",
      reservation: "رزرو میز",
      place: "دریافت حضوری",
      post: "ارسال با پست",
      unknown: "-",
    },
    paymentType: {
      online: "پرداخت آنلاین",
      place: "پرداخت در محل",
      card2card:"پرداخت کارت به کارت",
      unknown: "-",
    },
    status: {
      all: "همه",
      pending: "در انتظار پرداخت",
      accepted: {
        place: "پرداخت در محل",
        paid: "پرداخت شده",
      },
      delivered: "تحویل شده",
      rejected: "پرداخت ناموفق",
    },
    factorTitle: "فاکتور سفارش",
    printFactor: "پرینت فاکتور",
    fetchError: "خطا در دریافت اطلاعات",
    statusChanged: "وضعیت با موفقیت تغییر کرد",
    statusChangeError: "خطا در تغییر وضعیت",
    currency: "ریال",
    perPage: "تعداد",
    search: "جستجو",
    noStatus: "هیچ وضعیتی وجود ندارد",
    loading: "در حال بارگذاری...",
    noShippingType: "هیچ نوع ارسالی وجود ندارد",
    noPaymentType: "هیچ نوع پرداختی وجود ندارد",
    sortColumn: "ستون مرتب‌سازی",
    sortDirection: "جهت مرتب‌سازی",
    sortDirectionDesc: "نزولی",
    sortDirectionAsc: "صعودی",
    selectNewStatus: "انتخاب وضعیت جدید",
    changeStatusTitle: "تغییر وضعیت",
    linkCopied: "لینک کپی شد.",
  },
  qrUserTransfer: {
    title: "انتقال مالکیت",
    radioLabels: {
      userTransfer: "انتقال به شخص دیگر",
      givingAccess: "ارائه دسترسی",
    },
    inputLabels: {
      phone: "تلفن همراه شخص",
    },
    hints: {
      addNumber: "برای تعیین ارائه دسترسی دکمه Enter یا آیکون + را بزنید",
      addNumberStep2: "برای اضافه کردن شماره دکمه Enter یا آیکون + را بزنید",
    },
    buttons: {
      transfer: "انتقال",
      giveAccess: "ارائه دسترسی",
      back: "بازگشت",
      saveChanges: "ذخیره تغییرات",
      cancel: "لغو",
      add:"افزودن",
    },
    tooltips: {
      deleteAccess: "حذف دسترسی",
    },
    subtitles: {
      accessList: "لیست افرادی که دسترسی دارند:",
      selectPermissions: "انتخاب دسترسی‌ها:",
    },
    permissionList: {
      edit_name: "ویرایش نام سرویس",
      edit_link: "ویرایش لینک",
      edit_info: "ویرایش اطلاعات",
      edit_design: "ویرایش دیزاین کیوآرکد",
      edit_settings: "ویرایش تنظیمات کیوآرکد",
      toggle_access: "دسترسی غیرفعال/فعال",
      view_customers: "مشاهده لیست مشتریان",
      view_orders: "مشاهده لیست سفارشات",
    },
    messages: {
      invalidPhone: "شماره وارد شده معتبر نیست",
      duplicatePhone: "شما نمی‌توانید شماره تکراری وارد کنید",
      updateAccessSuccess: "دسترسی‌ها با موفقیت به‌روزرسانی شد.",
      updateAccessError: "خطا در به‌روزرسانی دسترسی: {message}",
      deleteAccessSuccess: "دسترسی با موفقیت قطع شد.",
      deleteAccessError: "خطا در قطع دسترسی: {message}",
      fetchAccessError: "خطا در خواندن دسترسی‌ها: {message}",
      transferSuccess: "کیوآر شما با موفقیت منتقل شد.",
      transferError: "خطا در انتقال کیوآر: {message}",
      giveAccessSuccess: "با موفقیت انجام شد.",
      giveAccessError: "خطا در تنظیم دسترسی: {message}",
      confirmDeleteAccess: "آیا از قطع دسترسی فرد مورد نظر اطمینان دارید؟",
    },
  },
  form: {
    form_download: "فرم‌های دریافتی",
    form_add: "افزودن فرم",
    formdownload: "فرم دریافتی",
    create_at: "ساخته شده در :",
    shown: "مشاهده",
    nogiveform: "شما فرم دریافتی ندارید",
    back: "بازگشت",
    invalid_date: "تاریخ نامعتبر",
    select_date: "انتخاب تاریخ",
    select: "انتخاب",
    clear: "لغو",
    now: "حالا",
  },
  dsBasketCondition: {
    title: "حداقل شرایط سبد خرید",
    items: {
      NoConditions: "بدون محدودیت",
      MinimumShopping: "حداقل مبلغ سبد خرید",
      MinimumProduct: "حداقل تعداد محصولات در سبد خرید",
      MaximumShopping: "حداکثر مبلغ سبد خرید",
      MaximumProduct: "حداکثر تعداد محصولات در سبد خرید",
    },
  },
  dsUserSettings: {
    title: "حداقل شرایط سبد خرید",
    groupTitle: "کاربرانی که",
    specialTitle: "کاربر",
    labels: {
      minimumCart: "خداقل شرایط سبد",
      users: "کاربران",
    },
    items: {
      AllUser: "همه کاربران",
      group: "گروهی از کاربران",
      special: "کاربران خاص",
    },
    groupItems: {
      Order: "کاربرانی که قبلا خرید کرده‌اند",
      noOrder: "کاربرانی که قبلا خرید نکرده‌اند",
    },
  },
   "qrAddressUpdate": {
    "title": "ویرایش آدرس",
    "labels": {
      "address": "آدرس کیوآر"
    },
    "hints": {
      "allowedChars": "فقط حروف انگلیسی، اعداد، خط تیره (-) و آندرلاین (_) مجاز است"
    },
    "buttons": {
      "removeInvalidChars": "حذف کاراکترهای غیرمجاز"
    },
    "errors": {
      "minLength": "حداقل ۳ کاراکتر الزامی است",
      "invalidChars": "کاراکتر غیرمجاز! فقط حروف انگلیسی، اعداد، - و _ استفاده کنید.",
      "invalidAddress": "آدرس وارد شده نامعتبر است",
      "updateFailed": "خطا در بروزرسانی آدرس"
    },
    "successMessage": "آدرس با موفقیت بروزرسانی شد",
    "warning": "هشدار",
    "warningMessage": "تغییر آدرس باعث می‌شود لینک‌های قبلی از کار بیفتند.",
    "savePrompt": "آیا از ذخیره این تغییر مطمئن هستید؟"
  },
  dsFunctionType: {
    title: "تخفیف اعمال شود روی",
    productListTitle: "لیست محصولات",
    categoryListTitle: "لیست دسته‌بندی‌ها",
    labels: {
      applyDiscount: "اعمال تخفیف بر روی",
      category: "دسته‌بندی",
    },
    items: {
      AllShoppingCart: "کل مبلغ سبد خرید",
      SpecialProducts: "محصولات خاص",
      SpecialCategories: "دسته‌بندی خاص",
    },
  },
  dsLimitationUse: {
    title: "محدودیت استفاده",
    discountCodeTitle: "تعداد استفاده",
    userTitle: "تعداد کاربر",
    labels: {
      limitation: "محدودیت",
      usage: "استفاده",
      user: "کاربر",
    },
    items: {
      NoLimitations: "بدون محدودیت",
      DiscountCode: "تعداد استفاده از کد تخفیف",
      User: "تعداد استفاده برای هر کاربر",
    },
  },
  ManageHourLimitQr: {
    noLimit: "بدون محدودیت",
    dateLimit: "محدودیت تاریخ",
    timeLimit: "محدودیت ساعت",
    startDate: "تاریخ شروع",
    endDate: "تاریخ پایان",
    selectDate: "انتخاب تاریخ",
    startTime: "ساعت شروع",
    endTime: "ساعت پایان",
  },
  discount_percent_range: "تخفیف باید بین ۰ تا ۱۰۰ درصد باشد",
  discount_price_range: "تخفیف باید بین ۰ تا {max} باشد",
  invalid_number: "لطفاً فقط عدد وارد کنید",
  min_order_cart: "حداقل سبد خرید",
  preparation_time: "مدت زمان آماده سازی (دقیقه)",
  delivery_time: "مدت زمان ارسال (دقیقه)",
  max_product_in_order: "حداکثر تعداد محصول در هر سفارش",
  max_order_by_person: "حداکثر تعداد سفارش هر مشتری",
  send_by_courier_price: "هزینه پیک",
  vat: "درصد مالیات",
  send_by_post: "هزینه پست",
  online_pay: "پرداخت آنلاین",
  pay_in_person_place: "پرداخت در زمان تحویل",
  in_place: "مراجعه حضوری",
  table_booking_ability: "رزرو میز",
  send_by_courier: "ارسال با پیک",
  vat_switch: "مالیات",
  invalid_number: "لطفاً فقط عدد وارد کنید",
  positive_number: "عدد باید مثبت باشد",
  vat_range: "مالیات باید بین ۰ تا ۱۰۰ درصد باشد",
  sort_column: "ستون مرتب‌سازی",
  direction_sort: "جهت مرتب‌سازی",
  listFeedbackUser: {
    no_questions: "شما سوالی برای گرفتن بازخورد‌ها ندارید",
    add_feedback_prompt: "برای افزودن بازخورد جدید به تب افزودن مراجعه کنید",
    question_label: "سوال",
    show_answers: "نمایش پاسخ‌ها",
    back_button: "بازگشت",
    no_feedback: "بازخوردی ندارید!",
    user_opinion: "نظر کاربر",
    score_label: "امتیاز",
  },
  manageDiscount: {
    createNewDiscount: "ایجاد کد تخفیف جدید",
    copy: "کپی",
    row: "ردیف",
    id: "شناسه",
    discountCode: "کد تخفیف",
    usageLimit: "سقف استفاده",
    used: "استفاده شده",
    manage: "مدیریت",
    edit: "ویرایش",
    delete: "حذف",
    sendSms: "ارسال پیام به مخاطبین",
    copySuccess: "کد تخفیف شما کپی شد",
    copyError: "مشکلی پیش آمده",
    deleteSuccess: "کد تخفیف شما حذف شد",
    deleteError: "خطا در حذف کد تخفیف",
    smsSuccess: "کد تخفیف شما برای مخاطبان ارسال شد",
    smsError: "مشکلی پیش آمده است",
  },
  manageTableReservation: {
    table: "میز",
    number: "شماره {num}",
    add_table: "افزودن میز",
    complete_info_for_customer:
      "اطلاعات زیر را جهت نمایش به مشتری تکمیل نمایید",
    select_image: "انتخاب عکس",
    table_name_number: "نام/شماره میز",
    number_of_seats: "تعداد صندلی میز",
    type: "نوع",
    reservation_cost: "هزینه رزرو",
    enter_table_name: "لطفا نام/شماره میز را وارد نمایید",
    table_type: "میز",
    couch_type: "تخت",
    gazebo_type: "آلاچیق",
  },
  create_menu: {
    data: {
      visitName_label: "نام بازدید",
      organizationName: "فست فود زنجیره‌ای بزرگ",
      subOrgan: "بهترین طعم فست فود را با ما تجربه کنید",
      aboutUs:
        "فست فود بزرگ با حفظ کیفیت و احترام به شما تلاش کرده‌ایم بهترین‌ها را برای شما فراهم کنیم.\nحفظ کیفیت از اصولی است که ما به آن پایبند بوده و هستیم.\nدر بخش فست فود ما تا به امروز با ساندویچ‌های مخصوص طعمی جدید در لاین غذاهای فست فودی برای شما بوده‌ایم\nما همه روز آماده خدمت‌رسانی برای قرارهای اداری، تولد و… شما هستیم.",
      copyright: "تمامی حقوق این سایت متعلق به ترمینال تبلیغات می‌باشد.",
      product: {
        title: "محصولات",
        pizzas: "پیتزاها",
        pizza_roast_beef: "پیتزا رست بیف",
        pizza_roast_beef_desc: "🤩پیتزا ایتالیایی با گوشت گوساله",
        pizza_roast_beef_ingredients:
          "خمیر پیتزا ایتالیایی ۳۰ سانتی متری، ۱۰۰ گرم گوشت گوساله ریش ریش شده، قارچ، فلفل دلمه ای، زیتون سیاه",
        pizza_chicken_mushroom: "پیتزا مرغ و قارچ",
        pizza_chicken_mushroom_desc: "🍕کلاسیک ۴۰ سانتی‌متری",
        pizza_chicken_mushroom_ingredients:
          "سس گوجه فرنگی تازه پیتزارا، پنیر (مطهر)، فیله مرغ، قارچ، آویشن کوهی",
        pizza_meat_mushroom: "پیتزا گوشت وقارچ",
        pizza_meat_mushroom_desc: "🥰 پیتزا گوشت چرخ کرده با قارچ",
        pizza_meat_mushroom_ingredients:
          "سس گوجه فرنگی تازه پیتزارا، پنیر (مطهر)، گوشت راسته گوساله چرخ شده، قارچ، آویشن کوهی، دو نفره (۲۹ سانتی متری) ۳۵۵,۰۰۰ تومان، یک نفره (۲۲ سانتی متری) ۲۱۶,۰۰۰ تومان",
        pizza_veggie: "پیتزا سبزیجات",
        pizza_veggie_desc: "🍕 پیتزا سبزیجات آمریکایی",
        pizza_veggie_ingredients:
          "خمیر پیتزا آمریکایی، ذرت، قارچ، زیتون، گوجه، پیاز، فلفل، پنیر پیتزا",
        pizza_special: "پیتزا مخصوص",
        pizza_special_desc: "پیتزا مخصوص آمریکایی",
        pizza_special_ingredients:
          "خمیر پیتزا آمریکایی، گوشت گوساله چرخ شده مزه دار شده، میکس ژامبون گوشت و مرغ ۸۰%، پنیر موزارلا میکس، سس مخصوص، فلفل دلمه ای، قارچ، بدون سس تک نفره",
        pizza_bolognese: "پیتزا بولنیز",
        pizza_bolognese_desc: "(یک نفره) خمیر پیتزا ۲۳ سانت متری 🤌",
        pizza_bolognese_ingredients:
          "گوشت گوساله چرخ کرده، پنیر موزلا، قارچ، فلفل دلمه ای، ذرت، زیتون سیاه اسلایس شده",
        pizza_pepperoni: "پیتزاپپرونی",
        pizza_pepperoni_desc: "(یک نفره) خمیر پیتزا ۲۳ سانتی متری",
        pizza_pepperoni_ingredients:
          "خمیر پیتزا ایتالیایی، پپرونی ۸۰%، سس ماینارا، پنیر پیتزا مخصوص",
        pizza_bacon: "پیتزا بیکن",
        pizza_bacon_desc: "(یک نفره) خمیر پیتزای ۲۳ سانتی 💥",
        pizza_bacon_ingredients:
          "خمیر پیتزا ایتالیایی، سس مارینارا، پنیر پیتزا مخصوص، بیکن مخلوط گوشت و مرغ ۹۰%، قارچ، زیتون، فلفل دلمه ای",
        pizza_mixed: "پیتزا مخلوط",
        pizza_mixed_desc: "(یک نفره) خمیرپیتزا ۲۳ سانتی 🤭",
        pizza_mixed_ingredients:
          "مخلوط ژامبون گوشت و مرغ خرد شده، ژامبون سالامی، گوشت گوساله چرخ شده، قارچ، زیتون، فلفل دلمه ای، پنیر پیتزا، سس مخصوص",
        pizza_american_steak: "پیتزا استیک آمریکایی",
        pizza_american_steak_desc: "(یک نفره) ۲۳ سانتی متری 💥",
        pizza_american_steak_ingredients:
          "خمیر پیتزا آمریکایی، گوشت گوساله تکه ای، قارچ، پنیر پیتزا، کنجد",
        burgers: "همبرگرها",
        cheeseburger: "چیز برگر",
        cheeseburger_desc: "🤩همراه با سیب زمینی سرخ شده",
        cheeseburger_ingredients:
          "۲ عدد برگر گوشت گوساله ۱۵۰ گرمی، سس مخصوص، پنیر گودا، خیارشور، کاهو، گوجه",
        hamburger: "همبرگر",
        hamburger_desc: "😍گوشت خالص همراه سس مخصوص",
        hamburger_ingredients:
          "یک عدد برگر گوشت گوساله ۱۵۰ گرمی، خیارشور، کاهو، سس مخصوص، گوجه، نان مک، سس یک نفره",
        chicken_burger: "چیکن برگر",
        chicken_burger_desc: "گریل چیکن برگر با پنیر",
        chicken_burger_ingredients:
          "۱۵۰ گرم سینه مرغ گریل شده، پنیر، گوجه، خیارشور، کاهو، نان مک، سس مخصوص",
        spice_burger: "اسپایس برگر",
        spice_burger_desc: "گوشت گوساله همراه سس اسپایسی",
        spice_burger_ingredients:
          "یک عدد برگر گوشت گوساله ۱۳۰ گرمی، سس اسپایسی، کاهو، گوجه، نان مک، سس مخصوص اسپایسی",
        double_burger: "دوبل برگر",
        double_burger_desc: "گوشت گوساله ۱۵۰ گرمی",
        double_burger_ingredients:
          "۲ عدد برگر دست ساز گوشت گوساله ۱۵۰ گرمی، پنیر پیتزا، سس کاراملی، کاهو، کلم، سس سفید مخصوص، نان گرد",
        royal_burger: "رویال برگر",
        royal_burger_desc: "۱۵۰ گرم گوشت گوساله 🍔",
        royal_burger_ingredients:
          "یک عدد برگر دست ساز گوشت گوساله ۱۵۰ گرمی، پنیر پیتزا، ۵ ورق ژامبون سالامی، سس کاراملی، کاهو، کلم، سس سفید مخصوص، نان گرد",
        mushroom_burger: "قارچ برگر",
        mushroom_burger_desc: "گوشت گوساله ۱۵۰ گرمی",
        mushroom_burger_ingredients:
          "یک عدد برگر دست ساز گوشت گوساله ۱۵۰ گرمی، قارچ، سس کاراملی، کاهو، کلم، سس سفید مخصوص، نان گرد، پنیر موزلا",
        mashroom_burger: "ماشروم برگر",
        mashroom_burger_desc: "گوشت گوساله گریل شده ۱۰۰%🤩",
        mashroom_burger_ingredients:
          "یک عدد برگر دست ساز گوشت گوساله گریل شده ۱۰۰%، سیب زمینی سرخ شده، گوجه، کاهو، خیارشور، سس قارچ، نان گرد",
        fried_burger: "برگر سوخاری",
        fried_burger_desc: "گوشت گوساله گریل شده سوخاری ۱۰۰%👌",
        fried_burger_ingredients:
          "یک عدد برگر دست ساز گوشت گوساله گریل شده سوخاری ۱۰۰%، ۱۵۰ گرم سیب زمینی سرخ شده، گوجه، کاهو، خیارشور، سس مخصوص، نان گرد",
        fried: "سوخاری",
        fried_chicken: "مرغ سوخاری",
        fried_chicken_desc: "😍مرغ سوخاری سه تیکه",
        fried_chicken_ingredients:
          "۳ عدد مرغ سوخاری، ۱۲۰ تا ۱۵۰ گرم سیب زمینی سرخ کرده، یک عدد سالاد کلم ۱۰۰ تا ۱۲۰ گرمی، یک عدد نان بروتچن، سس مخصوص",
        chicken_strips: "چیکن استریپس",
        chicken_strips_desc: "۴ عدد فیله سوخاری طعم دار شده تند",
        chicken_strips_ingredients:
          "۴ عدد فیله مرغ سوخاری، ۱۲۰ تا ۱۵۰ گرم سیب زمینی سرخ کرده، یک عدد سالاد کلم ۱۰۰ تا ۱۲۰ گرمی، یک عدد نان بروتچن، سس تارتار",
        fried_filet: "فیله سوخاری",
        fried_filet_desc: "🤩۲ تیکه فیله سوخاری همراه سس مخصوص",
        fried_filet_ingredients:
          "۲ تکه فیله استریپس، سیب زمینی تنوری، سالاد کلم، نان بروتچن، سس سیر، سس چیلی تای، سس فلفل",
        fried_mushroom_onion: "قارچ و پیاز سوخاری",
        fried_mushroom_onion_desc: "🤩قارچ و پیاز سوخاری همراه سس تاتار",
        fried_mushroom_onion_ingredients:
          "۲۰ عدد قارچ سوخاری شده، ۶ عدد پیاز سوخاری شده، یک عدد سس تاتار",
        fried_wings: "بال سوخاری",
        fried_wings_desc: "۶ عدد بال سوخاری 🍗",
        fried_wings_ingredients: "شش عدد بال گریل شده سوخاری",
        fried_chicken_basket: "سبد مرغ سوخاری",
        fried_chicken_basket_desc: "(دو نفره)😍",
        fried_chicken_basket_ingredients:
          "۲ عدد مرغ سوخاری، ۲ عدد فیله استریپس، ۲ عدد پیاز حلقه ای، ۲ عدد ناگت میگو سوخاری، ۲ عدد ناگت مرغ",
        fried_schnitzel: "شینسل سوخاری",
        fried_schnitzel_desc: "چهار عدد شینسل مرغ💥",
        fried_schnitzel_ingredients:
          "چهار عدد شینسل مرغ سوخاری گریل شده اسپایسی",
        veggie_basket_fried: "وجی بسکت سوخاری",
        veggie_basket_fried_desc: "۲۵۰ گرم🤩",
        veggie_basket_fried_ingredients:
          "۲۵۰ گرم، کدو سوخاری، بادمجان سوخاری، قارچ سوخاری، سیب زمینی سوخاری",
        fried_chicken_2_piece: "مرغ سوخاری ۲ تیکه",
        fried_chicken_2_piece_desc: "۲ عدد مرغ سوخاری🍗",
        fried_chicken_2_piece_ingredients:
          "۱۲۰ تا ۱۵۰ گرم سیب زمینی سرخ کرده، یک عدد سالاد کلم ۱۰۰ تا ۱۲۰ گرمی، یک عدد نان بروتچن، سس مخصوص",
        fried_chicken_5_piece: "مرغ سوخاری پنج تیکه",
        fried_chicken_5_piece_desc: "پنج عدد مرغ سوخاری",
        fried_chicken_5_piece_ingredients:
          "۱۵۰ تا ۲۰۰ گرم سیب زمینی سرخ کرده، دو عدد سالاد کلم ۱۰۰ تا ۱۲۰ گرمی، ۲ عدد نان بروتچن، سس مخصوص",
        fried_chicken_7_piece: "مرغ سوخاری هفت تیکه",
        fried_chicken_7_piece_desc: "هفت عدد مرغ سوخاری 💥",
        fried_chicken_7_piece_ingredients:
          "۱۵۰ تا ۲۰۰ گرم سیب زمینی سرخ کرده، یک عدد سالاد کلم ۱۰۰ تا ۱۲۰ گرمی، ۳ عدد نان بروتچن، سس مخصوص، سس یک نفره سوخاری",
        sandwich: "ساندویچ",
        hotdog_sandwich: "ساندویچ هات داگ",
        hotdog_sandwich_desc: "ساندویچ هات داگ با قارچ و پنیر",
        hotdog_sandwich_ingredients:
          "یک عدد سوسیس هات داگ تنوری شده، کاهو، گوجه، خیارشور، قارچ و پنیر پیتزا",
        roast_beef_sandwich: "ساندویچ رست بیف",
        roast_beef_sandwich_desc: "✔️گوشت گوساله ریش ریش شده",
        roast_beef_sandwich_ingredients:
          "گوشت گوساله، پنیر پیتزا، قارچ، چیپس خلالی، کاهو، گوجه، خیارشور، سس مخصوص، نان فرانسوی",
        ham_sandwich: "ساندویچ ژامبون",
        ham_sandwich_desc: "ساندویچ ژامبون مرغ و قارچ (سرد)",
        ham_sandwich_ingredients:
          "ژامبون قارچ و مرغ، کاهو، گوجه، خیارشور، چیپس خلال، سس مخصوص، نان باگت",
        bandari_sausage_sandwich: "ساندویچ بندری",
        bandari_sausage_sandwich_desc: "💥ساندویچ بندری تند",
        bandari_sausage_sandwich_ingredients:
          "خوراک بندری با سوسیس کوکتل دودی ۵۵%، گوجه، خیارشور، سس مخصوص، پیاز و جعفری، نان بولکی",
        tongue_mushroom_sandwich: "ساندویچ زبان و قارچ",
        tongue_mushroom_sandwich_desc: "۱۵۰ گرم زبان گوساله",
        tongue_mushroom_sandwich_ingredients:
          "قارچ، پنیر پیتزا مطهر، زیتون، ذرت، کاهو، خیارشور، گوجه، یک عدد سس، دورچین، سیب زمینی سرخ شده، سالاد کلم",
        falafel_sandwich: "ساندویچ فلافل",
        falafel_sandwich_desc: "شش عدد قرص فلافل🌭",
        falafel_sandwich_ingredients:
          "شش قرص فلافل، خیارشور، گوجه، کاهو، یک عدد سس یک نفره، دورچین، سیب زمینی سرخ شده، سالاد کلم",
        cheesy_kebab_turki_sandwich: "ساندویچ کباب ترکی پنیری",
        cheesy_kebab_turki_sandwich_desc: "۱۵۰ گرم گوشت گوساله",
        cheesy_kebab_turki_sandwich_ingredients:
          "۱۵۰ گرم گوشت گوساله، پنیر پیتزای مخصوص، خیارشور، گوجه، کاهو، یک عدد سس یک نفره، سیب زمینی سرخ شده، سالاد کلم",
        roast_chicken_sandwich: "ساندویچ رست مرغ",
        roast_chicken_sandwich_desc: "شینسل مرغ و قارچ🤩",
        roast_chicken_sandwich_ingredients:
          "شینسل مرغ و قارچ، پنیر پیتزای مخصوص، زیتون، ذرت، کنجد، کاهو، فلفل دلمه ای، خیارشور، گوجه، یک عدد سس مخصوص، دورچین، سیب زمینی سرخ شده",
        cheesy_indian_sandwich: "ساندویچ هندی پنیری",
        cheesy_indian_sandwich_desc: "سوسیس آلمانی💥",
        cheesy_indian_sandwich_ingredients:
          "سوسیس آلمانی پنیری، ذرت، کاهو، قارچ، یک عدد سس مخصوص، دورچین، سیب زمینی سرخ کرده، سالاد کلم",
        snack: "اسنک",
        chicken_snack: "اسنک مرغ",
        chicken_snack_desc: "😋سینه مرغ ریش ریش شده",
        chicken_snack_ingredients:
          "۱۵۰ گرم سینه مرغ، فلفل دلمه، قارچ، نان مخصوص اسنک، سس مخصوص",
        meat_snack: "اسنک گوشت",
        meat_snack_desc: "🥪یک جفت اسنک گوشت",
        meat_snack_ingredients:
          "یک جفت، مغز ران گوساله ریش ریش شده، پنیر موزارلا، ذرت، فلفل دلمه ای، سس مخصوص، نان تست",
        chicken_meat_snack: "اسنک چیکن میت",
        chicken_meat_snack_desc: "🤩یک جفت اسنک چیکن میت",
        chicken_meat_snack_ingredients:
          "یک جفت، سینه مرغ ریش شده، گوشت مغز ران گوساله ریش ریش شده، پنیر موزارلا، ذرت، فلفل دلمه ای، سس مخصوص، نان تست",
        special_snack: "اسنک مخصوص",
        special_snack_desc: "🤤 یک جفت اسنک مخصوص",
        special_snack_ingredients:
          "یک جفت، میکس کالباس گوشت و مرغ ۹۰٪، پنیر موزارلا، ذرت، فلفل دلمه ای، سس مخصوص، نان تست",
        roast_beef_snack: "اسنک رست بیف",
        roast_beef_snack_desc: "گوشت ریش شده گوساله🍖",
        roast_beef_snack_ingredients:
          "گوشت گوساله ریش شده، قارچ، پنیر پیتزا، فلفل دلمه ای، ذرت، دورچین، سیب زمینی سرخ شده، سالاد کلم",
        veggie_snack: "اسنک سبزیجات",
        veggie_snack_desc: "اسنک سبزیجات ۴ تکه",
        veggie_snack_ingredients:
          "کلم بروکلی، ذرت، زیتون، پنیر پیتزای رژیمی، قارچ، دورچین، سیب زمینی سرخ شده، سالاد کلم",
        chicken_mushroom_snack: "اسنک مرغ و قارچ",
        chicken_mushroom_snack_desc: "شینسل مرغ و قارچ👌",
        chicken_mushroom_snack_ingredients:
          "شینسل مرغ، قارچ، پنیر پیتزای مخصوص، زیتون، ذرت، فلفل دلمه ای، دورچین، سیب زمینی سرخ شده، سالاد کلم",
        pepperoni_snack: "اسنک پپرونی",
        pepperoni_snack_desc: "کالباس پپرونی ۹۰%💥",
        pepperoni_snack_ingredients:
          "یک جفت، کالباس پپرونی ۹۰%، پنیر موزارلا، ذرت، فلفل دلمه ای، سس مخصوص",
        bologna_snack: "اسنک بلونیا",
        bologna_snack_desc: "گوشت چرخ شده👌",
        bologna_snack_ingredients:
          "یک جفت، گوشت چرخ شده، بیکن ویژه، قارچ بلنچ، ذرت، پنیر موزارلا، فلفل دلمه ای، سس مخصوص",
        pasta: "پاستا",
        alfredo_pasta: "پاستا آلفردو",
        alfredo_pasta_desc: "پاستا آلفردو با سس قارچ مخصوص",
        alfredo_pasta_ingredients: "۳۵۰ گرم پنه",
        macaroni: "ماکارانی",
        macaroni_desc: "🥣ماکارونی گوشت و قارچ",
        macaroni_ingredients:
          "ماکارونی رشته ای ۱.۲، گوشت چرخ کرده گوساله ۱۰۰ گرم، قارچ، فلفل دلمه ای، سیب زمینی نگینی سرخ شده، نخود فرنگی",
        spaghetti_bolognese: "اسپاگتی بلونز",
        spaghetti_bolognese_desc: "🥰پاستا لینگویینی",
        spaghetti_bolognese_ingredients:
          "۷۰۰ گرم، پاستا لینگویینی، گوشت گوساله و گوسفندی چرخ شده، سس بلونز، سس قرمز رسو مخصوص، قاشق و چنگال یکبار مصرف به انتخاب شما",
        chicken_stroganoff: "چیکن استراگانف",
        chicken_stroganoff_desc: "😍چیکن استراگانف همراه با سینه مرغ تکه ای",
        chicken_stroganoff_ingredients:
          "۱۸۰ گرم سینه مرغ تکه ای مرینیت شده، خامه، قارچ بلانچ، پنیر پارمسان، سیب زمینی سرخ کرده خلالی دست ساز، ظرف مخصوص ماکروویو",
        penne_arrabbiata: "پاستا پنه آرابیاتا",
        penne_arrabbiata_desc: "سینه مرغ💥",
        penne_arrabbiata_ingredients:
          "یک نفره، سینه مرغ، پاستا، قارچ، پنیر پارمیسان، گوجه چری، جعفری، سس آرابیاتا",
        chicken_pesto_pasta: "پاستا چیکن پستو",
        chicken_pesto_pasta_desc: "(یک نفره) سینه مرغ",
        chicken_pesto_pasta_ingredients:
          "سینه مرغ، قارچ، پنیر پارمیسان، گوجه چری، جعفری، سس آرابیاتا",
        carbonara_pasta: "پاستا کاربونارا",
        carbonara_pasta_desc: "بیکن گوشت ۹۷%",
        carbonara_pasta_ingredients:
          "پاستا، بیکن گوشت ۹۷%، سس آلفردو، پنیر پارمیسان، گوجه چری، جعفری",
        appetizer: "پیش غذا",
        hot_chips: "هات چیپس",
        hot_chips_desc: "😙در طعم‌های مختلف چیپس",
        hot_chips_ingredients:
          "یک کیلوگرم چیپس، سس مخصوص، ژامبون مرغ ۷۰%، قارچ، فلفل دلمه ای، پنیر پیتزا، پنیر گودا",
        lasagna: "لازانیا",
        lasagna_desc: "لازانیا با گوشت چرخ کرده",
        lasagna_ingredients:
          "۳ ورق لازانیا، گوشت چرخ کرده، قارچ، فلفل دلمه ای، زیتون سیاه، پنیر پیتزا، سس مخصوص",
        french_fries: "سیب زمینی سرخ شده",
        french_fries_desc: "سیب زمینی سرخ شده در کنار سس مخصوص",
        french_fries_ingredients: "۱۵۰ گرم سیب زمینی سرخ کرده، سس مخصوص",
        baked_potato: "سیب زمینی تنوری",
        baked_potato_desc: "🍟سیب زمینی تنوری همراه بیکن گوشت",
        baked_potato_ingredients:
          "۱۵۰ گرم سیب زمینی سرخ کرده، بیکن گوشت ۹۰%، پنیر پیتزا، ادویه مخصوص، سس تک نفره",
        garlic_bread: "نان سیر",
        garlic_bread_desc: "سس مخصوص سیر💥",
        garlic_bread_ingredients:
          "خمیر پیتزا آمریکایی، پنیر پیتزا ترکیبی، سس مخصوص سیر، کنجد",
        silo_potatoes: "سیب زمینی سیلو",
        silo_potatoes_desc: "دو نفره سیب زمینی سرخ شده",
        silo_potatoes_ingredients:
          "سیب زمینی سرخ شده با ادویه سیلو، بیکن گوشت ۹۷%، دیپ چدار، سس آیولی، پیازچه، جعفری",
        bbq_sausage: "سوسیس باربیکیو",
        bbq_sausage_desc: "سوسیس انگشتی مزه دار شده🍢",
        bbq_sausage_ingredients:
          "۵۰۰ گرم پوره سیب زمینی مزه دار شده، ۲۰۰ گرم سوسیس انگشتی مزه دار شده، پیاز حلقه ای، زیتون سبز، پودر پنیر پارمیسان، گوجه چری، میکرو گرین، پنیر کبابی، سس باربیکیو، اسپایسی",
        silo_toast: "تست سیلو",
        silo_toast_desc: "۱۶۰ گرم گوشت ورقه ای راسته گوساله🤩",
        silo_toast_ingredients:
          "۱۶۰ گرم گوشت ورقه ای راسته گوساله، کاهو فرانسوی، بیکن گوشت، نان کشاورزی، سس باربیکیو، سس تارتار، سورل، زیتون سبز، میکرو گرین، سس آیولی، پودر پنیر پارمیسان",
        salad_and_dessert: "سالاد و دسر",
        caesar_salad: "سالاد سزار",
        caesar_salad_desc: "سالاد سزار تک نفره🥗",
        caesar_salad_ingredients:
          "میکس کاهو، مرغ گریل، پنیر پارمسان، کروتان (نان سیر)، سس سزار، زیتون",
        caesar_salad_extra: "کاهو رومی، کروتون، پارمزان",
        coleslaw_salad: "سالاد کلم",
        coleslaw_salad_desc: "سالاد کلم تک نفره🍴",
        coleslaw_salad_ingredients: "دست ساز، یک نفره، کلم سفید، ذرت، سس",
        macaroni_salad: "سالاد ماکارانی",
        macaroni_salad_desc: "سالاد ماکارانی با کالباس خانگی",
        macaroni_salad_ingredients: "ماکارونی، کالباس خانگی",
        pachira_salad: "سالاد پاچیرا",
        pachira_salad_desc: "سالاد پاچیرا دو نفره🥗",
        pachira_salad_ingredients:
          "۲ نفره، کاهو میکس، چیپس بیکن گوشت ۹۸%، گردو کاراملی، پنیر پارمسان، توت فرنگی، خاویار گیاهی، کشمش، لیمو اسلایس، سس رز بری",
        greek_salad: "سالاد یونانی",
        greek_salad_desc: "سالاد یونانی سنتی با پنیر فتا و زیتون",
        greek_salad_ingredients: "پنیر فتا، زیتون، خیار",
        tiramisu: "تیرامیسو",
        tiramisu_desc: "دسر تیرامیسو کلاسیک ایتالیایی",
        tiramisu_ingredients: "قهوه، ماسکارپونه، کاکائو",
        beverages: "نوشیدنی",
        local_yogurt_drink: "دوغ محلی",
        local_yogurt_drink_desc: "دوغ محلی خانواده🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "نوشابه مشکی",
        black_soda_desc: "نوشابه لیوانی مشکی🧋",
        black_soda_ingredients: "",
        fanta: "نوشابه زرد",
        fanta_desc: "نوشابه زرد لیوانی🥤",
        fanta_ingredients: "",
        mojito: "موهیتو",
        mojito_desc: "موهیتو لیوانی بین ۳۵۰ تا ۴۰۰ میلی لیتر🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "دلستر استوایی",
        tropical_malt_beverage_desc: "دلستر استوایی لیوانی🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "آدرس",
        address_text: "لینک سایت مورد نظر را وارد نمایید",
        instagram_label: "اینستاگرام",
        instagram_text: "نام کاربری خود را وارد نمایید",
        whatsapp_label: "واتساپ",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "گالری ویدئو",
        description:
          "برای آشنایی بیشتر با خدمات هوشمند سامانه کیوآرلند، ویدئوهای زیر را مشاهده فرمایید.",
        tutorial: "آموزشی",
        fast_food: "فست فود",
      },
      feedback: {
        title: "بازخورد شما",
        description:
          "لطفاً با پاسخ‌گویی به سوالات زیر ما را در خدمات بهتر راهنمایی فرمایید",
        question1: "چقدر از خدمات و کیفیت غذای ما راضی بودید؟",
        question2: "تنوع غذایی رستوران را چطور ارزیابی می‌کنید؟",
        question3: "برخورد کارکنان رستوران را چگونه ارزیابی می‌کنید؟",
        question4: "آیا غذا به‌موقع به شما تحویل شد؟",
        question5: "انتقادی برای بهبود خدمات یا کیفیت غذایی ما دارید؟",
      },
      worksheet: {
        saturday: "شنبه",
        sunday: "یکشنبه",
        monday: "دوشنبه",
        tuesday: "سه‌شنبه",
        wednesday: "چهارشنبه",
        thursday: "پنجشنبه",
        friday: "جمعه",
        shift_1_saturday: "۱۰:۰۰ تا ۲۲:۰۰",
        shift_1_sunday: "۱۰:۰۰ تا ۲۲:۰۰",
        shift_1_monday: "۱۰:۰۰ تا ۲۲:۰۰",
        shift_1_tuesday: "۱۰:۰۰ تا ۲۲:۰۰",
        shift_1_wednesday: "۱۰:۰۰ تا ۰۰:۰۰",
        shift_1_thursday: "۱۰:۰۰ تا ۰۰:۰۰",
        shift_1_friday: "۱۰:۰۰ تا ۰۰:۰۰",
      },
      gallery: {
        gallery_0: "گالری عکس۰",
        image_1: "۱",
        image_2: "۲",
        image_3: "۳",
        image_4: "۴",
        image_5: "۵",
        baked_potato_2: "سیب زمینی تنوری ۲",
        chicken_stroganoff_1: "چیکن استراگانف۱",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "تهران، خیابان شریعتی، بعد از پل سید خندان، بن بست خندان، پلاک ۶، واحد ۳",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "ایران، تهران، شهر تهران، تهران، منطقه ۳ شهر تهران، محله سید خندان، دکتر علی شریعتی، خندان",
      },
    },
    messages: {
      qr_created_success: "منو آنلاین با موفقیت ساخته شد.",
      qr_updated_success: "کیوآر منو آنلاین شما با موفقیت ویرایش شد.",
      qr_create_error: "ساخت کیوآر با خطا روبرو شد!",
      qr_update_error: "خطا در ذخیره/ویرایش کیوآر",
      template_categories_saved:
        "دسته‌بندی‌های مدل نمونه با موفقیت ذخیره شدند.",
      template_products_saved: "محصولات مدل نمونه با موفقیت ذخیره شدند.",
      template_categories_error: "خطا در ذخیره‌سازی دسته‌بندی‌های مدل نمونه!",
      template_products_error: "خطا در ذخیره‌سازی محصولات مدل نمونه!",
    },
    sample_menu: "منوی نمونه",
    view_qr: "مشاهده کیوآر",
    preview: "پیش‌نمایش",
    download_qr: "دانلود کیوآر",
    create_qr: "ایجاد کیوآر",
    online_menu_name: "نام منوی آنلاین",
    online_menu_name_short: "نام منو",
    enter_qr_address: "آدرس کیوآر را وارد کنید",
    qr_address: "آدرس کیوآر",
    enter_menu_information: "اطلاعات منو را وارد کنید",
    cleardefaults: "پاک کردن پیش‌فرض‌ها",
    select_sample_menu: "انتخاب منوی نمونه",
    select_ready_menu: "انتخاب منوی آماده",
    online_sales: "فروش آنلاین",
    sales_settings: "تنظیمات فروش",
    download: "دانلود",
    gallery_photos: "عکس‌های گالری",
    fast_food_1: "تصویر فست‌فود ۱",
    fast_food_2: "تصویر فست‌فود ۲",
    large_chain_fast_food: "فست فود زنجیره‌ای بزرگ",
    best_fast_food_taste_experience: "بهترین طعم فست فود را با ما تجربه کنید",
    online_menu_created_successfully: "منو آنلاین با موفقیت ساخته شد.",
    qr_creation_failed: "ساخت کیوآر با خطا روبرو شد!",
    online_menu_qr_updated_successfully:
      "کیوآر منو آنلاین شما باموفقیت ویرایش شد.",
    error_saving_updating_qr: "خطا در ذخیره/ویرایش کیوآر",
    sample_model_categories_saved_successfully:
      "دسته‌بندی‌های مدل نمونه با موفقیت ذخیره شدند.",
    sample_model_products_saved_successfully:
      "محصولات مدل نمونه با موفقیت ذخیره شدند.",
    error_saving_sample_model_products: "خطا در ذخیره سازی محصولات مدل نمونه!",
    error_saving_sample_model_categories:
      "خطا در ذخیره سازی دسته‌بندی‌های مدل نمونه!",
  },
  editMenu: {
    enter_menu_information: "اطلاعات منو را وارد کنید",
    online_menu_name: "نام منوی آنلاین",
    online_menu_name_short: "نام کوتاه منوی آنلاین",
    fields: {
      qr_address_hint: "آدرس QR برای دسترسی به منوی آنلاین",
    },
    online_sales: "فروش آنلاین",
    sales_settings: "تنظیمات فروش",
    shop: {
      upload_banner: "آپلود بنر",
      create_product: "ایجاد محصول",
      user_info: "اطلاعات کاربر",
      add_social_media: "افزودن شبکه‌های اجتماعی",
      photo_gallery: "گالری تصاویر",
      video_gallery: "گالری ویدیو",
      feedback: "بازخورد",
      working_hours: "ساعات کاری",
    },
    success_message: "کیوآر شما با موفقیت ویرایش شد.",
  },
  qrCodeSquare: {
    dots_color: "رنگ نقطه‌ها",
    gradient_color: "طیف رنگی",
    linear: "خطی",
    radial: "دایره‌ای",
    color_rotation: "چرخش رنگ",
    first_color: "رنگ اول",
    second_color: "رنگ دوم",
    dots_color_label: "رنگ نقطه‌ها",
  },

  language: {
    selectAll: "انتخاب همه",
    lang: {
      fa: "فارسی",
      ar: "عربی",
      ar_ae: "عربی (امارات)",
      ar_iq: "عربی (عراق)",
      en_US: "انگلیسی (آمریکا)",
      en_GB: "انگلیسی (بریتانیا)",
      de: "آلمانی",
      fr: "فرانسوی",
      zh_CN: "چینی ساده",
      zh_TW: "چینی سنتی",
      tr: "ترکی",
      ru: "روسی",
      hy: "ارمنی",
    },
    only_manual_now: "در حال حاضر فقط ترجمه دستی امکان‌پذیر است",
    ai_coming_soon: "ترجمه هوش مصنوعی به زودی فعال می‌شود",
    got_it: "متوجه شدم",
    origin_language: "زبان اصلی",
    target_languages: "سایر زبان‌ها",
    remove_all: "حذف همه زبان‌ها",
    translation_method: "روش ترجمه را انتخاب کنید",
    manual_translation: "ترجمه دستی",
    ai_translation: "ترجمه هوش مصنوعی",
    coming_soon: "به زودی",
    source_language_updated: "زبان اصلی بروزرسانی شد",
    error_changing_source_language: "خطا در تغییر زبان اصلی",
    source_language_created: "زبان اصلی جدید ایجاد شد",
    languages_saved: "زبان‌های جدید ذخیره شد",
    error_saving_languages: "خطا در ذخیره زبان‌ها",
    error_loading_language: "خطا در بارگذاری زبان",
    languages_removed: "زبان‌های حذف‌شده",
    new_languages_to_save: "زبان‌های جدید برای ذخیره",
    saved: "ذخیره شد",
    management_langs: "مدیریت زبان",
    add_langs: "افزودن زبان",
    change_language: "تغییر زبان",
    visit_card: "کارت ویزیت",
    translate_to: "ترجمه شود به",
    main_language: "زبان",
    no_languages_available: "زبانی در دسترس نیست",
    return_to_default: "بازگشت به زبان اصلی",
    translate: "ترجمه",
    changes_pending: "در انتظار اعمال تغییرات",
    apply_changes: "اعمال تغییرات",
    cancel_changes: "لغو",
  },
  winner_list: "لیست برندگان",
  qrwinnersList: {
    winnersList: "لیست برندگان کیوآر",
    winnerstotalcount: "تعداد برندگان برای کیوآر",
    winnerscountoffilter: " تعداد برندگان با فیلتر اعمال شده",
    prize: "جایزه",
    winnerName: "نام برنده",
    date: "تاریخ",
    noWinners: "هیچ برنده ای وجود ندارد",
    perPage: "تعداد در هر صفحه",
    search: "جستجو بر اساس نام برنده یا جایزه",
    sortDirection: "جهت مرتب سازی",
    sortBy: "مرتب سازی بر اساس",
  },
  appearance_settings: "تنظیمات ظاهری",
  header_color: "رنگ هدر",
  background_color: "رنگ پس‌زمینه",
  text_color: "رنگ متن",
  font_size: "اندازه فونت",
  chat_logo: "لوگو چت",
  floating_button_icon: "آیکن دکمه شناور",
  assistant_name: "نام دستیار",
  chat_preview: "پیش‌نمایش چت",
  smart_assistant: "دستیار هوشمند",
  online: "آنلاین",
  aiChatSettings: {
    select_assistant: "انتخاب دستیار",
    appearance_settings: "تنظیمات ظاهری",
    lead_connection_tab: "دریافت لید- اتصال به باشگاه مشتریان",

    // آکاردئون‌ها
    header_settings: "تنظیمات هدر",
    header_settings_desc: "رنگ و استایل هدر چت",
    text_settings: "تنظیمات متن",
    text_settings_desc: "رنگ و اندازه فونت",
    logo_settings: "تنظیمات لوگو",
    logo_settings_desc: "عکس یا آیکن دستیار",
    background_settings: "تنظیمات پس‌زمینه",
    background_settings_desc: "عکس یا رنگ پس‌زمینه",

    // سوئیچ‌ها
    gradient_color: "رنگ گرادیان",
    solid_color: "رنگ تکی",
    use_image: "استفاده از عکس",
    use_icon: "استفاده از آیکن",

    // لیبل‌های کالر پیکر
    first_color: "رنگ اول",
    second_color: "رنگ دوم",
    header_color: "رنگ هدر",
    text_color: "رنگ متن",
    background_color: "رنگ پس‌زمینه",

    // اسلایدر
    font_size: "اندازه فونت",

    // آیکن‌ها (text در v-select)
    robot: "ربات",
    chat: "چت",
    support: "پشتیبانی",
    question: "سوال",
    message: "پیام",
    assistant_voice: "دستیار",
    ai_brain: "هوش مصنوعی",

    // تب سوم - لید
    lead_connection_title: "اتصال به باشگاه مشتریان",
    lead_alert:
      "تعیین این تنظیمات باعث می‌شود در صورت انتخاب گزینه «دریافت لید»، شماره در باشگاه مشتریان ذخیره شود.",
    // سوئیچ‌های لید
    hasAssistantsName_label: "دریافت نام دستیار",
    hasAssistantsName_hint: "نام دستیار از کاربر دریافت شود",
    hasAssistantsFamily_label: "دریافت نام خانوادگی دستیار",
    hasAssistantsFamily_hint: "نام خانوادگی دستیار از کاربر دریافت شود",
    hasAssistantsMobile_label: "دریافت شماره موبایل دستیار",
    hasAssistantsMobile_hint: "شماره موبایل دستیار از کاربر دریافت شود",
  },
  assistantChatViewer: {
    assistant_name: "دستیار هوشمند",
    online: "آنلاین",
    new_chat: "چت جدید",
    clear_chat: "حذف چت",
    close: "بستن",
    message_placeholder: "پیام...",
    processing: "در حال پردازش...",
    renew: "تمدید",
    created_at: "زمان ایجاد",
    last_edit: "آخرین ویرایش",
    copied: "کپی شد",
    copy: "کپی",
    print_qr: "چاپ QR",
    print_visit_card: "چاپ کارت ویزیت",
    send_link: "ارسال لینک",
    winner_list: "لیست برندگان",
    customer_list: "لیست مشتریان",
    order_list: "لیست سفارشات",
    reserved_appointments: "رزروهای انجام شده",
    feedback: "بازخورد",
    request_form: "فرم درخواست",
    transfer_ownership: "انتقال مالکیت",
    store_management: "مدیریت فروشگاه",
    select_nfc_card: "انتخاب کارت NFC",
    edit: "ویرایش",
    design: "طراحی",
    qr_settings: "تنظیمات QR",
    deactivate: "غیرفعال کردن",
    download: "دانلود",
    viewed: "بار مشاهده شده",
    see_more: "مشاهده بیشتر",
    updating_qr: "در حال به‌روزرسانی QR...",
  },

  create_game: "ایجاد بازی",
  ready_games: "بازی‌های آماده",
  add_game: "افزودن بازی",
  game_gallery: "گالری بازی‌ها",
  game_size_error: "حجم فایل بازی نباید از 2MB بیشتر شود",
  game_upload_error: "خطا در آپلود بازی",
  no_game_available: "هیچ بازی‌ای موجود نیست",
  to_use_ready_games_search_category_or_product:
    "برای استفاده از بازی‌های آماده، دسته‌بندی یا محصول را جستجو کنید",
  gif_size_error: "حجم فایل گیف نباید از 2MB بیشتر شود",
  previewer_page: "نمایش پیش‌نمایش",
  // ─────────────────────────────────────────────────────
  // کلیدهای ترجمه برای بخش بازی، گیف و تنظیمات
  // فایل: src/core/services/langs/fa.js
  // ─────────────────────────────────────────────────────

  // ══════════════════════════════════════════════════════
  // 1. ویرایشگر اصلی بازی (PublicGameEditor)
  // ══════════════════════════════════════════════════════
  game_editor: "ویرایشگر بازی",
  reset_defaults: "بازگشت به پیش‌فرض",
  save_and_preview: "ذخیره و پیش‌نمایش",
  texts: "متن‌ها",
  images: "تصاویر",
  colors: "رنگ‌ها",
  general_settings: "تنظیمات عمومی",
  gameplay_settings: "تنظیمات گیم‌پلی",
  effects: "افکت‌ها",
  login_and_phone: "لاگین و شماره تماس",
  no_settings_available_for_this_game_type:
    "تنظیماتی برای این نوع بازی وجود ندارد",
  confirm_reset: "تایید بازنشانی",
  reset_all_settings_to_default:
    "آیا مطمئن هستید که می‌خواهید همه تنظیمات به حالت پیش‌فرض برگردد؟",
  yes_reset: "بله، بازنشانی کن",
  cancel: "انصراف",
  settings_reset_successfully: "تنظیمات با موفقیت بازنشانی شد",
  saved_and_ready_for_preview: "ذخیره شد و آماده پیش‌نمایش است",

  // ══════════════════════════════════════════════════════
  // 2. تب لاگین و شماره تماس (TabLogin)
  // ══════════════════════════════════════════════════════
  login_and_phone_settings: "تنظیمات لاگین و شماره تماس",
  ask_phone_after_game: "درخواست شماره پس از پایان بازی",
  phone_prompt_text: "متن درخواست شماره موبایل",
  phone_prompt_hint: "متنی که در دیالوگ درخواست شماره نمایش داده می‌شود",
  submit_button: "دکمه ثبت",
  login_dialog_logo: "لوگوی دیالوگ لاگین",
  logo_url: "آدرس لوگو",

  // ══════════════════════════════════════════════════════
  // 3. تب افکت‌ها (TabEffect)
  // ══════════════════════════════════════════════════════
  game_effects_settings: "تنظیمات افکت‌های بازی",
  sound_enabled: "فعال کردن صدا",
  volume: "حجم صدا",
  volume_hint: "میزان حجم صدای بازی (0 تا 1)",
  oscillator_type: "نوع نوسانگر صدا",
  jump_sound_freq: "فرکانس صدای پرش",
  hit_sound_freq: "فرکانس صدای برخورد",
  powerup_sound_freq: "فرکانس صدای پاورآپ",
  move_sound_freq: "فرکانس صدای حرکت",
  combo_base_freq: "فرکانس پایه کومبو",
  sound_durations: "مدت زمان صداها",
  move_duration_ms: "مدت صدای حرکت (میلی‌ثانیه)",
  jump_duration_ms: "مدت صدای پرش (میلی‌ثانیه)",
  combo_duration_ms: "مدت صدای کومبو (میلی‌ثانیه)",
  hit_duration_ms: "مدت صدای برخورد (میلی‌ثانیه)",
  vibration_enabled: "فعال کردن لرزش",
  particles_enabled: "فعال کردن ذرات",
  explosion_settings: "تنظیمات انفجار ذرات",
  particle_count: "تعداد ذرات",
  gravity: "گرانش",
  friction: "اصطکاک",
  fade_speed: "سرعت محو شدن",

  // ══════════════════════════════════════════════════════
  // 4. تب تصاویر (TabImages)
  // ══════════════════════════════════════════════════════
  game_images_and_assets: "تصاویر و دارایی‌های بازی",
  player_image: "تصویر بازیکن",
  player: "بازیکن",
  powerup_image: "تصویر پاورآپ",
  qr_powerup: "پاورآپ QR",
  enemy_images: "تصاویر دشمنان",
  optional_multi: "اختیاری، چند تصویر",
  enemies: "دشمنان",
  background_image: "تصویر پس‌زمینه",
  background: "پس‌زمینه",
  phone_frame_background: "پس‌زمینه قاب گوشی",
  phone_frame: "قاب گوشی",
  winner_background: "پس‌زمینه برنده",
  winner: "برنده",
  ground_image: "تصویر زمین",
  ground: "زمین",
  player_character: "کاراکتر بازیکن",
  far_background_layer: "لایه پس‌زمینه دور",
  background_far: "پس‌زمینه دور",
  near_background_layer: "لایه پس‌زمینه نزدیک",
  background_near: "پس‌زمینه نزدیک",
  obstacle_images: "تصاویر موانع",
  multi_optional: "چند تصویر، اختیاری",
  obstacles: "موانع",

  // ══════════════════════════════════════════════════════
  // 5. تب متن‌ها (TabTexts)
  // ══════════════════════════════════════════════════════
  game_text_contents: "محتوای متنی بازی",
  main_screen_texts: "متن‌های صفحه اصلی",
  game_title: "عنوان بازی",
  game_subtitle: "زیرعنوان بازی",
  start_button: "دکمه شروع",
  score_label: "برچسب امتیاز",
  game_over_screen: "صفحه پایان بازی",
  game_over_title: "عنوان پایان بازی",
  game_over_subtitle: "زیرعنوان پایان بازی",
  phone_prompt: "درخواست شماره موبایل",
  restart_button: "دکمه شروع دوباره",
  hud_and_labels: "نمایشگر و برچسب‌ها",
  level_label: "برچسب مرحله",
  combo_label: "برچسب کومبو",
  final_score_label: "برچسب امتیاز نهایی",
  high_score_label: "برچسب بیشترین امتیاز",
  messages_and_popups: "پیام‌ها و پنجره‌های بازشو",
  new_record_message: "پیام رکورد جدید",
  fun_random_messages: "پیام‌های تصادفی سرگرم‌کننده",
  add_new_message: "افزودن پیام جدید",

  // ══════════════════════════════════════════════════════
  // 6. تب تنظیمات عمومی (TabSetting)
  // ══════════════════════════════════════════════════════
  general_game_settings: "تنظیمات عمومی بازی",
  enemy_spawn_rate: "نرخ ظاهر شدن دشمنان",
  frames_between_enemies_spawn: "تعداد فریم‌های بین ظاهر شدن هر دشمن",
  powerup_spawn_rate: "نرخ ظاهر شدن پاورآپ",
  frames_between_qr_spawn: "تعداد فریم‌های بین ظاهر شدن QR",
  win_score_threshold: "آستانه امتیاز برد",
  score_required_for_win_or_phone_prompt:
    "امتیاز مورد نیاز برای برد یا نمایش دیالوگ شماره",
  starting_lives: "تعداد جان اولیه",
  high_score_storage_key: "کلید ذخیره‌سازی بیشترین امتیاز",
  phone_prompt_score_threshold: "آستانه امتیاز برای درخواست شماره",
  score_to_show_phone_number_form: "امتیاز لازم برای نمایش فرم شماره موبایل",
  no_general_settings_available_for_this_game:
    "تنظیمات عمومی برای این بازی وجود ندارد",

  // ══════════════════════════════════════════════════════
  // 7. تب گیم‌پلی (TabGamePlay)
  // ══════════════════════════════════════════════════════
  speed_settings: "تنظیمات سرعت",
  initial_speed: "سرعت اولیه",
  max_speed: "حداکثر سرعت",
  speed_increase_every_frames: "افزایش سرعت هر چند فریم",
  speed_increase_amount: "میزان افزایش سرعت",
  distance_per_level: "مسافت هر مرحله",
  level_speed_increase: "افزایش سرعت هر مرحله",
  jump_and_physics: "پرش و فیزیک",
  jump_force: "نیروی پرش",
  max_jump_height: "حداکثر ارتفاع پرش",
  lanes_settings: "تنظیمات لاین‌ها",
  number_of_lanes: "تعداد لاین‌ها",
  starting_lane: "لاین شروع",
  enemies_spawn: "ظاهر شدن دشمنان",
  traps_spawn: "ظاهر شدن موانع",
  min_spawn_interval_ms: "حداقل فاصله ظاهر شدن (میلی‌ثانیه)",
  max_spawn_interval_ms: "حداکثر فاصله ظاهر شدن (میلی‌ثانیه)",
  same_lane_chance: "احتمال ظاهر در همان لاین",
  probability_of_spawn_in_player_lane: "احتمال ظاهر شدن در لاین بازیکن",
  collision_tolerance_px: "تلورانس برخورد (پیکسل)",
  scoring_rules: "قوانین امتیازدهی",
  hit_penalty: "جریمه برخورد",
  powerup_reward: "جایزه پاورآپ",
  score_speed_divider: "تقسیم‌کننده امتیاز سرعت",
  reset_combo_on_hit: "ریست کومبو با برخورد",
  camera_settings: "تنظیمات دوربین",
  normal_zoom: "زوم عادی",
  hit_zoom: "زوم هنگام برخورد",
  zoom_lerp_speed: "سرعت نرم‌سازی زوم",
  game_end_conditions: "شرایط پایان بازی",
  phone_dialog_score_threshold: "آستانه امتیاز برای دیالوگ شماره",

  // ══════════════════════════════════════════════════════
  // 8. تب رنگ‌ها (TabColors)
  // ══════════════════════════════════════════════════════
  background_gradient: "گرادیان پس‌زمینه",
  first_color: "رنگ اول",
  second_color: "رنگ دوم",
  particle_hit_color: "رنگ ذرات برخورد",
  particle_powerup_color: "رنگ ذرات پاورآپ",
  main_background_color: "رنگ اصلی پس‌زمینه",
  ground_color: "رنگ زمین",
  hud_colors: "رنگ‌های نمایشگر",
  hud_background: "پس‌زمینه نمایشگر",
  score_text_color: "رنگ متن امتیاز",
  level_text_color: "رنگ متن مرحله",
  combo_text_color: "رنگ متن کومبو",
  overlay_colors: "رنگ‌های لایه رویه",
  backdrop_color: "رنگ پس‌زمینه لایه",
  card_background: "پس‌زمینه کارت",
  card_border_color: "رنگ حاشیه کارت",
  explosion_particle_color: "رنگ ذرات انفجار",

  // ══════════════════════════════════════════════════════
  // 9. کامپوننت پیش‌نمایش QR (previewerQr)
  // ══════════════════════════════════════════════════════
  gif_tab: "گیف",
  game_tab: "بازی",
  welcome_gif_upload: "بارگذاری گیف خوش‌آمدگویی",
  loading_animation: "انیمیشن بارگذاری",
  hide_previewer: "مخفی کردن پیش‌نمایش",
  show_previewer: "نمایش پیش‌نمایش",
  edit_game_settings: "ویرایش تنظیمات بازی",
  save_and_close: "ذخیره و بستن",
  animation_scale: "انیمیشن مقیاس",
  animation_slide_x: "انیمیشن اسلاید افقی",
  animation_slide_y: "انیمیشن اسلاید عمودی",
  animation_fade: "انیمیشن محو شدن",
  game_settings_saved: "تنظیمات بازی ذخیره شد",
  no_game_configured: "بازی پیکربندی نشده است",

  // ══════════════════════════════════════════════════════
  // 10. انتخابگر گیف (gifSelector)
  // ══════════════════════════════════════════════════════
  gallery_name: "نام گالری",
  change_gallery_name: "تغییر نام گالری",
  add_gif: "افزودن گیف",
  select_gif: "انتخاب گیف",
  show_gif: "نمایش گیف",
  selected_gif: "گیف انتخاب شده",
  count: "تعداد",
  select_category: "انتخاب دسته‌بندی",
  after_typing_enter: "بعد از تایپ، اینتر بزنید",
  search: "جستجو",
  no_gif_available: "گیف موجود نیست",
  to_use_ready_gifs_search_category_or_product:
    "برای استفاده از گیف‌های آماده، دسته‌بندی یا محصول را جستجو کنید",
  max_file_size_2mb: "حداکثر حجم فایل 2 مگابایت",
  upload_file: "آپلود فایل",
  drag_and_drop_to_upload_or: "فایل را بکشید و اینجا رها کنید یا",
  here: "اینجا",
  click: "کلیک کنید",
  all: "همه",
  no_gif_found: "گیفی یافت نشد",
  for_adding_file_use_upload_center:
    "برای افزودن فایل از مرکز آپلود استفاده کنید",
  to_use_external_gif_link_fill_fields:
    "برای استفاده از لینک خارجی گیف، فیلدها را پر کنید",
  gif_url_hint: "آدرس کامل فایل گیف",
  gif_url: "آدرس گیف",
  add: "افزودن",
  title: "عنوان",
  link: "لینک",
  description: "توضیحات",
  add_new_gallery: "افزودن گالری جدید",
  enter_valid_link: "لینک معتبر وارد کنید",
  create_gif: "ساخت گیف",
  ready_gifs: "گیف‌های آماده",
  gif_gallery: "گالری گیف",
  edit_gif: "ویرایش گیف",
  max_background_gif_size_2mb: "حداکثر حجم گیف پس‌زمینه 2 مگابایت است",
  uploaded_successfully: "با موفقیت آپلود شد",
  gif_upload_error: "خطا در بارگذاری گیف",

  // ══════════════════════════════════════════════════════
  // 11. متن‌های اضافی و کلیدهای دیگر تست‌ها
  // ══════════════════════════════════════════════════════
  preview: "پیش‌نمایش",
  start_button_text: "متن دکمه شروع",
  game_over_text: "متن پایان بازی",
  game_over_subtext: "زیرمتن پایان بازی",
  mobile_prompt_text: "متن درخواست موبایل",
  submit_button_text: "متن دکمه ثبت",
  optional: "اختیاری",
  game_background: "پس‌زمینه بازی",
  background_gradient_colors: "رنگ‌های گرادیان پس‌زمینه",
  frames_per_enemy: "فریم به ازای هر دشمن",
  frames_per_powerup: "فریم به ازای هر پاورآپ",
  win_threshold: "آستانه برد",
  score_to_win: "امتیاز برای برد",
  your_work_page_name: "کیوار شخصی/ شرکتی",

  "pdf_gallery": {
    "display_mode": "حالت نمایش گالری PDF",
    "display_mode_label": "حالت نمایش",
    "layout": {
      "list": "نمایش به صورت لیست",
      "accordion": "نمایش آکاردئونی",
      "slider": "نمایش به صورت اسلایدر"
    },
    "gallery_name": "نام گالری",
    "selected_gallery": "گالری انتخابی",
    "add_file": "افزودن فایل",
    "pdf_gallery_label": "گالری پی دی اف",
    "select_file": "انتخاب فایل",
    "title": "عنوان",
    "pdf_url": "آدرس پی‌دی‌اف",
    "description": "توضیحات",
    "add_button": "افزودن",
    "all": "همه",
    "image_gallery": "گالری تصاویر",
    "edit_pdf": "ویرایش پی‌دی‌اف",
    "preview": "پیش نمایش",
    "add_pdf_gallery": "افزودن گالری پی دی اف",
    "default_gallery_name": "گالری",
    "gallery_prefix": "گالری",
    "tabs": {
      "add_file": "افزودن فایل",
      "pdf_gallery": "گالری پی دی اف",
      "link": "لینک"
    },
    "messages": {
      "file_too_large": "حجم فایل نمی‌تواند بیشتر از 10 مگابایت باشد.",
      "invalid_file_type": "لطفاً فقط فایل‌های اسناد و متنی انتخاب کنید.",
      "upload_error": "خطا در آپلود فایل",
      "only_pdf_txt_allowed": "فقط فایل‌های PDF و TXT قابل افزودن هستند.",
      "title_url_required": "لطفاً عنوان و آدرس فایل را وارد کنید."
    }
  },
  "special_info_desc": {
    "textCards": "افزودن کارت‌های متنی برای نمایش اطلاعات کاربر مانند توضیحات، سوابق یا معرفی کوتاه.",
    "customerClubSettings": "تنظیم پیام عضویت در باشگاه مشتریان که پس از ثبت شماره برای کاربران ارسال می‌شود.",
    "advanceSettings": "مدیریت تنظیمات پیشرفته و هوشمند برای شخصی‌سازی رفتار و امکانات صفحه.",
    "voiceGallery": "بارگذاری و مدیریت فایل‌های صوتی برای پخش در صفحه.",
    "VideoGallery": "افزودن و نمایش ویدیوها برای معرفی، آموزش یا نمایش محتوا.",
    "imageUploader": "بارگذاری تصاویر برای نمایش در گالری یا بخش‌های مختلف صفحه.",
    "colorPallete": "انتخاب رنگ‌های دلخواه برای شخصی‌سازی ظاهر و طراحی صفحه.",
    "socialMediaIcons": "افزودن لینک شبکه‌های اجتماعی برای دسترسی سریع کاربران.",
    "pdfSelector": "بارگذاری و نمایش فایل‌های PDF برای دانلود یا مشاهده کاربران.",
    "FeedBack": "دریافت نظرات و بازخورد کاربران درباره خدمات یا محتوا.",
    "consultationNew": "ایجاد فرم برای ثبت درخواست، مشاوره یا ارتباط کاربران."
  },

"voice_gallery": {
    "autoplay_warning": "در آن واحد تنها یک فایل صوتی را می‌توانید در حالت پخش خودکار قرار دهید.",
    "autoplay":"پخش خودکار",
  },
  "card": {
    "consultation": {
      "title": "فرم درخواست"
    },
    "form": {
      "name": "نام",
      "surname": "نام خانوادگی",
      "phone": "شماره موبایل",
      "email": "ایمیل",
      "address": "آدرس",
      "national_id": "کدملی",
      "location": "لوکیشن",
      "description": "توضیحات"
    },
    "feedback": {
      "title": "بازخورد شما",
      "description": "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
      "q1": "چقدر از خدمات کیوآرلند راضی بوده اید؟",
      "q2": "خدمات کیوآرلند چه میزان از نیازهای شما را پوشش داده است؟",
      "q3": "میزان هزینه پرداختی بابت سرویس دریافتی چقدر معقول بوده است؟",
      "q4": "برای بهبود خدمات نظر خود را با ما درمیان بگذارید."
    },
    "pdf": {
      "gallery_name": "گالری پروپزال‌های کیوآرلند",
      "item1_title": "پروپزال معرفی محصول",
      "item1_desc": "معرفی کامل سرویس‌های کیوآرلند، نحوه کار QR کدهای هوشمند، مزایا برای کسب‌وکارها و نمونه کاربردها برای افزایش تعامل مشتریان.",
      "item2_title": "پروپزال کارت ویزیت الکترونیکی",
      "item2_desc": "معرفی کارت ویزیت دیجیتال کیوآرلند، امکانات اشتراک سریع اطلاعات تماس، لینک شبکه‌های اجتماعی و مدیریت حرفه‌ای ارتباط با مشتریان."
    },
    "pdf_selector": {
      "title": "گالری پی دی اف",
      "description": "توضیحات"
    },
    "info": {
      "visit_name": "کیوآر لند/کارت ویزیت الکترونیکی",
      "organization_name": "کیوآر لند",
      "sub_organ": "اولین سامانه ساخت کیوآر داینامیک",
      "user_name": "کارت ویزیت الکترونیکی",
      "fax": "فکس 02191016066",
      "location_desc": "تهران، خیابان شریعتی\nبعد از پل سید خندان، بن بست خندان ، پلاک 6",
      "postal_code": "کد پستی 1541946815",
      "about_us": "باتوجه به مشکلات موجود در کارت ویزیت فیزیکی\nسامانه کیوآر لند محصولی به نام \"کارت ویزیت الکترونیکی\"\nرا ارائه نموده است.\nو با استفاده از تکنولوژی های دیجیتالی\nتوانسته مشکلات و محدودیت های موجود در\nکارت ویزیت های فیزیکی را به طور کامل برطرف نماید.\nهمزمان، با جایگزین کردن هوشمندی، از قطع بی رویه درختان جلوگیری کنید.",
      "full_address": "ایران، تهران، شهر تهران، تهران، منطقه ۳ شهر تهران، محله سید خندان، دکتر علی شریعتی، خندان"
    },
    "extra": {
      "field1": "\n🟥مشابه همین کارت ویزیت الکترونیکی را برای کسب و کار خود بسازید.\n🟧3 روز رایگان تست کنید.\n🟨برای ثبت نام رایگان کلیک کنید.",
      "field2": "کارت ویزیت الکترونیکی شما دارای كيوار دايناميك است.\nدر هر زمان ميتوانيد با موبایل خود اطلاعات را ویرایش کنید.\nكيوآر كد شما هيچگاه پس از ویرایش تغيير نميكند.",
      "field3": "💲هزینه داشتن این کارت ویزیت 900هزار تومان است."
    },
    "gallery": {
      "name": "ما همیشه کنار شما خواهیم ماند..."
    },
    "social": {
      "address_hint": "لطفا آدرس خود را وارد کنید",
      "address_label": "آدرس",
      "instagram_hint": "لطفا آدرس اینستاگرام خود را وارد کنید",
      "instagram_label": "اینستاگرام",
      "whatsapp_hint": "لطفا آدرس واتساپ خود را وارد کنید",
      "whatsapp_label": "واتساپ"
    },
    "video": {
      "item1_name": "چرا کارت ویزیت کیو آر لند؟ کیو آر لند با بقیه چه فرقی داره؟",
      "item1_title": "چرا کارت ویزیت کیوآر لند",
      "item2_name": "معرفی کارت ویزیت الکترنیکی کیوآر لند",
      "item2_title": "بهترین جایگزین کارت ویزیت فیزیکی"
    },
    "club": {
      "title": "عضویت در باشگاه مشتریان",
      "description": "این یک باشگاه مشتریان عادی نیست!\nشمارتو ثبت کن"
    },
    "audio": {
      "category_all": "همه",
      "item1_title": "راهنمای جامع کارت ویزیت الکترونیکی",
      "diff_seconds": "1 ثانیه پیش"
    }
  },
   "pic":{
   "background_image": "تصویر پس‌زمینه",
  "image_display_type": "نوع نمایش تصاویر",
  "image_orientation": "جهت تصویر:",
  "horizontal": "افقی",
  "vertical": "عمودی",
  "change_display_mode": "تغییر نحوه نمایش",
  "image": "تصویر",
  "uploaded_image": "تصویر آپلود شده"
  },
   "send_limit_per_user": "دفعات ارسال برای کاربر (۰ = نامحدود)",
  "enable_discount_code": "فعال‌سازی کد تخفیف",
  "add_new_discount_code": "افزودن کد تخفیف جدید",
  "no_discount_codes_added": "هیچ کد تخفیفی وارد نشده است",

  "toolsManagment":' ابزارهای مدیریت',
  "gateway":{
  "edit": "ویرایش",
  "integrated_edit_all_sections": "ویرایش یکپارچه تمامی بخش‌ها",
  "show_descriptions": "نمایش توضیحات",
  "search_section_placeholder": "جستجوی بخش مورد نظر...",
  "no_section_found": "بخشی با این نام یافت نشد.",
  "back_to_menu": "برگشت به منو",
  "cancel": "انصراف",
  "save": "ذخیره"
},
"gridShow":"نمایش کارتی",
"tableShow":"نمایش جدولی",

"editvisit":{
  special_info_single: {
    text_cards_description:
      "افزودن کارت‌های متنی برای نمایش اطلاعات کاربر مانند توضیحات، سوابق یا معرفی کوتاه.",
    customer_club_settings_description:
      "تنظیم پیام عضویت در باشگاه مشتریان که پس از ثبت شماره برای کاربران ارسال می‌شود.",
    advance_settings_description:
      "مدیریت تنظیمات پیشرفته و هوشمند برای شخصی‌سازی رفتار و امکانات صفحه.",
    voice_gallery_description:
      "بارگذاری و مدیریت فایل‌های صوتی برای پخش در صفحه.",
    video_gallery_description:
      "افزودن و نمایش ویدیوها برای معرفی، آموزش یا نمایش محتوا.",
    image_uploader_description:
      "بارگذاری تصاویر برای نمایش در گالری یا بخش‌های مختلف صفحه.",
    color_palette_description:
      "انتخاب رنگ‌های دلخواه برای شخصی‌سازی ظاهر و طراحی صفحه.",
    social_media_icons_description:
      "افزودن لینک شبکه‌های اجتماعی برای دسترسی سریع کاربران.",
  },
},
"editBpage":{
  special_info_single: {
     banner_selector_description:
    "تصویر بنر اصلی مجتمع را بارگذاری یا تغییر دهید.",
  logo_select_description:
    "لوگوی کسب‌وکار یا مجتمع را تنظیم کنید.",
  service_description:
    "خدمات و امکانات اصلی مجموعه را مدیریت کنید.",
  faq_description:
    "سوالات متداول مشتریان را ثبت و ویرایش کنید.",
  blog_description:
    "مقالات و اخبار مربوط به مجموعه را اضافه کنید.",
  floor_description:
    "طبقات و واحدهای فروشگاهی مجتمع را مدیریت کنید.",
  text_cards_description:
    "توضیحات و اطلاعات کاربری مرتبط را وارد نمایید.",
  social_media_icons_description:
    "لینک شبکه‌های اجتماعی برای ارتباط مشتریان.",
  pic_selector_description:
    "تصاویر محیط مجتمع و فروشگاه‌ها را اضافه کنید.",
  video_gallery_description:
    "ویدیوهای معرفی یا تبلیغاتی را بارگذاری کنید.",
  pdf_selector_description:
    "کاتالوگ‌ها و فایل‌های راهنمای متنی را مدیریت کنید.",
  feedback_description:
    "بخش نظرات و بازخوردهای مراجعین را مدیریت کنید.",
  consultation_new_description:
    "فرم دریافت اطلاعات یا درخواست‌های مشتریان را مدیریت کنید.",
  service_section_description:
    "بخش‌بندی‌های اختصاصی خدمات را ایجاد کنید.",
  counter_service_description:
    "آمارها و دستاوردهای مجتمع را به‌صورت عددی نمایش دهید.",
  counter_description:
    "شمارش معکوس برای رویدادها یا افتتاحیه‌ها را تنظیم کنید.",
  personnel_description:
    "مدیران و اعضای کلیدی تیم را معرفی کنید.",
  customer_club_settings_description:
    "تنظیمات پیامک و ثبت‌نام در باشگاه مشتریان را مدیریت کنید.",
  work_sheet_description:
    "ساعات کاری و روزهای فعالیت مجتمع را مشخص کنید.",
  pallet_commercial_description:
    "رنگ‌بندی و استایل ظاهری صفحه را تنظیم کنید.",
  default_description:
    "افزودن و مدیریت بخش {title} در صفحه کاری.",
},
},
store_special_info_single: {
  shop_login_config_description:
    "تنظیمات صفحه ورود و تغییر لوگوی فروشگاه",
  banner_selector_description:
    "آپلود و مدیریت بنرهای فروشگاه",
  text_cards_description:
    "اطلاعات متنی، معرفی و درباره ما",
  product_description:
    "ایجاد، مدیریت و ویرایش محصولات",
  special_category_manager_description:
    "مدیریت دسته‌بندی‌های فروش ویژه و تخفیف‌دار",
  social_media_icons_description:
    "افزودن لینک شبکه‌های اجتماعی فروشگاه",
  blog_description:
    "نوشتن و مدیریت مطالب وبلاگ",
  service_description:
    "معرفی خدمات جانبی ارائه‌شده",
  faq_description:
    "نمایش و مدیریت فهرست سوالات متداول کاربران",
  pic_selector_description:
    "آپلود و مدیریت گالری تصاویر فروشگاه",
  video_gallery_description:
    "آپلود ویدیوهای معرفی و تبلیغاتی",
  pdf_selector_description:
    "ارائه فایل‌های راهنما یا کاتالوگ PDF",
  feedback_description:
    "مدیریت بخش نظرات و بازخوردهای مشتریان",
  counter_description:
    "تنظیم شمارشگر معکوس برای رویدادها یا تخفیف‌ها",
  consultation_description:
    "ایجاد فرم دریافت درخواست یا مشاوره",
  service_section_description:
    "مدیریت بخش‌های اختصاصی خدمات",
  counter_service_description:
    "نمایش آمار، ارقام و دستاوردهای فروشگاه",
  personnel_description:
    "معرفی اعضای تیم و پرسنل فروشگاه",
  work_sheet_description:
    "تنظیم روزها و ساعات کاری فروشگاه",
  default_description:
    "افزودن و مدیریت بخش {title} در صفحه فروشگاه.",
},
edit_gold_special_info_single: {
  product_info_title: "اطلاعات محصول",
  product_info_description:
    "ثبت و ویرایش مشخصات اصلی محصول، ویژگی‌ها، قیمت و توضیحات تکمیلی.",
  asset_management_title: "مدیریت دارایی",
  asset_management_description:
    "مدیریت دارایی‌ها، تخصیص ارزش و اطلاعات کیف پول مرتبط با محصول.",
  add_social_networks_title:
    "افزودن شبکه‌های اجتماعی",
  social_networks_title:
    "شبکه‌های اجتماعی",
  social_media_description:
    "افزودن لینک شبکه‌های اجتماعی برای ارتباط سریع‌تر مشتریان با برند شما.",
  add_video_title:
    "افزودن ویدئو",
  video_description:
    "افزودن و نمایش ویدیوهای معرفی، آموزشی یا تبلیغاتی برای محصول.",
  add_image_title:
    "افزودن تصویر",
  image_description:
    "بارگذاری تصاویر باکیفیت از زوایای مختلف برای نمایش بهتر محصول در گالری.",
  select_color_title:
    "انتخاب رنگ",
  color_palette_description:
    "شخصی‌سازی ترکیب رنگی و ظاهر صفحه نمایش محصول متناسب با هویت برند شما.",
},
edit_multicard_special_info_single: {
  add_account_description:
    "ویرایش نام، تصویر پروفایل و پس‌زمینه",
  management_account_description:
    "افزودن و ویرایش اطلاعات حساب‌های بانکی",
  management_color_description:
    "تغییر تم رنگی دکمه‌ها و پس‌زمینه",
},
edit_feedback_special_single: {
  base_info_description:
    "ویرایش اطلاعات پایه و عنوان فرم",
  image_uploader_description:
    "آپلود و مدیریت لوگوی فرم بازخورد",
  feedback_description:
    "تنظیمات فیلدها و مدیریت فرم دریافت بازخورد",
  color_palette_description:
    "انتخاب تم رنگی و شخصی‌سازی ظاهر فرم",
},
edit_gitf_special_info_single: {
  default_description:
    "افزودن و مدیریت بخش {title} در کیوآر قاب خاطره‌ها.",
},
edit_catalog_special_info_single: {
  text_cards_description:
    "اطلاعات پایه، عنوان و توضیحات کاتالوگ",
  image_uploader_description:
    "آپلود و مدیریت لوگو یا تصویر اصلی",
  pic_selector_description:
    "آپلود و مدیریت صفحات کاتالوگ یا بروشور",
  social_media_icons_description:
    "افزودن و مدیریت لینک شبکه‌های اجتماعی",
  color_palette_description:
    "انتخاب تم رنگی و شخصی‌سازی ظاهر",
},
edit_menu_special_info_single: {
  theme_selector_description:
    "انتخاب قالب برای اعمال دسته‌بندی متفاوت",
  login_config_description:
    "تنظیمات و شکل ظاهری صفحه ورود است",
  general_settings_description:
    "تنظیم کلی واحد پول و نوع کسب‌وکار شما.",
  banner_selector_description:
    "آپلود و انتخاب تصویر بنر برای نمایش در بالای صفحه و جذاب‌تر کردن ظاهر منو یا پروفایل.",
  product_description:
    "ایجاد و مدیریت محصولات یا خدمات به همراه جزئیاتی مانند تصویر، قیمت و توضیحات اختصاصی.",
  text_cards_description:
    "افزودن کارت‌های متنی برای نمایش اطلاعات پایه کاربر مانند توضیحات عمومی، سوابق یا معرفی کوتاه.",
  social_media_description:
    "افزودن لینک‌ها و آیکون‌های شبکه‌های اجتماعی جهت ارتباط سریع‌تر و دسترسی راحت‌تر مشتریان.",
  photo_gallery_description:
    "ایجاد گالری تصاویر برای نمایش عکس‌های محصولات، نمونه‌کارها یا محیط کسب‌وکار.",
  video_gallery_description:
    "افزودن گالری ویدئویی برای نمایش تیزرهای تبلیغاتی، ویدئوهای آموزشی یا معرفی.",
  feedback_description:
    "ایجاد بخشی برای نمایش نظرات، بازخوردها و میزان رضایت مشتریان قبلی.",
  working_hours_description:
    "تعیین و رضایت مشتریان قبلی.",
},
edit_pdf_special_info_single: {
  base_info_title: "اطلاعات",
  base_info_description:
    "افزودن کارت‌های متنی برای نمایش اطلاعات پایه کاربر مانند توضیحات عمومی، سوابق یا معرفی کوتاه.",
  image_uploader_title: "آپلود لوگو",
  image_uploader_description:
    "آپلود و انتخاب تصویر به عنوان لوگو یا عکس پروفایل جهت نمایش در صفحه.",
  pdf_selector_title: "افزودن گالری پی‌دی‌اف",
  pdf_selector_description:
    "ایجاد گالری از فایل‌های PDF یا متنی، با امکان افزودن تصویر کاور و نوشتن توضیحات اختصاصی برای هر فایل.",
  social_media_icons_title: "افزودن شبکه‌های اجتماعی",
  social_media_icons_description:
    "افزودن لینک‌ها و آیکون‌های شبکه‌های اجتماعی جهت ارتباط سریع‌تر و دسترسی راحت‌تر.",
  color_palette_title: "انتخاب رنگ",
  color_palette_description:
    "انتخاب رنگ قالب و شخصی‌سازی تم ظاهری المان‌ها برای هماهنگی بیشتر با برند شما.",
},
edi_photogallery_spcial_info_single: {
  default_description:
    "افزودن و مدیریت بخش {title} در گالری عکس.",
},
edi_social_special_info_single: {
  banner_selector_title: "آپلود عکس",
  banner_selector_description:
    "تصویر پس‌زمینه یا بنر بالای صفحه شبکه اجتماعی خود را انتخاب و آپلود کنید.",
  base_info_title: "اطلاعات",
  base_info_description:
    "اطلاعات پایه مانند عنوان اصلی و توضیحات پروفایل خود را وارد نمایید.",
  image_uploader_title: "آپلود لوگو",
  image_uploader_description:
    "لوگو یا تصویر پروفایل شخصی یا برند خود را برای نمایش در صفحه آپلود کنید.",
  social_media_icons_title: "افزودن شبکه‌های اجتماعی",
  social_media_icons_description:
    "لینک شبکه‌های اجتماعی خود مانند اینستاگرام، تلگرام، واتس‌اپ، لینکدین و سایر شبکه‌ها را اضافه کنید تا آیکون آن‌ها در صفحه قرار گیرد.",
},
edit_text_special_info_single: {
  base_info_title:
    "اطلاعات و متون کیوآر",
  base_info_subtitle:
    "متن اصلی و فیلدهای متنی",
  base_info_description:
    "ویرایش عنوان، متن اصلی درباره ما و فیلدهای متنی سفارشی کیوآر",
  image_uploader_title:
    "لوگو و تصویر پس‌زمینه",
  image_uploader_subtitle:
    "تنظیمات تصویر",
  image_uploader_description:
    "آپلود و تغییر لوگوی اختصاصی یا تصویر پس‌زمینه کارت",
  color_palette_subtitle:
    "شخصی‌سازی ظاهر",
  color_palette_description:
    "تنظیم رنگ سربرگ، پس‌زمینه و رنگ متون جهت بهبود خوانایی و کنتراست",
},
edit_video_special_info_single: {
  base_info_title:
    "اطلاعات",
  base_info_description:
    "ویرایش اطلاعات اصلی مانند عنوان و آدرس کیوآرکد.",
  image_uploader_title:
    "آپلود لوگو",
  image_uploader_description:
    "بارگذاری و مدیریت تصویر لوگوی صفحه.",
  video_gallery_title:
    "گالری ویدئو",
  video_gallery_description:
    "افزودن، ویرایش و مدیریت ویدئوها برای نمایش در گالری.",
  social_media_icons_title:
    "افزودن شبکه‌های اجتماعی",
  social_media_icons_description:
    "افزودن لینک‌های شبکه‌های اجتماعی و راه‌های ارتباطی.",
  color_palette_title:
    "انتخاب رنگ",
  color_palette_description:
    "تغییر رنگ‌بندی و انتخاب تم رنگی مناسب برای صفحه.",
},
edit_product_special_info_single: {
  factory_info_description:
    "ویرایش اطلاعات و معرفی مجموعه",
  single_product_editor_description:
    "ویرایش مشخصات اصلی و دکمه‌های فراخوان مانند خرید",
  customer_club_settings_description:"تنظیمات باشگاه مشتریان و ارسال پیامک",
  advance_settings_description: "تنظیمات پیشرفته نمایش و امنیتی",
  features_description: "مدیریت ویژگی‌ها و مشخصات فنی محصول",
  voice_gallery_description: "آپلود و مدیریت پادکست و فایل‌های صوتی",
  image_uploader_description: "آپلود و مدیریت گالری تصاویر محصول",
  video_gallery_description: "افزودن و مدیریت گالری ویدئوهای مرتبط",
  social_media_icons_description: "افزودن و مدیریت لینک شبکه‌های اجتماعی",
  color_palette_description: "انتخاب تم رنگی و شبکه‌های اجتماعی",
  color_palette_description: "انتخاب تم رنگی و شخصی‌سازی قالب",
},
edit_product_pro_special_info_single: {
  factory_info_description: "اطلاعات کلی و معرفی مجموعه تولیدی را وارد کنید.",
  single_product_editor_description: "اطلاعات اصلی، نشان اعتماد و دکمه خرید محصول را تنظیم کنید.",
  customer_club_settings_description: "تنظیمات پیامک و عضویت مشتریان در باشگاه.",
  features_description: "ویژگی‌ها و مشخصات فنی محصول را اضافه کنید.",
  feedback_description: "بخش نظرات و بازخوردهای خریداران.",
  consultation_description: "فرم درخواست مشاوره یا ثبت سفارش.",
  advance_settings_description: "تنظیمات پیشرفته و هوشمند نمایش محصول.",
  voice_gallery_description: "فایل‌های صوتی معرفی یا راهنمای محصول.",
  image_uploader_description: "تصاویر مختلف محصول را آپلود کنید.",
  video_gallery_description: "ویدئوهای معرفی یا آموزشی مرتبط با محصول.",
  social_media_icons_description: "لینک شبکه‌های اجتماعی برای ارتباط بیشتر.",
  color_palette_description: "رنگ‌بندی و استایل ظاهری صفحه محصول را تنظیم کنید.",
},
edit_voice_special_info_single: {
  base_info_voice_description: "اطلاعات پایه و مشخصات گالری صوتی",
  image_uploader_description: "آپلود و مدیریت لوگو یا تصویر کاور",
  voice_gallery_description: "آپلود و مدیریت فایل‌های صوتی و پادکست‌ها",
  color_palette_description: "انتخاب تم رنگی و شخصی‌سازی ظاهر گالری",
},
edit_voice_pro_special_info_single: {
  base_info_description: "ویرایش عنوان و توضیحات گالری",
  image_uploader_description: "آپلود و مدیریت لوگو و کاور اصلی",
  voice_gallery_acc_description: "آپلود، حذف و مدیریت فایل‌های صوتی",
  social_media_icons_description: "افزودن و مدیریت لینک شبکه‌های اجتماعی",
  color_palette_description: "انتخاب تم رنگی و شخصی‌سازی ظاهر گالری",
},
edit_bpage_special_info_special: {
  advertising_sites: "سایت‌های تبلیغاتی",
  stores: "استورها",

  divar: "دیوار",
  divar_hint: "لینک دیوار را وارد کنید",

  sheypoor: "شیپور",
  sheypoor_hint: "لینک شیپور را وارد کنید",

  digikala: "دیجی‌کالا",
  digikala_hint: "لینک دیجی‌کالا را وارد کنید",

  basalam: "باسلام",
  basalam_hint: "لینک باسلام را وارد کنید",

  snappshop: "اسنپ‌شاپ",
  snappshop_hint: "لینک اسنپ‌شاپ را وارد کنید",

  technolife: "تکنولایف",
  technolife_hint: "لینک تکنولایف را وارد کنید",

  torob: "ترب",
  torob_hint: "لینک ترب را وارد کنید",

  emalls: "ایمالز",
  emalls_hint: "لینک ایمالز را وارد کنید",

  cafebazaar: "کافه‌بازار",
  cafebazaar_hint: "لینک کافه‌بازار را وارد کنید",

  googleplay: "گوگل پلی",
  googleplay_hint: "لینک گوگل پلی را وارد کنید",

  samsung: "سامسونگ",
  samsung_hint: "لینک گلکسی استور را وارد کنید",

  apple: "اپل",
  apple_hint: "لینک اپ استور را وارد کنید",
  add_audio_gallery: "افزودن گالری فایل صوتی",
  factory_information: "اطلاعات مجموعه",
  trust_badge: "نشان اعتماد",
  buy_button: "دکمه خرید",
  smart_settings: "تنظیمات هوشمند",
  add_product_feature: "افزودن ویژگی محصول",
  product_features: "ویژگی های محصول",
  add_audio_file: "افزودن فایل صوتی",
  audio_gallery: "گالری صوتی",
  text: "متن",
  logo_background: "لوگو/ پس زمینه",
  select_color: "انتخاب رنگ",
  information: "اطلاعات",
  luck_management: "مدیریت شانس",
  registration_management: "مدیریت ثبت نام",
  turning: "ورق زدن",
  slider: "اسلایدر",
  vertical: "عمودی",
  upload_catalog_brochure_images: "آپلود تصاویر کاتالوگ / بروشور",
  upload_banner: "آپلود بنر",
  upload_header_image: "آپلود عکس هدبار",
  upload_image: "آپلود عکس",
  services: "خدمات",
  faq: "سوالات متداول",
  blog: "بلاگ",
  create_product: "ایجاد محصول",
  user_information: "اطلاعات کاربری",
  add_social_media: "افزودن شبکه های اجتماعی",
  photo_gallery: "گالری عکس",
  video_gallery: "گالری ویدئو",
  pdf_gallery: "گالری پی دی اف",
  feedback: "بازخورد",
  request_form: "فرم درخواست",
  create_section: "ایجاد بخش",
  achievements: "موفقیت های بدست آمده",
  countdown: "شمارنده معکوس",
  team_members: "اعضای تیم",
  working_hours: "تایم کاری",
  upload_logo: "آپلود لوگو",
  create_store: "ایجاد فروشگاه",
  customer_club_membership_sms: "پیامک عضویت در باشگاه مشتریان",
  product_information: "اطلاعات محصول",
  asset_management: "مدیریت دارایی",
  social_media: "شبکه های اجتماعی",
  add_video: "افزودن ویدئو",
  add_image: "افزودن تصویر",
  add_user_information: "افزودن اطلاعات کاربر",
  manage_accounts: "مدیریت حساب ها",
  manage_color: "مدیریت رنگ",
  download_qr: "دانلود کیوآر",
  add_store: "افزودن استور",
  manage_appointments: "مدیریت نوبت ها",
},
edit_gift_special_info_special: {
  gift_story: "داستان هدیه",
  profile_image: "تصویر پروفایل",
  featured_images: "تصاویر منتخب",
  image_gallery: "گالری تصویر",
  video_gallery: "گالری ویدئو",
  add_audio_file: "افزودن فایل صوتی",
  select_color: "انتخاب رنگ",
},
edit_insurance_special_info_special: {
  login_settings: "تنظیمات ورود",
  shop_logo_images: "لوگو و تصاویر فروشگاه",
  login_page_information: "اطلاعات صفحه ورود",
  upload_banner_logo: "آپلود بنر و لوگو",
  user_information: "اطلاعات کاربری",
  manage_products_insurance: "مدیریت محصولات/بیمه‌ها",
  special_sale: "فروش ویژه",
  add_social_media: "افزودن شبکه های اجتماعی",
  blog: "بلاگ",
  services: "خدمات",
  faq: "سوالات متداول",
  photo_gallery: "گالری عکس",
  video_gallery: "گالری ویدئو",
  pdf_gallery: "گالری پی دی اف",
  feedback: "بازخورد",
  countdown: "شمارنده معکوس",
  request_form: "فرم درخواست",
  create_section: "ایجاد بخش",
  achievements: "موفقیت های بدست آمده",
  team_members: "اعضای تیم",
  working_hours: "تایم کاری",
  shop_login_description: "تنظیمات لوگو و صفحه ورود فروشگاه",
  insurance_manage_description: "افزودن و ویرایش لیست محصولات/خدمات",
  banner_description: "مدیریت تصاویر سربرگ",
},
};
